!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.domDelegate=t()}}(function(){return function t(e,i,n){function r(o,a){if(!i[o]){if(!e[o]){var l="function"==typeof require&&require;if(!a&&l)return l(o,!0);if(s)return s(o,!0);var h=new Error("Cannot find module '"+o+"'");throw h.code="MODULE_NOT_FOUND",h}var c=i[o]={exports:{}};e[o][0].call(c.exports,function(t){var i=e[o][1][t];return r(i?i:t)},c,c.exports,t,e,i,n)}return i[o].exports}for(var s="function"==typeof require&&require,o=0;o<n.length;o++)r(n[o]);return r}({1:[function(t,e,i){"use strict";function n(t){this.listenerMap=[{},{}],t&&this.root(t),this.handle=n.prototype.handle.bind(this)}function r(t,e){return t.toLowerCase()===e.tagName.toLowerCase()}function s(t,e){return this.rootElement===window?e===document:this.rootElement===e}function o(t,e){return t===e.id}e.exports=n,n.prototype.root=function(t){var e,i=this.listenerMap;if(this.rootElement){for(e in i[1])i[1].hasOwnProperty(e)&&this.rootElement.removeEventListener(e,this.handle,!0);for(e in i[0])i[0].hasOwnProperty(e)&&this.rootElement.removeEventListener(e,this.handle,!1)}if(!t||!t.addEventListener)return this.rootElement&&delete this.rootElement,this;this.rootElement=t;for(e in i[1])i[1].hasOwnProperty(e)&&this.rootElement.addEventListener(e,this.handle,!0);for(e in i[0])i[0].hasOwnProperty(e)&&this.rootElement.addEventListener(e,this.handle,!1);return this},n.prototype.captureForType=function(t){return["blur","error","focus","load","resize","scroll"].indexOf(t)!==-1},n.prototype.on=function(t,e,i,n){var l,h,c,u;if(!t)throw new TypeError("Invalid event type: "+t);if("function"==typeof e&&(n=i,i=e,e=null),void 0===n&&(n=this.captureForType(t)),"function"!=typeof i)throw new TypeError("Handler must be a type of Function");return l=this.rootElement,h=this.listenerMap[n?1:0],h[t]||(l&&l.addEventListener(t,this.handle,n),h[t]=[]),e?/^[a-z]+$/i.test(e)?(u=e,c=r):/^#[a-z0-9\-_]+$/i.test(e)?(u=e.slice(1),c=o):(u=e,c=a):(u=null,c=s.bind(this)),h[t].push({selector:e,handler:i,matcher:c,matcherParam:u}),this},n.prototype.off=function(t,e,i,n){var r,s,o,a,l;if("function"==typeof e&&(n=i,i=e,e=null),void 0===n)return this.off(t,e,i,!0),this.off(t,e,i,!1),this;if(o=this.listenerMap[n?1:0],!t){for(l in o)o.hasOwnProperty(l)&&this.off(l,e,i);return this}if(a=o[t],!a||!a.length)return this;for(r=a.length-1;r>=0;r--)s=a[r],e&&e!==s.selector||i&&i!==s.handler||a.splice(r,1);return a.length||(delete o[t],this.rootElement&&this.rootElement.removeEventListener(t,this.handle,n)),this},n.prototype.handle=function(t){var e,i,n,r,s,o,a,l=t.type,h=[],c="ftLabsDelegateIgnore";if(t[c]!==!0){switch(a=t.target,3===a.nodeType&&(a=a.parentNode),n=this.rootElement,r=t.eventPhase||(t.target!==t.currentTarget?3:2)){case 1:h=this.listenerMap[1][l];break;case 2:this.listenerMap[0]&&this.listenerMap[0][l]&&(h=h.concat(this.listenerMap[0][l])),this.listenerMap[1]&&this.listenerMap[1][l]&&(h=h.concat(this.listenerMap[1][l]));break;case 3:h=this.listenerMap[0][l]}for(i=h.length;a&&i;){for(e=0;e<i&&(s=h[e]);e++)if(s.matcher.call(a,s.matcherParam,a)&&(o=this.fire(t,a,s)),o===!1)return t[c]=!0,void t.preventDefault();if(a===n)break;i=h.length,a=a.parentElement}}},n.prototype.fire=function(t,e,i){return i.handler.call(e,t,e)};var a=function(t){if(t){var e=t.prototype;return e.matches||e.matchesSelector||e.webkitMatchesSelector||e.mozMatchesSelector||e.msMatchesSelector||e.oMatchesSelector}}(Element);n.prototype.destroy=function(){this.off(),this.root()}},{}],2:[function(t,e,i){"use strict";var n=t("./delegate");e.exports=function(t){return new n(t)},e.exports.Delegate=n},{"./delegate":1}]},{},[2])(2)});var disableBodyScroll=function(){var t,e=!1,i=!1,n=function(t){!1!==i&&t.target.closest(e)||t.preventDefault()},r=function(e){1===e.targetTouches.length&&(t=e.targetTouches[0].clientY)},s=function(e){if(1===e.targetTouches.length){var n=e.targetTouches[0].clientY-t;0===i.scrollTop&&n>0&&e.preventDefault(),i.scrollHeight-i.scrollTop<=i.clientHeight&&n<0&&e.preventDefault()}};return function(t,o){"undefined"!=typeof o&&(e=o,i=document.querySelector(o));var a=!1;try{window.addEventListener("test",null,Object.defineProperty({},"passive",{get:function(){a=!0}}))}catch(l){}!0===t?(i&&(i.addEventListener("touchstart",r,!1),i.addEventListener("touchmove",s,!1)),document.body.addEventListener("touchmove",n,!!a&&{capture:!1,passive:!1})):(i&&(i.removeEventListener("touchstart",r,!1),i.removeEventListener("touchmove",s,!1)),document.body.removeEventListener("touchmove",n,!!a&&{capture:!1,passive:!1}))}}();!function(t){"use strict";function e(){var e=this;e.reads=[],e.writes=[],e.raf=l.bind(t),a("initialized",e)}function i(t){t.scheduled||(t.scheduled=!0,t.raf(n.bind(null,t)),a("flush scheduled"))}function n(t){a("flush");var e,n=t.writes,s=t.reads;try{a("flushing reads",s.length),r(s),a("flushing writes",n.length),r(n)}catch(o){e=o}if(t.scheduled=!1,(s.length||n.length)&&i(t),e){if(a("task errored",e.message),!t["catch"])throw e;t["catch"](e)}}function r(t){a("run tasks");for(var e;e=t.shift();)e()}function s(t,e){var i=t.indexOf(e);return!!~i&&!!t.splice(i,1)}function o(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])}var a=function(){},l=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(t){return setTimeout(t,16)};e.prototype={constructor:e,measure:function(t,e){a("measure");var n=e?t.bind(e):t;return this.reads.push(n),i(this),n},mutate:function(t,e){a("mutate");var n=e?t.bind(e):t;return this.writes.push(n),i(this),n},clear:function(t){return a("clear",t),s(this.reads,t)||s(this.writes,t)},extend:function(t){if(a("extend",t),"object"!=typeof t)throw new Error("expected object");var e=Object.create(this);return o(e,t),e.fastdom=this,e.initialize&&e.initialize(),e},"catch":null};var h=t.fastdom=t.fastdom||new e;"function"==typeof define?define(function(){return h}):"object"==typeof module&&(module.exports=h)}("undefined"!=typeof window?window:this),function(t,e){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,function(t,e){"use strict";function i(i,s,a){function l(t,e,n){var r,s="$()."+i+'("'+e+'")';return t.each(function(t,l){var h=a.data(l,i);if(!h)return void o(i+" not initialized. Cannot call methods, i.e. "+s);var c=h[e];if(!c||"_"==e.charAt(0))return void o(s+" is not a valid method");var u=c.apply(h,n);r=void 0===r?u:r}),void 0!==r?r:t}function h(t,e){t.each(function(t,n){var r=a.data(n,i);r?(r.option(e),r._init()):(r=new s(n,e),a.data(n,i,r))})}a=a||e||t.jQuery,a&&(s.prototype.option||(s.prototype.option=function(t){a.isPlainObject(t)&&(this.options=a.extend(!0,this.options,t))}),a.fn[i]=function(t){if("string"==typeof t){var e=r.call(arguments,1);return l(this,t,e)}return h(this,t),this},n(a))}function n(t){!t||t&&t.bridget||(t.bridget=i)}var r=Array.prototype.slice,s=t.console,o="undefined"==typeof s?function(){}:function(t){s.error(t)};return n(e||t.jQuery),i}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return n.indexOf(e)==-1&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return n!=-1&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],r=0;r<i.length;r++){var s=i[r],o=n&&n[s];o&&(this.off(t,s),delete n[s]),s.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("get-size/get-size",[],function(){return e()}):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function t(t){var e=parseFloat(t),i=t.indexOf("%")==-1&&!isNaN(e);return i&&e}function e(){}function i(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<h;e++){var i=l[e];t[i]=0}return t}function n(t){var e=getComputedStyle(t);return e||a("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"),e}function r(){if(!c){c=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var i=document.body||document.documentElement;i.appendChild(e);var r=n(e);s.isBoxSizeOuter=o=200==t(r.width),i.removeChild(e)}}function s(e){if(r(),"string"==typeof e&&(e=document.querySelector(e)),e&&"object"==typeof e&&e.nodeType){var s=n(e);if("none"==s.display)return i();var a={};a.width=e.offsetWidth,a.height=e.offsetHeight;for(var c=a.isBorderBox="border-box"==s.boxSizing,u=0;u<h;u++){var f=l[u],d=s[f],p=parseFloat(d);a[f]=isNaN(p)?0:p}var m=a.paddingLeft+a.paddingRight,g=a.paddingTop+a.paddingBottom,v=a.marginLeft+a.marginRight,y=a.marginTop+a.marginBottom,_=a.borderLeftWidth+a.borderRightWidth,x=a.borderTopWidth+a.borderBottomWidth,w=c&&o,b=t(s.width);b!==!1&&(a.width=b+(w?0:m+_));var T=t(s.height);return T!==!1&&(a.height=T+(w?0:g+x)),a.innerWidth=a.width-(m+_),a.innerHeight=a.height-(g+x),a.outerWidth=a.width+v,a.outerHeight=a.height+y,a}}var o,a="undefined"==typeof console?e:function(t){console.error(t)},l=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],h=l.length,c=!1;return s}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i],r=n+"MatchesSelector";if(t[r])return r}}();return function(e,i){return e[t](i)}}),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,function(t,e){var i={};i.extend=function(t,e){for(var i in e)t[i]=e[i];return t},i.modulo=function(t,e){return(t%e+e)%e},i.makeArray=function(t){var e=[];if(Array.isArray(t))e=t;else if(t&&"object"==typeof t&&"number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e},i.removeFrom=function(t,e){var i=t.indexOf(e);i!=-1&&t.splice(i,1)},i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,n){t=i.makeArray(t);var r=[];return t.forEach(function(t){if(t instanceof HTMLElement){if(!n)return void r.push(t);e(t,n)&&r.push(t);for(var i=t.querySelectorAll(n),s=0;s<i.length;s++)r.push(i[s])}}),r},i.debounceMethod=function(t,e,i){var n=t.prototype[e],r=e+"Timeout";t.prototype[e]=function(){var t=this[r];t&&clearTimeout(t);var e=arguments,s=this;this[r]=setTimeout(function(){n.apply(s,e),delete s[r]},i||100)}},i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var n=t.console;return i.htmlInit=function(e,r){i.docReady(function(){var s=i.toDashed(r),o="data-"+s,a=document.querySelectorAll("["+o+"]"),l=document.querySelectorAll(".js-"+s),h=i.makeArray(a).concat(i.makeArray(l)),c=o+"-options",u=t.jQuery;h.forEach(function(t){var i,s=t.getAttribute(o)||t.getAttribute(c);try{i=s&&JSON.parse(s)}catch(a){return void(n&&n.error("Error parsing "+o+" on "+t.className+": "+a))}var l=new e(t,i);u&&u.data(t,r,l)})})},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("get-size")):(t.Flickity=t.Flickity||{},t.Flickity.Cell=e(t,t.getSize))}(window,function(t,e){function i(t,e){this.element=t,this.parent=e,this.create()}var n=i.prototype;return n.create=function(){this.element.style.position="absolute",this.x=0,this.shift=0},n.destroy=function(){this.element.style.position="";var t=this.parent.originSide;this.element.style[t]=""},n.getSize=function(){this.size=e(this.element)},n.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},n.updateTarget=n.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},n.renderPosition=function(t){var e=this.parent.originSide;this.element.style[e]=this.parent.getPositionValue(t)},n.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},n.remove=function(){this.element.parentNode.removeChild(this.element)},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/slide",e):"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}(window,function(){"use strict";function t(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var e=t.prototype;return e.addCell=function(t){if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},e.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.changeSelectedClass("add")},e.unselect=function(){this.changeSelectedClass("remove")},e.changeSelectedClass=function(t){this.cells.forEach(function(e){e.element.classList[t]("is-selected")})},e.getCellElements=function(){return this.cells.map(function(t){return t.element})},t}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("fizzy-ui-utils")):(t.Flickity=t.Flickity||{},t.Flickity.animatePrototype=e(t,t.fizzyUIUtils))}(window,function(t,e){var i=t.requestAnimationFrame||t.webkitRequestAnimationFrame,n=0;i||(i=function(t){var e=(new Date).getTime(),i=Math.max(0,16-(e-n)),r=setTimeout(t,i);return n=e+i,r});var r={};r.startAnimation=function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},r.animate=function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;i(function(){e.animate()})}};var s=function(){var t=document.documentElement.style;return"string"==typeof t.transform?"transform":"WebkitTransform"}();return r.positionSlider=function(){var t=this.x;this.options.wrapAround&&this.cells.length>1&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),t+=this.cursorPosition,t=this.options.rightToLeft&&s?-t:t;var i=this.getPositionValue(t);this.slider.style[s]=this.isAnimating?"translate3d("+i+",0,0)":"translateX("+i+")";var n=this.slides[0];if(n){var r=-this.x-n.target,o=r/this.slidesWidth;this.dispatchEvent("scroll",null,[o,r])}},r.positionSliderAtSelected=function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.positionSlider())},r.getPositionValue=function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},r.settle=function(t){this.isPointerDown||Math.round(100*this.x)!=Math.round(100*t)||this.restingFrames++,this.restingFrames>2&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle"))},r.shiftWrapCells=function(t){var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},r._shiftCells=function(t,e,i){for(var n=0;n<t.length;n++){var r=t[n],s=e>0?i:0;r.wrapShift(s),e-=r.size.outerWidth}},r._unshiftCells=function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},r.integratePhysics=function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},r.applyForce=function(t){this.velocity+=t},r.getFrictionFactor=function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},r.getRestingPosition=function(){return this.x+this.velocity/(1-this.getFrictionFactor())},r.applyDragForce=function(){if(this.isPointerDown){var t=this.dragX-this.x,e=t-this.velocity;this.applyForce(e)}},r.applySelectedAttraction=function(){if(!this.isPointerDown&&!this.isFreeScrolling&&this.cells.length){var t=this.selectedSlide.target*-1-this.x,e=t*this.options.selectedAttraction;this.applyForce(e)}},r}),function(t,e){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],function(i,n,r,s,o,a){return e(t,i,n,r,s,o,a)});else if("object"==typeof module&&module.exports)module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var i=t.Flickity;t.Flickity=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,i.Cell,i.Slide,i.animatePrototype)}}(window,function(t,e,i,n,r,s,o){function a(t,e){for(t=n.makeArray(t);t.length;)e.appendChild(t.shift())}function l(t,e){var i=n.getQueryElement(t);if(!i)return void(u&&u.error("Bad element for Flickity: "+(i||t)));if(this.element=i,this.element.flickityGUID){var r=d[this.element.flickityGUID];return r.option(e),r}h&&(this.$element=h(this.element)),this.options=n.extend({},this.constructor.defaults),this.option(e),this._create()}var h=t.jQuery,c=t.getComputedStyle,u=t.console,f=0,d={};l.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},l.createMethods=[];var p=l.prototype;n.extend(p,e.prototype),p._create=function(){var e=this.guid=++f;this.element.flickityGUID=e,d[e]=this,this.selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&t.addEventListener("resize",this),l.createMethods.forEach(function(t){this[t]()},this),this.options.watchCSS?this.watchCSS():this.activate()},p.option=function(t){n.extend(this.options,t)},p.activate=function(){if(!this.isActive){this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize();var t=this._filterFindCellElements(this.element.children);a(t,this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate");var e,i=this.options.initialIndex;e=this.isInitActivated?this.selectedIndex:void 0!==i&&this.cells[i]?i:0,this.select(e,!1,!0),this.isInitActivated=!0}},p._createSlider=function(){var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},p._filterFindCellElements=function(t){return n.filterFindElements(t,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},p._makeCells=function(t){var e=this._filterFindCellElements(t),i=e.map(function(t){return new r(t,this)},this);return i},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(t){t=t||0,this.maxCellHeight=t?this.maxCellHeight||0:0;var e=0;if(t>0){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,r=t;r<n;r++){var s=this.cells[r];s.setPosition(e),e+=s.size.outerWidth,this.maxCellHeight=Math.max(s.size.outerHeight,this.maxCellHeight)}this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},p._sizeCells=function(t){t.forEach(function(t){t.getSize()})},p.updateSlides=function(){if(this.slides=[],this.cells.length){var t=new s(this);this.slides.push(t);var e="left"==this.originSide,i=e?"marginRight":"marginLeft",n=this._getCanCellFit();this.cells.forEach(function(e,r){if(!t.cells.length)return void t.addCell(e);var o=t.outerWidth-t.firstMargin+(e.size.outerWidth-e.size[i]);n.call(this,r,o)?t.addCell(e):(t.updateTarget(),t=new s(this),this.slides.push(t),t.addCell(e))},this),t.updateTarget(),this.updateSelectedSlide()}},p._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};if("number"==typeof t){var e=parseInt(t,10);return function(t){return t%e!==0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){return e<=(this.size.innerWidth+1)*n}},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=i(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var m={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return p.setCellAlign=function(){var t=m[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},p.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},p._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),t=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(t,0,1)}},p._getGapCells=function(t,e,i){for(var n=[];t>0;){var r=this.cells[e];if(!r)break;n.push(r),e+=i,t-=r.size.outerWidth}return n},p._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],r=n<this.size.innerWidth,s=this.cursorPosition+this.cells[0].size[e],o=n-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(function(t){r?t.target=n*this.cellAlign:(t.target=Math.max(t.target,s),t.target=Math.min(t.target,o))},this)}},p.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),h&&this.$element){t+=this.options.namespaceJQueryEvents?".flickity":"";var r=t;if(e){var s=h.Event(e);s.type=t,r=s}this.$element.trigger(r,i)}},p.select=function(t,e,i){this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=n.modulo(t,this.slides.length)),this.slides[t]&&(this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select"),this.dispatchEvent("cellSelect")))},p._wrapSelect=function(t){var e=this.slides.length,i=this.options.wrapAround&&e>1;if(!i)return t;var r=n.modulo(t,e),s=Math.abs(r-this.selectedIndex),o=Math.abs(r+e-this.selectedIndex),a=Math.abs(r-e-this.selectedIndex);!this.isDragSelect&&o<s?t+=e:!this.isDragSelect&&a<s&&(t-=e),t<0?this.x-=this.slideableWidth:t>=e&&(this.x+=this.slideableWidth)},p.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},p.next=function(t,e){this.select(this.selectedIndex+1,t,e)},p.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),this.selectedSlide=t,t.select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectCell=function(t,e,i){var n;"number"==typeof t?n=this.cells[t]:("string"==typeof t&&(t=this.element.querySelector(t)),n=this.getCell(t));for(var r=0;n&&r<this.slides.length;r++){var s=this.slides[r],o=s.cells.indexOf(n);if(o!=-1)return void this.select(r,e,i)}},p.getCell=function(t){for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},p.getCells=function(t){t=n.makeArray(t);var e=[];return t.forEach(function(t){var i=this.getCell(t);i&&e.push(i)},this),e},p.getCellElements=function(){return this.cells.map(function(t){return t.element})},p.getParentCell=function(t){var e=this.getCell(t);return e?e:(t=n.getParent(t,".flickity-slider > *"),this.getCell(t))},p.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(1+2*t>=i)return this.getCellElements();for(var r=[],s=e-t;s<=e+t;s++){var o=this.options.wrapAround?n.modulo(s,i):s,a=this.slides[o];a&&(r=r.concat(a.getCellElements()))}return r},p.uiChange=function(){this.emitEvent("uiChange")},p.childUIPointerDown=function(t){this.emitEvent("childUIPointerDown",[t])},p.onresize=function(){this.watchCSS(),this.resize()},n.debounceMethod(l,"onresize",150),p.resize=function(){if(this.isActive){this.getSize(),this.options.wrapAround&&(this.x=n.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},p.watchCSS=function(){var t=this.options.watchCSS;if(t){var e=c(this.element,":after").content;e.indexOf("flickity")!=-1?this.activate():this.deactivate()}},p.onkeydown=function(t){if(this.options.accessibility&&(!document.activeElement||document.activeElement==this.element))if(37==t.keyCode){var e=this.options.rightToLeft?"next":"previous";this.uiChange(),this[e]()}else if(39==t.keyCode){var i=this.options.rightToLeft?"previous":"next";this.uiChange(),this[i]()}},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.cells.forEach(function(t){t.destroy()}),this.unselectSelectedSlide(),this.element.removeChild(this.viewport),a(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),t.removeEventListener("resize",this),this.emitEvent("destroy"),h&&this.$element&&h.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete d[this.guid]},n.extend(p,o),l.data=function(t){t=n.getQueryElement(t);var e=t&&t.flickityGUID;return e&&d[e]},n.htmlInit(l,"flickity"),h&&h.bridget&&h.bridget("flickity",l),l.setJQuery=function(t){h=t},l.Cell=r,l}),function(t,e){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.Unipointer=e(t,t.EvEmitter)}(window,function(t,e){function i(){}function n(){}var r=n.prototype=Object.create(e.prototype);r.bindStartEvent=function(t){this._bindStartEvent(t,!0)},r.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},r._bindStartEvent=function(e,i){i=void 0===i||!!i;var n=i?"addEventListener":"removeEventListener";t.PointerEvent?e[n]("pointerdown",this):(e[n]("mousedown",this),e[n]("touchstart",this))},r.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},r.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},r.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},r.onpointerdown=function(t){this._pointerDown(t,t)},r._pointerDown=function(t,e){this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},r.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var s={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return r._bindPostStartEvents=function(e){if(e){var i=s[e.type];i.forEach(function(e){t.addEventListener(e,this)},this),this._boundPointerEvents=i}},r._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach(function(e){t.removeEventListener(e,this)},this),delete this._boundPointerEvents)},r.onmousemove=function(t){this._pointerMove(t,t)},r.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},r.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},r._pointerMove=function(t,e){this.pointerMove(t,e)},r.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},r.onmouseup=function(t){this._pointerUp(t,t)},r.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},r.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},r._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},r.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},r._pointerDone=function(){this.isPointerDown=!1,delete this.pointerIdentifier,this._unbindPostStartEvents(),this.pointerDone()},r.pointerDone=i,r.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},r.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},r._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},r.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},n.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},n}),function(t,e){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("unipointer")):t.Unidragger=e(t,t.Unipointer)}(window,function(t,e){function i(){}var n=i.prototype=Object.create(e.prototype);return n.bindHandles=function(){this._bindHandles(!0)},n.unbindHandles=function(){this._bindHandles(!1)},n._bindHandles=function(e){e=void 0===e||!!e;for(var i=e?"addEventListener":"removeEventListener",n=0;n<this.handles.length;n++){
var r=this.handles[n];this._bindStartEvent(r,e),r[i]("click",this),t.PointerEvent&&(r.style.touchAction=e?this._touchActionValue:"")}},n._touchActionValue="none",n.pointerDown=function(t,e){if("INPUT"==t.target.nodeName&&"range"==t.target.type)return this.isPointerDown=!1,void delete this.pointerIdentifier;this._dragPointerDown(t,e);var i=document.activeElement;i&&i.blur&&i.blur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])},n._dragPointerDown=function(t,i){this.pointerDownPoint=e.getPointerPoint(i);var n=this.canPreventDefaultOnPointerDown(t,i);n&&t.preventDefault()},n.canPreventDefaultOnPointerDown=function(t){return"SELECT"!=t.target.nodeName},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},n._dragPointerMove=function(t,i){var n=e.getPointerPoint(i),r={x:n.x-this.pointerDownPoint.x,y:n.y-this.pointerDownPoint.y};return!this.isDragging&&this.hasDragStarted(r)&&this._dragStart(t,i),r},n.hasDragStarted=function(t){return Math.abs(t.x)>3||Math.abs(t.y)>3},n.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},n._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},n._dragStart=function(t,i){this.isDragging=!0,this.dragStartPoint=e.getPointerPoint(i),this.isPreventingClicks=!0,this.dragStart(t,i)},n.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},n._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},n.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},n._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},n.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},n.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},n._staticClick=function(t,e){if(!this.isIgnoringMouseUp||"mouseup"!=t.type){var i=t.target.nodeName;"INPUT"!=i&&"TEXTAREA"!=i||t.target.focus(),this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400))}},n.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},i.getPointerPoint=e.getPointerPoint,i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],function(i,n,r){return e(t,i,n,r)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):t.Flickity=e(t,t.Flickity,t.Unidragger,t.fizzyUIUtils)}(window,function(t,e,i,n){function r(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=u[t.target.nodeName];return e||i||n}function s(){return{x:t.pageXOffset,y:t.pageYOffset}}n.extend(e.defaults,{draggable:!0,dragThreshold:3}),e.createMethods.push("_createDrag");var o=e.prototype;n.extend(o,i.prototype),o._touchActionValue="pan-y";var a="createTouch"in document,l=!1;o._createDrag=function(){this.on("activate",this.bindDrag),this.on("uiChange",this._uiChangeDrag),this.on("childUIPointerDown",this._childUIPointerDownDrag),this.on("deactivate",this.unbindDrag),a&&!l&&(t.addEventListener("touchmove",function(){}),l=!0)},o.bindDrag=function(){this.options.draggable&&!this.isDragBound&&(this.element.classList.add("is-draggable"),this.handles=[this.viewport],this.bindHandles(),this.isDragBound=!0)},o.unbindDrag=function(){this.isDragBound&&(this.element.classList.remove("is-draggable"),this.unbindHandles(),delete this.isDragBound)},o._uiChangeDrag=function(){delete this.isFreeScrolling},o._childUIPointerDownDrag=function(t){t.preventDefault(),this.pointerDownFocus(t)};var h={TEXTAREA:!0,INPUT:!0,OPTION:!0},c={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};o.pointerDown=function(e,i){var n=h[e.target.nodeName]&&!c[e.target.type];if(n)return this.isPointerDown=!1,void delete this.pointerIdentifier;this._dragPointerDown(e,i);var r=document.activeElement;r&&r.blur&&r!=this.element&&r!=document.body&&r.blur(),this.pointerDownFocus(e),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this._bindPostStartEvents(e),this.pointerDownScroll=s(),t.addEventListener("scroll",this),this.dispatchEvent("pointerDown",e,[i])},o.pointerDownFocus=function(e){var i=r(e);if(this.options.accessibility&&!i){var n=t.pageYOffset;this.element.focus(),t.pageYOffset!=n&&t.scrollTo(t.pageXOffset,n)}};var u={INPUT:!0,SELECT:!0};return o.canPreventDefaultOnPointerDown=function(t){var e=r(t);return!e},o.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},o.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},o.pointerDone=function(){t.removeEventListener("scroll",this),delete this.pointerDownScroll},o.dragStart=function(e,i){this.dragStartPosition=this.x,this.startAnimation(),t.removeEventListener("scroll",this),this.dispatchEvent("dragStart",e,[i])},o.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},o.dragMove=function(t,e,i){t.preventDefault(),this.previousDragX=this.dragX;var n=this.options.rightToLeft?-1:1,r=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){var s=Math.max(-this.slides[0].target,this.dragStartPosition);r=r>s?.5*(r+s):r;var o=Math.min(-this.getLastSlide().target,this.dragStartPosition);r=r<o?.5*(r+o):r}this.dragX=r,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])},o.dragEnd=function(t,e){this.options.freeScroll&&(this.isFreeScrolling=!0);var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(i+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])},o.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1),r=i.distance<n.distance?i.index:n.index;return r},o._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,r=1/0,s=this.options.contain&&!this.options.wrapAround?function(t,e){return t<=e}:function(t,e){return t<e};s(e,r)&&(n+=i,r=e,e=this.getSlideDistance(-t,n),null!==e);)e=Math.abs(e);return{distance:r,index:n-i}},o.getSlideDistance=function(t,e){var i=this.slides.length,r=this.options.wrapAround&&i>1,s=r?n.modulo(e,i):e,o=this.slides[s];if(!o)return null;var a=r?this.slideableWidth*Math.floor(e/i):0;return t-(o.target+a)},o.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||new Date-this.dragMoveTime>100)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return t>0&&e>0?1:t<0&&e<0?-1:0},o.staticClick=function(t,e){var i=this.getParentCell(t.target),n=i&&i.element,r=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,r])},o.onscroll=function(){var t=s(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(Math.abs(e)>3||Math.abs(i)>3)&&this._pointerDone()},e}),function(t,e){"function"==typeof define&&define.amd?define("tap-listener/tap-listener",["unipointer/unipointer"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("unipointer")):t.TapListener=e(t,t.Unipointer)}(window,function(t,e){function i(t){this.bindTap(t)}var n=i.prototype=Object.create(e.prototype);return n.bindTap=function(t){t&&(this.unbindTap(),this.tapElement=t,this._bindStartEvent(t,!0))},n.unbindTap=function(){this.tapElement&&(this._bindStartEvent(this.tapElement,!0),delete this.tapElement)},n.pointerUp=function(i,n){if(!this.isIgnoringMouseUp||"mouseup"!=i.type){var r=e.getPointerPoint(n),s=this.tapElement.getBoundingClientRect(),o=t.pageXOffset,a=t.pageYOffset,l=r.x>=s.left+o&&r.x<=s.right+o&&r.y>=s.top+a&&r.y<=s.bottom+a;if(l&&this.emitEvent("tap",[i,n]),"mouseup"!=i.type){this.isIgnoringMouseUp=!0;var h=this;setTimeout(function(){delete h.isIgnoringMouseUp},400)}}},n.destroy=function(){this.pointerDone(),this.unbindTap()},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","tap-listener/tap-listener","fizzy-ui-utils/utils"],function(i,n,r){return e(t,i,n,r)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("tap-listener"),require("fizzy-ui-utils")):e(t,t.Flickity,t.TapListener,t.fizzyUIUtils)}(window,function(t,e,i,n){"use strict";function r(t,e){this.direction=t,this.parent=e,this._create()}function s(t){return"string"==typeof t?t:"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z"}var o="http://www.w3.org/2000/svg";r.prototype=new i,r.prototype._create=function(){this.isEnabled=!0,this.isPrevious=this.direction==-1;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"previous":"next");var i=this.createSVG();e.appendChild(i),this.on("tap",this.onTap),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},r.prototype.activate=function(){this.bindTap(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},r.prototype.deactivate=function(){this.parent.element.removeChild(this.element),i.prototype.destroy.call(this),this.element.removeEventListener("click",this)},r.prototype.createSVG=function(){var t=document.createElementNS(o,"svg");t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(o,"path"),i=s(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},r.prototype.onTap=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},r.prototype.handleEvent=n.handleEvent,r.prototype.onclick=function(){var t=document.activeElement;t&&t==this.element&&this.onTap()},r.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},r.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},r.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&t.length>1)return void this.enable();var e=t.length?t.length-1:0,i=this.isPrevious?0:e,n=this.parent.selectedIndex==i?"disable":"enable";this[n]()},r.prototype.destroy=function(){this.deactivate()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var a=e.prototype;return a._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new r((-1),this),this.nextButton=new r(1,this),this.on("activate",this.activatePrevNextButtons))},a.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},a.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=r,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","tap-listener/tap-listener","fizzy-ui-utils/utils"],function(i,n,r){return e(t,i,n,r)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("tap-listener"),require("fizzy-ui-utils")):e(t,t.Flickity,t.TapListener,t.fizzyUIUtils)}(window,function(t,e,i,n){function r(t){this.parent=t,this._create()}r.prototype=new i,r.prototype._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.on("tap",this.onTap),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},r.prototype.activate=function(){this.setDots(),this.bindTap(this.holder),this.parent.element.appendChild(this.holder)},r.prototype.deactivate=function(){this.parent.element.removeChild(this.holder),i.prototype.destroy.call(this)},r.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;t>0?this.addDots(t):t<0&&this.removeDots(-t)},r.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[];t;){var n=document.createElement("li");n.className="dot",e.appendChild(n),i.push(n),t--}this.holder.appendChild(e),this.dots=this.dots.concat(i)},r.prototype.removeDots=function(t){var e=this.dots.splice(this.dots.length-t,t);e.forEach(function(t){this.holder.removeChild(t)},this)},r.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot"),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected")},r.prototype.onTap=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},r.prototype.destroy=function(){this.deactivate()},e.PageDots=r,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var s=e.prototype;return s._createPageDots=function(){this.options.pageDots&&(this.pageDots=new r(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},s.activatePageDots=function(){this.pageDots.activate()},s.updateSelectedPageDots=function(){this.pageDots.updateSelected()},s.updatePageDots=function(){this.pageDots.setDots()},s.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=r,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],function(t,i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):e(t.EvEmitter,t.fizzyUIUtils,t.Flickity)}(window,function(t,e,i){function n(t){this.parent=t,this.state="stopped",s&&(this.onVisibilityChange=function(){this.visibilityChange()}.bind(this),this.onVisibilityPlay=function(){this.visibilityPlay()}.bind(this))}var r,s;"hidden"in document?(r="hidden",s="visibilitychange"):"webkitHidden"in document&&(r="webkitHidden",s="webkitvisibilitychange"),n.prototype=Object.create(t.prototype),n.prototype.play=function(){if("playing"!=this.state){var t=document[r];if(s&&t)return void document.addEventListener(s,this.onVisibilityPlay);this.state="playing",s&&document.addEventListener(s,this.onVisibilityChange),this.tick()}},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout(function(){e.parent.next(!0),e.tick()},t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),s&&document.removeEventListener(s,this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){var t=document[r];this[t?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener(s,this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var o=i.prototype;return o._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},o.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},o.playPlayer=function(){this.player.play()},o.stopPlayer=function(){this.player.stop()},o.pausePlayer=function(){this.player.pause()},o.unpausePlayer=function(){this.player.unpause()},o.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},o.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},o.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("fizzy-ui-utils")):e(t,t.Flickity,t.fizzyUIUtils)}(window,function(t,e,i){function n(t){var e=document.createDocumentFragment();return t.forEach(function(t){e.appendChild(t.element)}),e}var r=e.prototype;return r.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var r=this.cells.length;e=void 0===e?r:e;var s=n(i),o=e==r;if(o)this.slider.appendChild(s);else{var a=this.cells[e].element;this.slider.insertBefore(s,a)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{var l=this.cells.splice(e,r-e);this.cells=this.cells.concat(i).concat(l)}this._sizeCells(i);var h=e>this.selectedIndex?0:i.length;this._cellAddedRemoved(e,h)}},r.append=function(t){this.insert(t,this.cells.length)},r.prepend=function(t){this.insert(t,0)},r.remove=function(t){var e,n,r=this.getCells(t),s=0,o=r.length;for(e=0;e<o;e++){n=r[e];var a=this.cells.indexOf(n)<this.selectedIndex;s-=a?1:0}for(e=0;e<o;e++)n=r[e],n.remove(),i.removeFrom(this.cells,n);r.length&&this._cellAddedRemoved(0,s)},r._cellAddedRemoved=function(t,e){e=e||0,this.selectedIndex+=e,this.selectedIndex=Math.max(0,Math.min(this.slides.length-1,this.selectedIndex)),this.cellChange(t,!0),this.emitEvent("cellAddedRemoved",[t,e])},r.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},r.cellChange=function(t,e){var i=this.slideableWidth;if(this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("cellChange",[t]),this.options.freeScroll){var n=i-this.slideableWidth;this.x+=n*this.cellAlign,this.positionSlider()}else e&&this.positionSliderAtSelected(),this.select(this.selectedIndex)},e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/lazyload",["./flickity","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("fizzy-ui-utils")):e(t,t.Flickity,t.fizzyUIUtils)}(window,function(t,e,i){"use strict";function n(t){if("IMG"==t.nodeName&&t.getAttribute("data-flickity-lazyload"))return[t];var e=t.querySelectorAll("img[data-flickity-lazyload]");return i.makeArray(e)}function r(t,e){this.img=t,this.flickity=e,this.load()}e.createMethods.push("_createLazyload");var s=e.prototype;return s._createLazyload=function(){this.on("select",this.lazyLoad)},s.lazyLoad=function(){var t=this.options.lazyLoad;if(t){var e="number"==typeof t?t:0,i=this.getAdjacentCellElements(e),s=[];i.forEach(function(t){var e=n(t);s=s.concat(e)}),s.forEach(function(t){new r(t,this)},this)}},r.prototype.handleEvent=i.handleEvent,r.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.img.getAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload")},r.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},r.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},r.prototype.complete=function(t,e){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},e.LazyLoader=r,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell","./lazyload"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell"),require("./lazyload")))}(window,function(t){return t}),function(t,e){"function"==typeof define&&define.amd?define("flickity-as-nav-for/as-nav-for",["flickity/js/index","fizzy-ui-utils/utils"],e):"object"==typeof module&&module.exports?module.exports=e(require("flickity"),require("fizzy-ui-utils")):t.Flickity=e(t.Flickity,t.fizzyUIUtils)}(window,function(t,e){function i(t,e,i){return(e-t)*i+t}t.createMethods.push("_createAsNavFor");var n=t.prototype;return n._createAsNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);var t=this.options.asNavFor;if(t){var e=this;setTimeout(function(){e.setNavCompanion(t)})}},n.setNavCompanion=function(i){i=e.getQueryElement(i);var n=t.data(i);if(n&&n!=this){this.navCompanion=n;var r=this;this.onNavCompanionSelect=function(){r.navCompanionSelect()},n.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0)}},n.navCompanionSelect=function(t){if(this.navCompanion){var e=this.navCompanion.selectedCells[0],n=this.navCompanion.cells.indexOf(e),r=n+this.navCompanion.selectedCells.length-1,s=Math.floor(i(n,r,this.navCompanion.cellAlign));if(this.selectCell(s,!1,t),this.removeNavSelectedElements(),!(s>=this.cells.length)){var o=this.cells.slice(n,r+1);this.navSelectedElements=o.map(function(t){return t.element}),this.changeNavSelectedClass("add")}}},n.changeNavSelectedClass=function(t){this.navSelectedElements.forEach(function(e){e.classList[t]("is-nav-selected")})},n.activateAsNavFor=function(){this.navCompanionSelect(!0)},n.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},n.onNavStaticClick=function(t,e,i,n){"number"==typeof n&&this.navCompanion.selectCell(n)},n.deactivateAsNavFor=function(){this.removeNavSelectedElements()},n.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},t}),function(t,e){"function"==typeof define&&define.amd?define(e):"object"==typeof exports?module.exports=e():t.PhotoSwipe=e()}(this,function(){"use strict";var t=function(t,e,i,n){var r={features:null,bind:function(t,e,i,n){var r=(n?"remove":"add")+"EventListener";e=e.split(" ");for(var s=0;s<e.length;s++)e[s]&&t[r](e[s],i,!1)},isArray:function(t){return t instanceof Array},createEl:function(t,e){var i=document.createElement(e||"div");return t&&(i.className=t),i},getScrollY:function(){var t=window.pageYOffset;return void 0!==t?t:document.documentElement.scrollTop},unbind:function(t,e,i){r.bind(t,e,i,!0)},removeClass:function(t,e){var i=new RegExp("(\\s|^)"+e+"(\\s|$)");t.className=t.className.replace(i," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")},addClass:function(t,e){r.hasClass(t,e)||(t.className+=(t.className?" ":"")+e)},hasClass:function(t,e){return t.className&&new RegExp("(^|\\s)"+e+"(\\s|$)").test(t.className)},getChildByClass:function(t,e){for(var i=t.firstChild;i;){if(r.hasClass(i,e))return i;i=i.nextSibling}},arraySearch:function(t,e,i){for(var n=t.length;n--;)if(t[n][i]===e)return n;return-1},extend:function(t,e,i){for(var n in e)if(e.hasOwnProperty(n)){if(i&&t.hasOwnProperty(n))continue;t[n]=e[n]}},easing:{sine:{out:function(t){return Math.sin(t*(Math.PI/2))},inOut:function(t){return-(Math.cos(Math.PI*t)-1)/2}},cubic:{out:function(t){return--t*t*t+1}}},detectFeatures:function(){if(r.features)return r.features;var t=r.createEl(),e=t.style,i="",n={};if(n.oldIE=document.all&&!document.addEventListener,n.touch="ontouchstart"in window,window.requestAnimationFrame&&(n.raf=window.requestAnimationFrame,n.caf=window.cancelAnimationFrame),n.pointerEvent=navigator.pointerEnabled||navigator.msPointerEnabled,!n.pointerEvent){var s=navigator.userAgent;if(/iP(hone|od)/.test(navigator.platform)){var o=navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);o&&o.length>0&&(o=parseInt(o[1],10),o>=1&&o<8&&(n.isOldIOSPhone=!0))}var a=s.match(/Android\s([0-9\.]*)/),l=a?a[1]:0;l=parseFloat(l),l>=1&&(l<4.4&&(n.isOldAndroid=!0),n.androidVersion=l),n.isMobileOpera=/opera mini|opera mobi/i.test(s)}for(var h,c,u=["transform","perspective","animationName"],f=["","webkit","Moz","ms","O"],d=0;d<4;d++){i=f[d];for(var p=0;p<3;p++)h=u[p],c=i+(i?h.charAt(0).toUpperCase()+h.slice(1):h),!n[h]&&c in e&&(n[h]=c);i&&!n.raf&&(i=i.toLowerCase(),n.raf=window[i+"RequestAnimationFrame"],n.raf&&(n.caf=window[i+"CancelAnimationFrame"]||window[i+"CancelRequestAnimationFrame"]))}if(!n.raf){var m=0;n.raf=function(t){var e=(new Date).getTime(),i=Math.max(0,16-(e-m)),n=window.setTimeout(function(){t(e+i)},i);return m=e+i,n},n.caf=function(t){clearTimeout(t)}}return n.svg=!!document.createElementNS&&!!document.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,r.features=n,n}};r.detectFeatures(),r.features.oldIE&&(r.bind=function(t,e,i,n){e=e.split(" ");for(var r,s=(n?"detach":"attach")+"Event",o=function(){i.handleEvent.call(i)},a=0;a<e.length;a++)if(r=e[a])if("object"==typeof i&&i.handleEvent){if(n){if(!i["oldIE"+r])return!1}else i["oldIE"+r]=o;t[s]("on"+r,i["oldIE"+r])}else t[s]("on"+r,i)});var s=this,o=25,a=3,l={allowPanToNext:!0,spacing:.12,bgOpacity:1,mouseUsed:!1,loop:!0,pinchToClose:!0,closeOnScroll:!0,closeOnVerticalDrag:!0,verticalDragRange:.75,hideAnimationDuration:333,showAnimationDuration:333,showHideOpacity:!1,focus:!0,escKey:!0,arrowKeys:!0,mainScrollEndFriction:.35,panEndFriction:.35,isClickableElement:function(t){return"A"===t.tagName},getDoubleTapZoom:function(t,e){return t?1:e.initialZoomLevel<.7?1:1.33},maxSpreadZoom:1.33,modal:!0,scaleMode:"fit"};r.extend(l,n);var h,c,u,f,d,p,m,g,v,y,_,x,w,b,T,S,P,C,k,E,O,A,D,M,z,L,R,I,F,N,X,j,B,U,W,Y,q,H,Z,V,G,Q,$,K,J,tt,et,it,nt,rt,st,ot,at,lt,ht,ct,ut,ft=function(){return{x:0,y:0}},dt=ft(),pt=ft(),mt=ft(),gt={},vt=0,yt={},_t=ft(),xt=0,wt=!0,bt=[],Tt={},St=!1,Pt=function(t,e){r.extend(s,e.publicMethods),bt.push(t)},Ct=function(t){var e=ti();return t>e-1?t-e:t<0?e+t:t},kt={},Et=function(t,e){return kt[t]||(kt[t]=[]),kt[t].push(e)},Ot=function(t){var e=kt[t];if(e){var i=Array.prototype.slice.call(arguments);i.shift();for(var n=0;n<e.length;n++)e[n].apply(s,i)}},At=function(){return(new Date).getTime()},Dt=function(t){ht=t,s.bg.style.opacity=t*l.bgOpacity},Mt=function(t,e,i,n,r){(!St||r&&r!==s.currItem)&&(n/=r?r.fitRatio:s.currItem.fitRatio),t[A]=x+e+"px, "+i+"px"+w+" scale("+n+")"},zt=function(t){rt&&(t&&(y>s.currItem.fitRatio?St||(fi(s.currItem,!1,!0),St=!0):St&&(fi(s.currItem),St=!1)),Mt(rt,mt.x,mt.y,y))},Lt=function(t){t.container&&Mt(t.container.style,t.initialPosition.x,t.initialPosition.y,t.initialZoomLevel,t)},Rt=function(t,e){e[A]=x+t+"px, 0px"+w},It=function(t,e){if(!l.loop&&e){var i=f+(_t.x*vt-t)/_t.x,n=Math.round(t-_e.x);(i<0&&n>0||i>=ti()-1&&n<0)&&(t=_e.x+n*l.mainScrollEndFriction)}_e.x=t,Rt(t,d)},Ft=function(t,e){var i=xe[t]-yt[t];return pt[t]+dt[t]+i-i*(e/_)},Nt=function(t,e){t.x=e.x,t.y=e.y,e.id&&(t.id=e.id)},Xt=function(t){t.x=Math.round(t.x),t.y=Math.round(t.y)},jt=null,Bt=function(){jt&&(r.unbind(document,"mousemove",Bt),r.addClass(t,"pswp--has_mouse"),l.mouseUsed=!0,Ot("mouseUsed")),jt=setTimeout(function(){jt=null},100)},Ut=function(){r.bind(document,"keydown",s),X.transform&&r.bind(s.scrollWrap,"click",s),l.mouseUsed||r.bind(document,"mousemove",Bt),r.bind(window,"resize scroll orientationchange",s),Ot("bindEvents")},Wt=function(){r.unbind(window,"resize scroll orientationchange",s),r.unbind(window,"scroll",v.scroll),r.unbind(document,"keydown",s),r.unbind(document,"mousemove",Bt),X.transform&&r.unbind(s.scrollWrap,"click",s),Z&&r.unbind(window,m,s),clearTimeout(j),Ot("unbindEvents")},Yt=function(t,e){var i=li(s.currItem,gt,t);return e&&(nt=i),i},qt=function(t){return t||(t=s.currItem),t.fitRatio},Ht=function(t){return t||(t=s.currItem),t.w>0?l.maxSpreadZoom:1},Zt=function(t,e,i,n){return n===s.currItem.initialZoomLevel?(i[t]=s.currItem.initialPosition[t],!0):(i[t]=Ft(t,n),i[t]>e.min[t]?(i[t]=e.min[t],!0):i[t]<e.max[t]&&(i[t]=e.max[t],!0))},Vt=function(){if(A){var e=X.perspective&&!M;return x="translate"+(e?"3d(":"("),void(w=X.perspective?", 0px)":")")}A="left",r.addClass(t,"pswp--ie"),Rt=function(t,e){e.left=t+"px"},Lt=function(t){var e=t.fitRatio>1?1:t.fitRatio,i=t.container.style,n=e*t.w,r=e*t.h;i.width=n+"px",i.height=r+"px",i.left=t.initialPosition.x+"px",i.top=t.initialPosition.y+"px"},zt=function(){if(rt){var t=rt,e=s.currItem,i=e.fitRatio>1?1:e.fitRatio,n=i*e.w,r=i*e.h;t.width=n+"px",t.height=r+"px",t.left=mt.x+"px",t.top=mt.y+"px"}}},Gt=function(t){var e="";l.escKey&&27===t.keyCode?e="close":l.arrowKeys&&(37===t.keyCode?e="prev":39===t.keyCode&&(e="next")),e&&(t.ctrlKey||t.altKey||t.shiftKey||t.metaKey||(t.preventDefault?t.preventDefault():t.returnValue=!1,s[e]()))},Qt=function(t){t&&(Q||G||st||q)&&(t.preventDefault(),t.stopPropagation())},$t=function(){s.setScrollOffset(0,r.getScrollY())},Kt={},Jt=0,te=function(t){Kt[t]&&(Kt[t].raf&&L(Kt[t].raf),Jt--,delete Kt[t])},ee=function(t){Kt[t]&&te(t),Kt[t]||(Jt++,Kt[t]={})},ie=function(){for(var t in Kt)Kt.hasOwnProperty(t)&&te(t)},ne=function(t,e,i,n,r,s,o){var a,l=At();ee(t);var h=function(){if(Kt[t]){if(a=At()-l,a>=n)return te(t),s(i),void(o&&o());s((i-e)*r(a/n)+e),Kt[t].raf=z(h)}};h()},re={shout:Ot,listen:Et,viewportSize:gt,options:l,isMainScrollAnimating:function(){return st},getZoomLevel:function(){return y},getCurrentIndex:function(){return f},isDragging:function(){return Z},isZooming:function(){return tt},setScrollOffset:function(t,e){yt.x=t,N=yt.y=e,Ot("updateScrollOffset",yt)},applyZoomPan:function(t,e,i,n){mt.x=e,mt.y=i,y=t,zt(n)},init:function(){if(!h&&!c){var i;s.framework=r,s.template=t,s.bg=r.getChildByClass(t,"pswp__bg"),R=t.className,h=!0,X=r.detectFeatures(),z=X.raf,L=X.caf,A=X.transform,F=X.oldIE,s.scrollWrap=r.getChildByClass(t,"pswp__scroll-wrap"),s.container=r.getChildByClass(s.scrollWrap,"pswp__container"),d=s.container.style,s.itemHolders=S=[{el:s.container.children[0],wrap:0,index:-1},{el:s.container.children[1],wrap:0,index:-1},{el:s.container.children[2],wrap:0,index:-1}],S[0].el.style.display=S[2].el.style.display="none",Vt(),v={resize:s.updateSize,orientationchange:function(){clearTimeout(j),j=setTimeout(function(){gt.x!==s.scrollWrap.clientWidth&&s.updateSize()},500)},scroll:$t,keydown:Gt,click:Qt};var n=X.isOldIOSPhone||X.isOldAndroid||X.isMobileOpera;for(X.animationName&&X.transform&&!n||(l.showAnimationDuration=l.hideAnimationDuration=0),i=0;i<bt.length;i++)s["init"+bt[i]]();if(e){var o=s.ui=new e(s,r);o.init()}Ot("firstUpdate"),f=f||l.index||0,(isNaN(f)||f<0||f>=ti())&&(f=0),s.currItem=Je(f),(X.isOldIOSPhone||X.isOldAndroid)&&(wt=!1),t.setAttribute("aria-hidden","false"),l.modal&&(wt?t.style.position="fixed":(t.style.position="absolute",t.style.top=r.getScrollY()+"px")),void 0===N&&(Ot("initialLayout"),N=I=r.getScrollY());var u="pswp--open ";for(l.mainClass&&(u+=l.mainClass+" "),l.showHideOpacity&&(u+="pswp--animate_opacity "),u+=M?"pswp--touch":"pswp--notouch",u+=X.animationName?" pswp--css_animation":"",u+=X.svg?" pswp--svg":"",r.addClass(t,u),s.updateSize(),p=-1,xt=null,i=0;i<a;i++)Rt((i+p)*_t.x,S[i].el.style);F||r.bind(s.scrollWrap,g,s),Et("initialZoomInEnd",function(){
s.setContent(S[0],f-1),s.setContent(S[2],f+1),S[0].el.style.display=S[2].el.style.display="block",l.focus&&t.focus(),Ut()}),s.setContent(S[1],f),s.updateCurrItem(),Ot("afterInit"),wt||(b=setInterval(function(){Jt||Z||tt||y!==s.currItem.initialZoomLevel||s.updateSize()},1e3)),r.addClass(t,"pswp--visible")}},close:function(){h&&(h=!1,c=!0,Ot("close"),Wt(),ii(s.currItem,null,!0,s.destroy))},destroy:function(){Ot("destroy"),Ge&&clearTimeout(Ge),t.setAttribute("aria-hidden","true"),t.className=R,b&&clearInterval(b),r.unbind(s.scrollWrap,g,s),r.unbind(window,"scroll",s),Pe(),ie(),kt=null},panTo:function(t,e,i){i||(t>nt.min.x?t=nt.min.x:t<nt.max.x&&(t=nt.max.x),e>nt.min.y?e=nt.min.y:e<nt.max.y&&(e=nt.max.y)),mt.x=t,mt.y=e,zt()},handleEvent:function(t){t=t||window.event,v[t.type]&&v[t.type](t)},goTo:function(t){t=Ct(t);var e=t-f;xt=e,f=t,s.currItem=Je(f),vt-=e,It(_t.x*vt),ie(),st=!1,s.updateCurrItem()},next:function(){s.goTo(f+1)},prev:function(){s.goTo(f-1)},updateCurrZoomItem:function(t){if(t&&Ot("beforeChange",0),S[1].el.children.length){var e=S[1].el.children[0];rt=r.hasClass(e,"pswp__zoom-wrap")?e.style:null}else rt=null;nt=s.currItem.bounds,_=y=s.currItem.initialZoomLevel,mt.x=nt.center.x,mt.y=nt.center.y,t&&Ot("afterChange")},invalidateCurrItems:function(){T=!0;for(var t=0;t<a;t++)S[t].item&&(S[t].item.needsUpdate=!0)},updateCurrItem:function(t){if(0!==xt){var e,i=Math.abs(xt);if(!(t&&i<2)){s.currItem=Je(f),St=!1,Ot("beforeChange",xt),i>=a&&(p+=xt+(xt>0?-a:a),i=a);for(var n=0;n<i;n++)xt>0?(e=S.shift(),S[a-1]=e,p++,Rt((p+2)*_t.x,e.el.style),s.setContent(e,f-i+n+1+1)):(e=S.pop(),S.unshift(e),p--,Rt(p*_t.x,e.el.style),s.setContent(e,f+i-n-1-1));if(rt&&1===Math.abs(xt)){var r=Je(P);r.initialZoomLevel!==y&&(li(r,gt),fi(r),Lt(r))}xt=0,s.updateCurrZoomItem(),P=f,Ot("afterChange")}}},updateSize:function(e){if(!wt&&l.modal){var i=r.getScrollY();if(N!==i&&(t.style.top=i+"px",N=i),!e&&Tt.x===window.innerWidth&&Tt.y===window.innerHeight)return;Tt.x=window.innerWidth,Tt.y=window.innerHeight,t.style.height=Tt.y+"px"}if(gt.x=s.scrollWrap.clientWidth,gt.y=s.scrollWrap.clientHeight,$t(),_t.x=gt.x+Math.round(gt.x*l.spacing),_t.y=gt.y,It(_t.x*vt),Ot("beforeResize"),void 0!==p){for(var n,o,h,c=0;c<a;c++)n=S[c],Rt((c+p)*_t.x,n.el.style),h=f+c-1,l.loop&&ti()>2&&(h=Ct(h)),o=Je(h),o&&(T||o.needsUpdate||!o.bounds)?(s.cleanSlide(o),s.setContent(n,h),1===c&&(s.currItem=o,s.updateCurrZoomItem(!0)),o.needsUpdate=!1):n.index===-1&&h>=0&&s.setContent(n,h),o&&o.container&&(li(o,gt),fi(o),Lt(o));T=!1}_=y=s.currItem.initialZoomLevel,nt=s.currItem.bounds,nt&&(mt.x=nt.center.x,mt.y=nt.center.y,zt(!0)),Ot("resize")},zoomTo:function(t,e,i,n,s){e&&(_=y,xe.x=Math.abs(e.x)-mt.x,xe.y=Math.abs(e.y)-mt.y,Nt(pt,mt));var o=Yt(t,!1),a={};Zt("x",o,a,t),Zt("y",o,a,t);var l=y,h={x:mt.x,y:mt.y};Xt(a);var c=function(e){1===e?(y=t,mt.x=a.x,mt.y=a.y):(y=(t-l)*e+l,mt.x=(a.x-h.x)*e+h.x,mt.y=(a.y-h.y)*e+h.y),s&&s(e),zt(1===e)};i?ne("customZoomTo",0,1,i,n||r.easing.sine.inOut,c):c(1)}},se=30,oe=10,ae={},le={},he={},ce={},ue={},fe=[],de={},pe=[],me={},ge=0,ve=ft(),ye=0,_e=ft(),xe=ft(),we=ft(),be=function(t,e){return t.x===e.x&&t.y===e.y},Te=function(t,e){return Math.abs(t.x-e.x)<o&&Math.abs(t.y-e.y)<o},Se=function(t,e){return me.x=Math.abs(t.x-e.x),me.y=Math.abs(t.y-e.y),Math.sqrt(me.x*me.x+me.y*me.y)},Pe=function(){$&&(L($),$=null)},Ce=function(){Z&&($=z(Ce),Ue())},ke=function(){return!("fit"===l.scaleMode&&y===s.currItem.initialZoomLevel)},Ee=function(t,e){return!(!t||t===document)&&(!(t.getAttribute("class")&&t.getAttribute("class").indexOf("pswp__scroll-wrap")>-1)&&(e(t)?t:Ee(t.parentNode,e)))},Oe={},Ae=function(t,e){return Oe.prevent=!Ee(t.target,l.isClickableElement),Ot("preventDragEvent",t,e,Oe),Oe.prevent},De=function(t,e){return e.x=t.pageX,e.y=t.pageY,e.id=t.identifier,e},Me=function(t,e,i){i.x=.5*(t.x+e.x),i.y=.5*(t.y+e.y)},ze=function(t,e,i){if(t-U>50){var n=pe.length>2?pe.shift():{};n.x=e,n.y=i,pe.push(n),U=t}},Le=function(){var t=mt.y-s.currItem.initialPosition.y;return 1-Math.abs(t/(gt.y/2))},Re={},Ie={},Fe=[],Ne=function(t){for(;Fe.length>0;)Fe.pop();return D?(ut=0,fe.forEach(function(t){0===ut?Fe[0]=t:1===ut&&(Fe[1]=t),ut++})):t.type.indexOf("touch")>-1?t.touches&&t.touches.length>0&&(Fe[0]=De(t.touches[0],Re),t.touches.length>1&&(Fe[1]=De(t.touches[1],Ie))):(Re.x=t.pageX,Re.y=t.pageY,Re.id="",Fe[0]=Re),Fe},Xe=function(t,e){var i,n,r,o,a=0,h=mt[t]+e[t],c=e[t]>0,u=_e.x+e.x,f=_e.x-de.x;return i=h>nt.min[t]||h<nt.max[t]?l.panEndFriction:1,h=mt[t]+e[t]*i,l.allowPanToNext&&(rt?"h"!==ot||"x"!==t||G||(c?(h>nt.min[t]&&(i=l.panEndFriction,a=nt.min[t]-h,n=nt.min[t]-pt[t]),(n<=0||f<0)&&ti()>1?(o=u,f<0&&u>de.x&&(o=de.x)):nt.min.x!==nt.max.x&&(r=h)):(h<nt.max[t]&&(i=l.panEndFriction,a=h-nt.max[t],n=pt[t]-nt.max[t]),(n<=0||f>0)&&ti()>1?(o=u,f>0&&u<de.x&&(o=de.x)):nt.min.x!==nt.max.x&&(r=h))):o=u,"x"===t)?(void 0!==o&&(It(o,!0),K=o!==de.x),nt.min.x!==nt.max.x&&(void 0!==r?mt.x=r:K||(mt.x+=e.x*i)),void 0!==o):void(st||K||y>s.currItem.fitRatio&&(mt[t]+=e[t]*i))},je=function(t){if(!("mousedown"===t.type&&t.button>0)){if(Ke)return void t.preventDefault();if(!H||"mousedown"!==t.type){if(Ae(t,!0)&&t.preventDefault(),Ot("pointerDown"),D){var e=r.arraySearch(fe,t.pointerId,"id");e<0&&(e=fe.length),fe[e]={x:t.pageX,y:t.pageY,id:t.pointerId}}var i=Ne(t),n=i.length;J=null,ie(),Z&&1!==n||(Z=at=!0,r.bind(window,m,s),Y=ct=lt=q=K=Q=V=G=!1,ot=null,Ot("firstTouchStart",i),Nt(pt,mt),dt.x=dt.y=0,Nt(ce,i[0]),Nt(ue,ce),de.x=_t.x*vt,pe=[{x:ce.x,y:ce.y}],U=B=At(),Yt(y,!0),Pe(),Ce()),!tt&&n>1&&!st&&!K&&(_=y,G=!1,tt=V=!0,dt.y=dt.x=0,Nt(pt,mt),Nt(ae,i[0]),Nt(le,i[1]),Me(ae,le,we),xe.x=Math.abs(we.x)-mt.x,xe.y=Math.abs(we.y)-mt.y,et=it=Se(ae,le))}}},Be=function(t){if(t.preventDefault(),D){var e=r.arraySearch(fe,t.pointerId,"id");if(e>-1){var i=fe[e];i.x=t.pageX,i.y=t.pageY}}if(Z){var n=Ne(t);if(ot||Q||tt)J=n;else if(_e.x!==_t.x*vt)ot="h";else{var s=Math.abs(n[0].x-ce.x)-Math.abs(n[0].y-ce.y);Math.abs(s)>=oe&&(ot=s>0?"h":"v",J=n)}}},Ue=function(){if(J){var t=J.length;if(0!==t)if(Nt(ae,J[0]),he.x=ae.x-ce.x,he.y=ae.y-ce.y,tt&&t>1){if(ce.x=ae.x,ce.y=ae.y,!he.x&&!he.y&&be(J[1],le))return;Nt(le,J[1]),G||(G=!0,Ot("zoomGestureStarted"));var e=Se(ae,le),i=Ze(e);i>s.currItem.initialZoomLevel+s.currItem.initialZoomLevel/15&&(ct=!0);var n=1,r=qt(),o=Ht();if(i<r)if(l.pinchToClose&&!ct&&_<=s.currItem.initialZoomLevel){var a=r-i,h=1-a/(r/1.2);Dt(h),Ot("onPinchClose",h),lt=!0}else n=(r-i)/r,n>1&&(n=1),i=r-n*(r/3);else i>o&&(n=(i-o)/(6*r),n>1&&(n=1),i=o+n*r);n<0&&(n=0),et=e,Me(ae,le,ve),dt.x+=ve.x-we.x,dt.y+=ve.y-we.y,Nt(we,ve),mt.x=Ft("x",i),mt.y=Ft("y",i),Y=i>y,y=i,zt()}else{if(!ot)return;if(at&&(at=!1,Math.abs(he.x)>=oe&&(he.x-=J[0].x-ue.x),Math.abs(he.y)>=oe&&(he.y-=J[0].y-ue.y)),ce.x=ae.x,ce.y=ae.y,0===he.x&&0===he.y)return;if("v"===ot&&l.closeOnVerticalDrag&&!ke()){dt.y+=he.y,mt.y+=he.y;var c=Le();return q=!0,Ot("onVerticalDrag",c),Dt(c),void zt()}ze(At(),ae.x,ae.y),Q=!0,nt=s.currItem.bounds;var u=Xe("x",he);u||(Xe("y",he),Xt(mt),zt())}}},We=function(t){if(X.isOldAndroid){if(H&&"mouseup"===t.type)return;t.type.indexOf("touch")>-1&&(clearTimeout(H),H=setTimeout(function(){H=0},600))}Ot("pointerUp"),Ae(t,!1)&&t.preventDefault();var e;if(D){var i=r.arraySearch(fe,t.pointerId,"id");if(i>-1)if(e=fe.splice(i,1)[0],navigator.pointerEnabled)e.type=t.pointerType||"mouse";else{var n={4:"mouse",2:"touch",3:"pen"};e.type=n[t.pointerType],e.type||(e.type=t.pointerType||"mouse")}}var o,a=Ne(t),h=a.length;if("mouseup"===t.type&&(h=0),2===h)return J=null,!0;1===h&&Nt(ue,a[0]),0!==h||ot||st||(e||("mouseup"===t.type?e={x:t.pageX,y:t.pageY,type:"mouse"}:t.changedTouches&&t.changedTouches[0]&&(e={x:t.changedTouches[0].pageX,y:t.changedTouches[0].pageY,type:"touch"})),Ot("touchRelease",t,e));var c=-1;if(0===h&&(Z=!1,r.unbind(window,m,s),Pe(),tt?c=0:ye!==-1&&(c=At()-ye)),ye=1===h?At():-1,o=c!==-1&&c<150?"zoom":"swipe",tt&&h<2&&(tt=!1,1===h&&(o="zoomPointerUp"),Ot("zoomGestureEnded")),J=null,Q||G||st||q)if(ie(),W||(W=Ye()),W.calculateSwipeSpeed("x"),q){var u=Le();if(u<l.verticalDragRange)s.close();else{var f=mt.y,d=ht;ne("verticalDrag",0,1,300,r.easing.cubic.out,function(t){mt.y=(s.currItem.initialPosition.y-f)*t+f,Dt((1-d)*t+d),zt()}),Ot("onVerticalDrag",1)}}else{if((K||st)&&0===h){var p=He(o,W);if(p)return;o="zoomPointerUp"}if(!st)return"swipe"!==o?void Ve():void(!K&&y>s.currItem.fitRatio&&qe(W))}},Ye=function(){var t,e,i={lastFlickOffset:{},lastFlickDist:{},lastFlickSpeed:{},slowDownRatio:{},slowDownRatioReverse:{},speedDecelerationRatio:{},speedDecelerationRatioAbs:{},distanceOffset:{},backAnimDestination:{},backAnimStarted:{},calculateSwipeSpeed:function(n){pe.length>1?(t=At()-U+50,e=pe[pe.length-2][n]):(t=At()-B,e=ue[n]),i.lastFlickOffset[n]=ce[n]-e,i.lastFlickDist[n]=Math.abs(i.lastFlickOffset[n]),i.lastFlickDist[n]>20?i.lastFlickSpeed[n]=i.lastFlickOffset[n]/t:i.lastFlickSpeed[n]=0,Math.abs(i.lastFlickSpeed[n])<.1&&(i.lastFlickSpeed[n]=0),i.slowDownRatio[n]=.95,i.slowDownRatioReverse[n]=1-i.slowDownRatio[n],i.speedDecelerationRatio[n]=1},calculateOverBoundsAnimOffset:function(t,e){i.backAnimStarted[t]||(mt[t]>nt.min[t]?i.backAnimDestination[t]=nt.min[t]:mt[t]<nt.max[t]&&(i.backAnimDestination[t]=nt.max[t]),void 0!==i.backAnimDestination[t]&&(i.slowDownRatio[t]=.7,i.slowDownRatioReverse[t]=1-i.slowDownRatio[t],i.speedDecelerationRatioAbs[t]<.05&&(i.lastFlickSpeed[t]=0,i.backAnimStarted[t]=!0,ne("bounceZoomPan"+t,mt[t],i.backAnimDestination[t],e||300,r.easing.sine.out,function(e){mt[t]=e,zt()}))))},calculateAnimOffset:function(t){i.backAnimStarted[t]||(i.speedDecelerationRatio[t]=i.speedDecelerationRatio[t]*(i.slowDownRatio[t]+i.slowDownRatioReverse[t]-i.slowDownRatioReverse[t]*i.timeDiff/10),i.speedDecelerationRatioAbs[t]=Math.abs(i.lastFlickSpeed[t]*i.speedDecelerationRatio[t]),i.distanceOffset[t]=i.lastFlickSpeed[t]*i.speedDecelerationRatio[t]*i.timeDiff,mt[t]+=i.distanceOffset[t])},panAnimLoop:function(){if(Kt.zoomPan&&(Kt.zoomPan.raf=z(i.panAnimLoop),i.now=At(),i.timeDiff=i.now-i.lastNow,i.lastNow=i.now,i.calculateAnimOffset("x"),i.calculateAnimOffset("y"),zt(),i.calculateOverBoundsAnimOffset("x"),i.calculateOverBoundsAnimOffset("y"),i.speedDecelerationRatioAbs.x<.05&&i.speedDecelerationRatioAbs.y<.05))return mt.x=Math.round(mt.x),mt.y=Math.round(mt.y),zt(),void te("zoomPan")}};return i},qe=function(t){return t.calculateSwipeSpeed("y"),nt=s.currItem.bounds,t.backAnimDestination={},t.backAnimStarted={},Math.abs(t.lastFlickSpeed.x)<=.05&&Math.abs(t.lastFlickSpeed.y)<=.05?(t.speedDecelerationRatioAbs.x=t.speedDecelerationRatioAbs.y=0,t.calculateOverBoundsAnimOffset("x"),t.calculateOverBoundsAnimOffset("y"),!0):(ee("zoomPan"),t.lastNow=At(),void t.panAnimLoop())},He=function(t,e){var i;st||(ge=f);var n;if("swipe"===t){var o=ce.x-ue.x,a=e.lastFlickDist.x<10;o>se&&(a||e.lastFlickOffset.x>20)?n=-1:o<-se&&(a||e.lastFlickOffset.x<-20)&&(n=1)}var h;n&&(f+=n,f<0?(f=l.loop?ti()-1:0,h=!0):f>=ti()&&(f=l.loop?0:ti()-1,h=!0),h&&!l.loop||(xt+=n,vt-=n,i=!0));var c,u=_t.x*vt,d=Math.abs(u-_e.x);return i||u>_e.x==e.lastFlickSpeed.x>0?(c=Math.abs(e.lastFlickSpeed.x)>0?d/Math.abs(e.lastFlickSpeed.x):333,c=Math.min(c,400),c=Math.max(c,250)):c=333,ge===f&&(i=!1),st=!0,Ot("mainScrollAnimStart"),ne("mainScroll",_e.x,u,c,r.easing.cubic.out,It,function(){ie(),st=!1,ge=-1,(i||ge!==f)&&s.updateCurrItem(),Ot("mainScrollAnimComplete")}),i&&s.updateCurrItem(!0),i},Ze=function(t){return 1/it*t*_},Ve=function(){var t=y,e=qt(),i=Ht();y<e?t=e:y>i&&(t=i);var n,o=1,a=ht;return lt&&!Y&&!ct&&y<e?(s.close(),!0):(lt&&(n=function(t){Dt((o-a)*t+a)}),s.zoomTo(t,0,200,r.easing.cubic.out,n),!0)};Pt("Gestures",{publicMethods:{initGestures:function(){var t=function(t,e,i,n,r){C=t+e,k=t+i,E=t+n,O=r?t+r:""};D=X.pointerEvent,D&&X.touch&&(X.touch=!1),D?navigator.pointerEnabled?t("pointer","down","move","up","cancel"):t("MSPointer","Down","Move","Up","Cancel"):X.touch?(t("touch","start","move","end","cancel"),M=!0):t("mouse","down","move","up"),m=k+" "+E+" "+O,g=C,D&&!M&&(M=navigator.maxTouchPoints>1||navigator.msMaxTouchPoints>1),s.likelyTouchDevice=M,v[C]=je,v[k]=Be,v[E]=We,O&&(v[O]=v[E]),X.touch&&(g+=" mousedown",m+=" mousemove mouseup",v.mousedown=v[C],v.mousemove=v[k],v.mouseup=v[E]),M||(l.allowPanToNext=!1)}}});var Ge,Qe,$e,Ke,Je,ti,ei,ii=function(e,i,n,o){Ge&&clearTimeout(Ge),Ke=!0,$e=!0;var a;e.initialLayout?(a=e.initialLayout,e.initialLayout=null):a=l.getThumbBoundsFn&&l.getThumbBoundsFn(f);var h=n?l.hideAnimationDuration:l.showAnimationDuration,c=function(){te("initialZoom"),n?(s.template.removeAttribute("style"),s.bg.removeAttribute("style")):(Dt(1),i&&(i.style.display="block"),r.addClass(t,"pswp--animated-in"),Ot("initialZoom"+(n?"OutEnd":"InEnd"))),o&&o(),Ke=!1};if(!h||!a||void 0===a.x)return Ot("initialZoom"+(n?"Out":"In")),y=e.initialZoomLevel,Nt(mt,e.initialPosition),zt(),t.style.opacity=n?0:1,Dt(1),void(h?setTimeout(function(){c()},h):c());var d=function(){var i=u,o=!s.currItem.src||s.currItem.loadError||l.showHideOpacity;e.miniImg&&(e.miniImg.style.webkitBackfaceVisibility="hidden"),n||(y=a.w/e.w,mt.x=a.x,mt.y=a.y-I,s[o?"template":"bg"].style.opacity=.001,zt()),ee("initialZoom"),n&&!i&&r.removeClass(t,"pswp--animated-in"),o&&(n?r[(i?"remove":"add")+"Class"](t,"pswp--animate_opacity"):setTimeout(function(){r.addClass(t,"pswp--animate_opacity")},30)),Ge=setTimeout(function(){if(Ot("initialZoom"+(n?"Out":"In")),n){var s=a.w/e.w,l={x:mt.x,y:mt.y},u=y,f=ht,d=function(e){1===e?(y=s,mt.x=a.x,mt.y=a.y-N):(y=(s-u)*e+u,mt.x=(a.x-l.x)*e+l.x,mt.y=(a.y-N-l.y)*e+l.y),zt(),o?t.style.opacity=1-e:Dt(f-e*f)};i?ne("initialZoom",0,1,h,r.easing.cubic.out,d,c):(d(1),Ge=setTimeout(c,h+20))}else y=e.initialZoomLevel,Nt(mt,e.initialPosition),zt(),Dt(1),o?t.style.opacity=1:Dt(1),Ge=setTimeout(c,h+20)},n?25:90)};d()},ni={},ri=[],si={index:0,errorMsg:'<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',forceProgressiveLoading:!1,preload:[1,1],getNumItemsFn:function(){return Qe.length}},oi=function(){return{center:{x:0,y:0},max:{x:0,y:0},min:{x:0,y:0}}},ai=function(t,e,i){var n=t.bounds;n.center.x=Math.round((ni.x-e)/2),n.center.y=Math.round((ni.y-i)/2)+t.vGap.top,n.max.x=e>ni.x?Math.round(ni.x-e):n.center.x,n.max.y=i>ni.y?Math.round(ni.y-i)+t.vGap.top:n.center.y,n.min.x=e>ni.x?0:n.center.x,n.min.y=i>ni.y?t.vGap.top:n.center.y},li=function(t,e,i){if(t.src&&!t.loadError){var n=!i;if(n&&(t.vGap||(t.vGap={top:0,bottom:0}),Ot("parseVerticalMargin",t)),ni.x=e.x,ni.y=e.y-t.vGap.top-t.vGap.bottom,n){var r=ni.x/t.w,s=ni.y/t.h;t.fitRatio=r<s?r:s;var o=l.scaleMode;"orig"===o?i=1:"fit"===o?i=t.fitRatio:"zoom"===o&&(i=Math.max(t.initialZoomLevel||1,t.fitRatio)),i>1&&(i=1),t.initialZoomLevel=i,t.bounds||(t.bounds=oi())}if(!i)return;return ai(t,t.w*i,t.h*i),n&&i===t.initialZoomLevel&&(t.initialPosition=t.bounds.center),t.bounds}return t.w=t.h=0,t.initialZoomLevel=t.fitRatio=1,t.bounds=oi(),t.initialPosition=t.bounds.center,t.bounds},hi=function(t,e,i,n,r,o){e.loadError||n&&(e.imageAppended=!0,fi(e,n,e===s.currItem&&St),i.appendChild(n),o&&setTimeout(function(){e&&e.loaded&&e.placeholder&&(e.placeholder.style.display="none",e.placeholder=null)},500))},ci=function(t){t.loading=!0,t.loaded=!1;var e=t.img=r.createEl("pswp__img","img"),i=function(){t.loading=!1,t.loaded=!0,t.loadComplete?t.loadComplete(t):t.img=null,e.onload=e.onerror=null,e=null};return e.onload=i,e.onerror=function(){t.loadError=!0,i()},e.src=t.src,e},ui=function(t,e){if(t.src&&t.loadError&&t.container)return e&&(t.container.innerHTML=""),t.container.innerHTML=l.errorMsg.replace("%url%",t.src),!0},fi=function(t,e,i){if(t.src){e||(e=t.container.lastChild);var n=i?t.w:Math.round(t.w*t.fitRatio),r=i?t.h:Math.round(t.h*t.fitRatio);t.placeholder&&!t.loaded&&(t.placeholder.style.width=n+"px",t.placeholder.style.height=r+"px"),e.style.width=n+"px",e.style.height=r+"px"}},di=function(){if(ri.length){for(var t,e=0;e<ri.length;e++)t=ri[e],t.holder.index===t.index&&hi(t.index,t.item,t.baseDiv,t.img,!1,t.clearPlaceholder);ri=[]}};Pt("Controller",{publicMethods:{lazyLoadItem:function(t){t=Ct(t);var e=Je(t);e&&(!e.loaded&&!e.loading||T)&&(Ot("gettingData",t,e),e.src&&ci(e))},initController:function(){r.extend(l,si,!0),s.items=Qe=i,Je=s.getItemAt,ti=l.getNumItemsFn,ei=l.loop,ti()<3&&(l.loop=!1),Et("beforeChange",function(t){var e,i=l.preload,n=null===t||t>=0,r=Math.min(i[0],ti()),o=Math.min(i[1],ti());for(e=1;e<=(n?o:r);e++)s.lazyLoadItem(f+e);for(e=1;e<=(n?r:o);e++)s.lazyLoadItem(f-e)}),Et("initialLayout",function(){s.currItem.initialLayout=l.getThumbBoundsFn&&l.getThumbBoundsFn(f)}),Et("mainScrollAnimComplete",di),Et("initialZoomInEnd",di),Et("destroy",function(){for(var t,e=0;e<Qe.length;e++)t=Qe[e],t.container&&(t.container=null),t.placeholder&&(t.placeholder=null),t.img&&(t.img=null),t.preloader&&(t.preloader=null),t.loadError&&(t.loaded=t.loadError=!1);ri=null})},getItemAt:function(t){return t>=0&&(void 0!==Qe[t]&&Qe[t])},allowProgressiveImg:function(){return l.forceProgressiveLoading||!M||l.mouseUsed||screen.width>1200},setContent:function(t,e){l.loop&&(e=Ct(e));var i=s.getItemAt(t.index);i&&(i.container=null);var n,o=s.getItemAt(e);if(!o)return void(t.el.innerHTML="");Ot("gettingData",e,o),t.index=e,t.item=o;var a=o.container=r.createEl("pswp__zoom-wrap");if(!o.src&&o.html&&(o.html.tagName?a.appendChild(o.html):a.innerHTML=o.html),ui(o),li(o,gt),!o.src||o.loadError||o.loaded)o.src&&!o.loadError&&(n=r.createEl("pswp__img","img"),n.style.opacity=1,n.src=o.src,fi(o,n),hi(e,o,a,n,!0));else{if(o.loadComplete=function(i){if(h){if(t&&t.index===e){if(ui(i,!0))return i.loadComplete=i.img=null,li(i,gt),Lt(i),void(t.index===f&&s.updateCurrZoomItem());i.imageAppended?!Ke&&i.placeholder&&(i.placeholder.style.display="none",i.placeholder=null):X.transform&&(st||Ke)?ri.push({item:i,baseDiv:a,img:i.img,index:e,holder:t,clearPlaceholder:!0}):hi(e,i,a,i.img,st||Ke,!0)}i.loadComplete=null,i.img=null,Ot("imageLoadComplete",e,i)}},r.features.transform){var c="pswp__img pswp__img--placeholder";c+=o.msrc?"":" pswp__img--placeholder--blank";var u=r.createEl(c,o.msrc?"img":"");o.msrc&&(u.src=o.msrc),fi(o,u),a.appendChild(u),o.placeholder=u}o.loading||ci(o),s.allowProgressiveImg()&&(!$e&&X.transform?ri.push({item:o,baseDiv:a,img:o.img,index:e,holder:t}):hi(e,o,a,o.img,!0,!0))}$e||e!==f?Lt(o):(rt=a.style,ii(o,n||o.img)),t.el.innerHTML="",t.el.appendChild(a)},cleanSlide:function(t){t.img&&(t.img.onload=t.img.onerror=null),t.loaded=t.loading=t.img=t.imageAppended=!1}}});var pi,mi={},gi=function(t,e,i){var n=document.createEvent("CustomEvent"),r={origEvent:t,target:t.target,releasePoint:e,pointerType:i||"touch"};n.initCustomEvent("pswpTap",!0,!0,r),t.target.dispatchEvent(n)};Pt("Tap",{publicMethods:{initTap:function(){Et("firstTouchStart",s.onTapStart),Et("touchRelease",s.onTapRelease),Et("destroy",function(){mi={},pi=null})},onTapStart:function(t){t.length>1&&(clearTimeout(pi),pi=null)},onTapRelease:function(t,e){if(e&&!Q&&!V&&!Jt){var i=e;if(pi&&(clearTimeout(pi),pi=null,Te(i,mi)))return void Ot("doubleTap",i);if("mouse"===e.type)return void gi(t,e,"mouse");var n=t.target.tagName.toUpperCase();if("BUTTON"===n||r.hasClass(t.target,"pswp__single-tap"))return void gi(t,e);Nt(mi,i),pi=setTimeout(function(){gi(t,e),pi=null},300)}}}});var vi;Pt("DesktopZoom",{publicMethods:{initDesktopZoom:function(){F||(M?Et("mouseUsed",function(){s.setupDesktopZoom()}):s.setupDesktopZoom(!0))},setupDesktopZoom:function(e){vi={};var i="wheel mousewheel DOMMouseScroll";Et("bindEvents",function(){r.bind(t,i,s.handleMouseWheel)}),Et("unbindEvents",function(){vi&&r.unbind(t,i,s.handleMouseWheel)}),s.mouseZoomedIn=!1;var n,o=function(){s.mouseZoomedIn&&(r.removeClass(t,"pswp--zoomed-in"),s.mouseZoomedIn=!1),y<1?r.addClass(t,"pswp--zoom-allowed"):r.removeClass(t,"pswp--zoom-allowed"),a()},a=function(){n&&(r.removeClass(t,"pswp--dragging"),n=!1)};Et("resize",o),Et("afterChange",o),Et("pointerDown",function(){s.mouseZoomedIn&&(n=!0,r.addClass(t,"pswp--dragging"))}),Et("pointerUp",a),e||o()},handleMouseWheel:function(t){if(y<=s.currItem.fitRatio)return l.modal&&(!l.closeOnScroll||Jt||Z?t.preventDefault():A&&Math.abs(t.deltaY)>2&&(u=!0,s.close())),!0;if(t.stopPropagation(),vi.x=0,"deltaX"in t)1===t.deltaMode?(vi.x=18*t.deltaX,vi.y=18*t.deltaY):(vi.x=t.deltaX,vi.y=t.deltaY);else if("wheelDelta"in t)t.wheelDeltaX&&(vi.x=-.16*t.wheelDeltaX),t.wheelDeltaY?vi.y=-.16*t.wheelDeltaY:vi.y=-.16*t.wheelDelta;else{if(!("detail"in t))return;vi.y=t.detail}Yt(y,!0);var e=mt.x-vi.x,i=mt.y-vi.y;(l.modal||e<=nt.min.x&&e>=nt.max.x&&i<=nt.min.y&&i>=nt.max.y)&&t.preventDefault(),s.panTo(e,i)},toggleDesktopZoom:function(e){e=e||{x:gt.x/2+yt.x,y:gt.y/2+yt.y};var i=l.getDoubleTapZoom(!0,s.currItem),n=y===i;s.mouseZoomedIn=!n,s.zoomTo(n?s.currItem.initialZoomLevel:i,e,333),r[(n?"remove":"add")+"Class"](t,"pswp--zoomed-in")}}}),r.extend(s,re)};return t}),function(t,e){"function"==typeof define&&define.amd?define([],e):"object"==typeof module&&module.exports?module.exports=e():t.Rellax=e()}(this,function(){var t=function(e,i){"use strict";var n=Object.create(t.prototype),r=0,s=0,o=[],a=!1,l=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame||function(t){setTimeout(t,1e3/60)},h=window.transformProp||function(){var t=document.createElement("div");if(null==t.style.transform){var e=["Webkit","Moz","ms"];for(var i in e)if(void 0!==t.style[e[i]+"Transform"])return e[i]+"Transform"}return"transform"}(),c=function(t,e,i){return t<=e?e:t>=i?i:t};n.options={speed:-2,center:!1,round:!0,callback:function(){}},i&&Object.keys(i).forEach(function(t){n.options[t]=i[t]}),n.options.speed=c(n.options.speed,-10,10),e||(e=".rellax");var u=document.querySelectorAll(e);if(!(u.length>0))throw new Error("The elements you're trying to select don't exist.");n.elems=u;var f=function(){s=window.innerHeight,p();for(var t=0;t<n.elems.length;t++){var e=d(n.elems[t]);o.push(e)}window.addEventListener("resize",function(){v()}),g(),v()},d=function(t){var e=t.getAttribute("data-rellax-percentage"),i=t.getAttribute("data-rellax-speed"),r=t.getAttribute("data-rellax-zindex")||0,o=e||n.options.center?window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop:0,a=o+t.getBoundingClientRect().top,l=t.clientHeight||t.offsetHeight||t.scrollHeight,h=e?e:(o-a+s)/(l+s);n.options.center&&(h=.5);var u=i?c(i,-10,10):n.options.speed;(e||n.options.center)&&(u=c(i||n.options.speed,-5,5));var f=m(h,u),d=t.style.cssText,p="";if(d.indexOf("transform")>=0){var g=d.indexOf("transform"),v=d.slice(g),y=v.indexOf(";");p=y?" "+v.slice(11,y).replace(/\s/g,""):" "+v.slice(11).replace(/\s/g,"")}return{base:f,top:a,height:l,speed:u,style:d,transform:p,zindex:r}},p=function(){var t=r;return r=void 0!==window.pageYOffset?window.pageYOffset:(document.documentElement||document.body.parentNode||document.body).scrollTop,t!=r},m=function(t,e){var i=e*(100*(1-t));return n.options.round?Math.round(i):Math.round(100*i)/100},g=function(){p()&&a===!1&&v(),l(g)},v=function(){for(var t=0;t<n.elems.length;t++){var e=(r-o[t].top+s)/(o[t].height+s),i=m(e,o[t].speed)-o[t].base,a=o[t].zindex,l="translate3d(0,"+i+"px,"+a+"px) "+o[t].transform;n.elems[t].style[h]=l}n.options.callback(i)};return n.destroy=function(){for(var t=0;t<n.elems.length;t++)n.elems[t].style.cssText=o[t].style;a=!0},f(),n};return t}),function(){"use strict";function t(t){var e=["MSIE ","Trident/","Edge/"];return new RegExp(e.join("|")).test(t)}function e(){function e(t,e){this.scrollLeft=t,this.scrollTop=e}function r(t){return.5*(1-Math.cos(Math.PI*t))}function s(t){if(null===t||"object"!=typeof t||void 0===t.behavior||"auto"===t.behavior||"instant"===t.behavior)return!0;if("object"==typeof t&&"smooth"===t.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+t.behavior+" is not a valid value for enumeration ScrollBehavior.")}function o(t,e){return"Y"===e?t.clientHeight+p<t.scrollHeight:"X"===e?t.clientWidth+p<t.scrollWidth:void 0}function a(t,e){var n=i.getComputedStyle(t,null)["overflow"+e];return"auto"===n||"scroll"===n}function l(t){var e=o(t,"Y")&&a(t,"Y"),i=o(t,"X")&&a(t,"X");return e||i}function h(t){var e;do t=t.parentNode,e=t===n.body;while(e===!1&&l(t)===!1);return e=null,t}function c(t){var e,n,s,o=g(),a=(o-t.startTime)/d;a=a>1?1:a,e=r(a),n=t.startX+(t.x-t.startX)*e,s=t.startY+(t.y-t.startY)*e,t.method.call(t.scrollable,n,s),n===t.x&&s===t.y||i.requestAnimationFrame(c.bind(i,t))}function u(t,r,s){var o,a,l,h,u=g();t===n.body?(o=i,a=i.scrollX||i.pageXOffset,l=i.scrollY||i.pageYOffset,h=m.scroll):(o=t,a=t.scrollLeft,l=t.scrollTop,h=e),c({scrollable:o,method:h,startTime:u,startX:a,startY:l,x:r,y:s})}if(!("scrollBehavior"in n.documentElement.style&&i.__forceSmoothScrollPolyfill__!==!0)){var f=i.HTMLElement||i.Element,d=468,p=t(i.navigator.userAgent)?1:0,m={scroll:i.scroll||i.scrollTo,scrollBy:i.scrollBy,elementScroll:f.prototype.scroll||e,scrollIntoView:f.prototype.scrollIntoView},g=i.performance&&i.performance.now?i.performance.now.bind(i.performance):Date.now;i.scroll=i.scrollTo=function(){if(void 0!==arguments[0])return s(arguments[0])===!0?void m.scroll.call(i,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:i.scrollX||i.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:i.scrollY||i.pageYOffset):void u.call(i,n.body,void 0!==arguments[0].left?~~arguments[0].left:i.scrollX||i.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:i.scrollY||i.pageYOffset)},i.scrollBy=function(){if(void 0!==arguments[0])return s(arguments[0])?void m.scrollBy.call(i,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):void u.call(i,n.body,~~arguments[0].left+(i.scrollX||i.pageXOffset),~~arguments[0].top+(i.scrollY||i.pageYOffset))},f.prototype.scroll=f.prototype.scrollTo=function(){if(void 0!==arguments[0]){if(s(arguments[0])===!0){if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value couldn't be converted");return void m.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}var t=arguments[0].left,e=arguments[0].top;u.call(this,this,"undefined"==typeof t?this.scrollLeft:~~t,"undefined"==typeof e?this.scrollTop:~~e)}},f.prototype.scrollBy=function(){if(void 0!==arguments[0])return s(arguments[0])===!0?void m.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop):void this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior})},f.prototype.scrollIntoView=function(){if(s(arguments[0])===!0)return void m.scrollIntoView.call(this,void 0===arguments[0]||arguments[0]);var t=h(this),e=t.getBoundingClientRect(),r=this.getBoundingClientRect();t!==n.body?(u.call(this,t,t.scrollLeft+r.left-e.left,t.scrollTop+r.top-e.top),"fixed"!==i.getComputedStyle(t).position&&i.scrollBy({left:e.left,top:e.top,behavior:"smooth"})):i.scrollBy({left:r.left,top:r.top,behavior:"smooth"})}}}var i=window,n=document;"object"==typeof exports?module.exports={polyfill:e}:e()}(),function(t,e){"use strict";function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function n(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])}function r(t){return parseFloat(t)||0}function s(t){for(var e=0;t;)e+=t.offsetTop,t=t.offsetParent;return e}function o(){function i(){t.pageXOffset!=c.left?(c.top=t.pageYOffset,c.left=t.pageXOffset,d.refreshAll()):t.pageYOffset!=c.top&&(c.top=t.pageYOffset,c.left=t.pageXOffset,u.forEach(function(t){return t._recalcPosition()}))}function n(){s=setInterval(function(){u.forEach(function(t){return t._fastCheck()})},500)}function r(){clearInterval(s)}i(),t.addEventListener("scroll",i),t.addEventListener("resize",d.refreshAll),t.addEventListener("orientationchange",d.refreshAll);var s=void 0,o=void 0,a=void 0;"hidden"in e?(o="hidden",a="visibilitychange"):"webkitHidden"in e&&(o="webkitHidden",a="webkitvisibilitychange"),a?(e[o]||n(),e.addEventListener(a,function(){e[o]?r():n()})):n()}var a=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),l=!1;t.getComputedStyle?!function(){var t=e.createElement("div");["","-webkit-","-moz-","-ms-"].some(function(e){try{t.style.position=e+"sticky"}catch(i){}return""!=t.style.position})&&(l=!0)}():l=!0;var h="undefined"!=typeof ShadowRoot,c={top:null,left:null},u=[],f=function(){function o(t){if(i(this,o),!(t instanceof HTMLElement))throw new Error("First argument must be HTMLElement");if(u.some(function(e){return e._node===t}))throw new Error("Stickyfill is already applied to this node");this._node=t,this._stickyMode=null,this._active=!1,u.push(this),this.refresh()}return a(o,[{key:"refresh",value:function(){if(!l&&!this._removed){this._active&&this._deactivate();var i=this._node,o=getComputedStyle(i),a={top:o.top,display:o.display,marginTop:o.marginTop,marginBottom:o.marginBottom,marginLeft:o.marginLeft,marginRight:o.marginRight,cssFloat:o.cssFloat};if(!isNaN(parseFloat(a.top))&&"table-cell"!=a.display&&"none"!=a.display){this._active=!0;var c=i.parentNode,u=h&&c instanceof ShadowRoot?c.host:c,f=i.getBoundingClientRect(),d=u.getBoundingClientRect(),p=getComputedStyle(u);this._parent={node:u,styles:{position:u.style.position},offsetHeight:u.offsetHeight},this._offsetToWindow={left:f.left,right:e.documentElement.clientWidth-f.right},this._offsetToParent={top:f.top-d.top-r(p.borderTopWidth),left:f.left-d.left-r(p.borderLeftWidth),right:-f.right+d.right-r(p.borderRightWidth)},this._styles={position:i.style.position,top:i.style.top,bottom:i.style.bottom,left:i.style.left,right:i.style.right,width:i.style.width,marginTop:i.style.marginTop,marginLeft:i.style.marginLeft,marginRight:i.style.marginRight};var m=r(a.top);this._limits={start:f.top+t.pageYOffset-m,end:d.top+t.pageYOffset+u.offsetHeight-r(p.borderBottomWidth)-i.offsetHeight-m-r(a.marginBottom)};var g=p.position;"absolute"!=g&&"relative"!=g&&(u.style.position="relative"),this._recalcPosition();var v=this._clone={};v.node=e.createElement("div"),n(v.node.style,{width:f.right-f.left+"px",height:f.bottom-f.top+"px",marginTop:a.marginTop,marginBottom:a.marginBottom,marginLeft:a.marginLeft,marginRight:a.marginRight,cssFloat:a.cssFloat,padding:0,border:0,borderSpacing:0,fontSize:"1em",position:"static"}),c.insertBefore(v.node,i),v.docOffsetTop=s(v.node)}}}},{key:"_recalcPosition",value:function(){if(this._active&&!this._removed){var t=c.top<=this._limits.start?"start":c.top>=this._limits.end?"end":"middle";if(this._stickyMode!=t){switch(t){case"start":n(this._node.style,{position:"absolute",left:this._offsetToParent.left+"px",right:this._offsetToParent.right+"px",top:this._offsetToParent.top+"px",bottom:"auto",width:"auto",marginLeft:0,marginRight:0,marginTop:0});break;case"middle":n(this._node.style,{position:"fixed",left:this._offsetToWindow.left+"px",right:this._offsetToWindow.right+"px",top:this._styles.top,bottom:"auto",width:"auto",marginLeft:0,marginRight:0,marginTop:0});break;case"end":n(this._node.style,{position:"absolute",left:this._offsetToParent.left+"px",right:this._offsetToParent.right+"px",top:"auto",bottom:0,width:"auto",marginLeft:0,marginRight:0})}this._stickyMode=t}}}},{key:"_fastCheck",value:function(){this._active&&!this._removed&&(Math.abs(s(this._clone.node)-this._clone.docOffsetTop)>1||Math.abs(this._parent.node.offsetHeight-this._parent.offsetHeight)>1)&&this.refresh()}},{key:"_deactivate",value:function(){
var t=this;this._active&&!this._removed&&(this._clone.node.parentNode.removeChild(this._clone.node),delete this._clone,n(this._node.style,this._styles),delete this._styles,u.some(function(e){return e!==t&&e._parent&&e._parent.node===t._parent.node})||n(this._parent.node.style,this._parent.styles),delete this._parent,this._stickyMode=null,this._active=!1,delete this._offsetToWindow,delete this._offsetToParent,delete this._limits)}},{key:"remove",value:function(){var t=this;this._deactivate(),u.some(function(e,i){if(e._node===t._node)return u.splice(i,1),!0}),this._removed=!0}}]),o}(),d={stickies:u,Sticky:f,addOne:function(t){if(!(t instanceof HTMLElement)){if(!t.length||!t[0])return;t=t[0]}for(var e=0;e<u.length;e++)if(u[e]._node===t)return u[e];return new f(t)},add:function(t){if(t instanceof HTMLElement&&(t=[t]),t.length){for(var e=[],i=function(i){var n=t[i];return n instanceof HTMLElement?u.some(function(t){if(t._node===n)return e.push(t),!0})?"continue":void e.push(new f(n)):(e.push(void 0),"continue")},n=0;n<t.length;n++){i(n)}return e}},refreshAll:function(){u.forEach(function(t){return t.refresh()})},removeOne:function(t){if(!(t instanceof HTMLElement)){if(!t.length||!t[0])return;t=t[0]}u.some(function(e){if(e._node===t)return e.remove(),!0})},remove:function(t){if(t instanceof HTMLElement&&(t=[t]),t.length)for(var e=function(e){var i=t[e];u.some(function(t){if(t._node===i)return t.remove(),!0})},i=0;i<t.length;i++)e(i)},removeAll:function(){for(;u.length;)u[0].remove()}};l||o(),"undefined"!=typeof module&&module.exports?module.exports=d:t.Stickyfill=d}(window,document),function(t,e){"use strict";var i={},n=t.document,r=t.GreenSockGlobals=t.GreenSockGlobals||t;if(!r.TweenLite){var s,o,a,l,h,c=function(t){var e,i=t.split("."),n=r;for(e=0;e<i.length;e++)n[i[e]]=n=n[i[e]]||{};return n},u=c("com.greensock"),f=1e-10,d=function(t){var e,i=[],n=t.length;for(e=0;e!==n;i.push(t[e++]));return i},p=function(){},m=function(){var t=Object.prototype.toString,e=t.call([]);return function(i){return null!=i&&(i instanceof Array||"object"==typeof i&&!!i.push&&t.call(i)===e)}}(),g={},v=function(n,s,o,a){this.sc=g[n]?g[n].sc:[],g[n]=this,this.gsClass=null,this.func=o;var l=[];this.check=function(h){for(var u,f,d,p,m=s.length,y=m;--m>-1;)(u=g[s[m]]||new v(s[m],[])).gsClass?(l[m]=u.gsClass,y--):h&&u.sc.push(this);if(0===y&&o){if(f=("com.greensock."+n).split("."),d=f.pop(),p=c(f.join("."))[d]=this.gsClass=o.apply(o,l),a)if(r[d]=i[d]=p,"undefined"!=typeof module&&module.exports)if(n===e){module.exports=i[e]=p;for(m in i)p[m]=i[m]}else i[e]&&(i[e][d]=p);else"function"==typeof define&&define.amd&&define((t.GreenSockAMDPath?t.GreenSockAMDPath+"/":"")+n.split(".").pop(),[],function(){return p});for(m=0;m<this.sc.length;m++)this.sc[m].check()}},this.check(!0)},y=t._gsDefine=function(t,e,i,n){return new v(t,e,i,n)},_=u._class=function(t,e,i){return e=e||function(){},y(t,[],function(){return e},i),e};y.globals=r;var x=[0,0,1,1],w=_("easing.Ease",function(t,e,i,n){this._func=t,this._type=i||0,this._power=n||0,this._params=e?x.concat(e):x},!0),b=w.map={},T=w.register=function(t,e,i,n){for(var r,s,o,a,l=e.split(","),h=l.length,c=(i||"easeIn,easeOut,easeInOut").split(",");--h>-1;)for(s=l[h],r=n?_("easing."+s,null,!0):u.easing[s]||{},o=c.length;--o>-1;)a=c[o],b[s+"."+a]=b[a+s]=r[a]=t.getRatio?t:t[a]||new t};for(a=w.prototype,a._calcEnd=!1,a.getRatio=function(t){if(this._func)return this._params[0]=t,this._func.apply(null,this._params);var e=this._type,i=this._power,n=1===e?1-t:2===e?t:t<.5?2*t:2*(1-t);return 1===i?n*=n:2===i?n*=n*n:3===i?n*=n*n*n:4===i&&(n*=n*n*n*n),1===e?1-n:2===e?n:t<.5?n/2:1-n/2},s=["Linear","Quad","Cubic","Quart","Quint,Strong"],o=s.length;--o>-1;)a=s[o]+",Power"+o,T(new w(null,null,1,o),a,"easeOut",!0),T(new w(null,null,2,o),a,"easeIn"+(0===o?",easeNone":"")),T(new w(null,null,3,o),a,"easeInOut");b.linear=u.easing.Linear.easeIn,b.swing=u.easing.Quad.easeInOut;var S=_("events.EventDispatcher",function(t){this._listeners={},this._eventTarget=t||this});a=S.prototype,a.addEventListener=function(t,e,i,n,r){r=r||0;var s,o,a=this._listeners[t],c=0;for(this!==l||h||l.wake(),null==a&&(this._listeners[t]=a=[]),o=a.length;--o>-1;)s=a[o],s.c===e&&s.s===i?a.splice(o,1):0===c&&s.pr<r&&(c=o+1);a.splice(c,0,{c:e,s:i,up:n,pr:r})},a.removeEventListener=function(t,e){var i,n=this._listeners[t];if(n)for(i=n.length;--i>-1;)if(n[i].c===e)return void n.splice(i,1)},a.dispatchEvent=function(t){var e,i,n,r=this._listeners[t];if(r)for(e=r.length,e>1&&(r=r.slice(0)),i=this._eventTarget;--e>-1;)n=r[e],n&&(n.up?n.c.call(n.s||i,{type:t,target:i}):n.c.call(n.s||i))};var P=t.requestAnimationFrame,C=t.cancelAnimationFrame,k=Date.now||function(){return(new Date).getTime()},E=k();for(s=["ms","moz","webkit","o"],o=s.length;--o>-1&&!P;)P=t[s[o]+"RequestAnimationFrame"],C=t[s[o]+"CancelAnimationFrame"]||t[s[o]+"CancelRequestAnimationFrame"];_("Ticker",function(t,e){var i,r,s,o,a,c=this,u=k(),d=!(e===!1||!P)&&"auto",m=500,g=33,v="tick",y=function(t){var e,n,l=k()-E;l>m&&(u+=l-g),E+=l,c.time=(E-u)/1e3,e=c.time-a,(!i||e>0||t===!0)&&(c.frame++,a+=e+(e>=o?.004:o-e),n=!0),t!==!0&&(s=r(y)),n&&c.dispatchEvent(v)};S.call(c),c.time=c.frame=0,c.tick=function(){y(!0)},c.lagSmoothing=function(t,e){return arguments.length?(m=t||1/f,void(g=Math.min(e,m,0))):m<1/f},c.sleep=function(){null!=s&&(d&&C?C(s):clearTimeout(s),r=p,s=null,c===l&&(h=!1))},c.wake=function(t){null!==s?c.sleep():t?u+=-E+(E=k()):c.frame>10&&(E=k()-m+5),r=0===i?p:d&&P?P:function(t){return setTimeout(t,1e3*(a-c.time)+1|0)},c===l&&(h=!0),y(2)},c.fps=function(t){return arguments.length?(i=t,o=1/(i||60),a=this.time+o,void c.wake()):i},c.useRAF=function(t){return arguments.length?(c.sleep(),d=t,void c.fps(i)):d},c.fps(t),setTimeout(function(){"auto"===d&&c.frame<5&&"hidden"!==n.visibilityState&&c.useRAF(!1)},1500)}),a=u.Ticker.prototype=new u.events.EventDispatcher,a.constructor=u.Ticker;var O=_("core.Animation",function(t,e){if(this.vars=e=e||{},this._duration=this._totalDuration=t||0,this._delay=Number(e.delay)||0,this._timeScale=1,this._active=e.immediateRender===!0,this.data=e.data,this._reversed=e.reversed===!0,G){h||l.wake();var i=this.vars.useFrames?V:G;i.add(this,i._time),this.vars.paused&&this.paused(!0)}});l=O.ticker=new u.Ticker,a=O.prototype,a._dirty=a._gc=a._initted=a._paused=!1,a._totalTime=a._time=0,a._rawPrevTime=-1,a._next=a._last=a._onUpdate=a._timeline=a.timeline=null,a._paused=!1;var A=function(){h&&k()-E>2e3&&("hidden"!==n.visibilityState||!l.lagSmoothing())&&l.wake();var t=setTimeout(A,2e3);t.unref&&t.unref()};A(),a.play=function(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},a.pause=function(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},a.resume=function(t,e){return null!=t&&this.seek(t,e),this.paused(!1)},a.seek=function(t,e){return this.totalTime(Number(t),e!==!1)},a.restart=function(t,e){return this.reversed(!1).paused(!1).totalTime(t?-this._delay:0,e!==!1,!0)},a.reverse=function(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},a.render=function(t,e,i){},a.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,!this._gc&&this.timeline||this._enabled(!0),this},a.isActive=function(){var t,e=this._timeline,i=this._startTime;return!e||!this._gc&&!this._paused&&e.isActive()&&(t=e.rawTime(!0))>=i&&t<i+this.totalDuration()/this._timeScale-1e-7},a._enabled=function(t,e){return h||l.wake(),this._gc=!t,this._active=this.isActive(),e!==!0&&(t&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!t&&this.timeline&&this._timeline._remove(this,!0)),!1},a._kill=function(t,e){return this._enabled(!1,!1)},a.kill=function(t,e){return this._kill(t,e),this},a._uncache=function(t){for(var e=t?this:this.timeline;e;)e._dirty=!0,e=e.timeline;return this},a._swapSelfInParams=function(t){for(var e=t.length,i=t.concat();--e>-1;)"{self}"===t[e]&&(i[e]=this);return i},a._callback=function(t){var e=this.vars,i=e[t],n=e[t+"Params"],r=e[t+"Scope"]||e.callbackScope||this,s=n?n.length:0;switch(s){case 0:i.call(r);break;case 1:i.call(r,n[0]);break;case 2:i.call(r,n[0],n[1]);break;default:i.apply(r,n)}},a.eventCallback=function(t,e,i,n){if("on"===(t||"").substr(0,2)){var r=this.vars;if(1===arguments.length)return r[t];null==e?delete r[t]:(r[t]=e,r[t+"Params"]=m(i)&&i.join("").indexOf("{self}")!==-1?this._swapSelfInParams(i):i,r[t+"Scope"]=n),"onUpdate"===t&&(this._onUpdate=e)}return this},a.delay=function(t){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+t-this._delay),this._delay=t,this):this._delay},a.duration=function(t){return arguments.length?(this._duration=this._totalDuration=t,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==t&&this.totalTime(this._totalTime*(t/this._duration),!0),this):(this._dirty=!1,this._duration)},a.totalDuration=function(t){return this._dirty=!1,arguments.length?this.duration(t):this._totalDuration},a.time=function(t,e){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(t>this._duration?this._duration:t,e)):this._time},a.totalTime=function(t,e,i){if(h||l.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(t<0&&!i&&(t+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var n=this._totalDuration,r=this._timeline;if(t>n&&!i&&(t=n),this._startTime=(this._paused?this._pauseTime:r._time)-(this._reversed?n-t:t)/this._timeScale,r._dirty||this._uncache(!1),r._timeline)for(;r._timeline;)r._timeline._time!==(r._startTime+r._totalTime)/r._timeScale&&r.totalTime(r._totalTime,!0),r=r._timeline}this._gc&&this._enabled(!0,!1),this._totalTime===t&&0!==this._duration||(R.length&&$(),this.render(t,e,!1),R.length&&$())}return this},a.progress=a.totalProgress=function(t,e){var i=this.duration();return arguments.length?this.totalTime(i*t,e):i?this._time/i:this.ratio},a.startTime=function(t){return arguments.length?(t!==this._startTime&&(this._startTime=t,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,t-this._delay)),this):this._startTime},a.endTime=function(t){return this._startTime+(0!=t?this.totalDuration():this.duration())/this._timeScale},a.timeScale=function(t){if(!arguments.length)return this._timeScale;var e,i;for(t=t||f,this._timeline&&this._timeline.smoothChildTiming&&(e=this._pauseTime,i=e||0===e?e:this._timeline.totalTime(),this._startTime=i-(i-this._startTime)*this._timeScale/t),this._timeScale=t,i=this.timeline;i&&i.timeline;)i._dirty=!0,i.totalDuration(),i=i.timeline;return this},a.reversed=function(t){return arguments.length?(t!=this._reversed&&(this._reversed=t,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},a.paused=function(t){if(!arguments.length)return this._paused;var e,i,n=this._timeline;return t!=this._paused&&n&&(h||t||l.wake(),e=n.rawTime(),i=e-this._pauseTime,!t&&n.smoothChildTiming&&(this._startTime+=i,this._uncache(!1)),this._pauseTime=t?e:null,this._paused=t,this._active=this.isActive(),!t&&0!==i&&this._initted&&this.duration()&&(e=n.smoothChildTiming?this._totalTime:(e-this._startTime)/this._timeScale,this.render(e,e===this._totalTime,!0))),this._gc&&!t&&this._enabled(!0,!1),this};var D=_("core.SimpleTimeline",function(t){O.call(this,0,t),this.autoRemoveChildren=this.smoothChildTiming=!0});a=D.prototype=new O,a.constructor=D,a.kill()._gc=!1,a._first=a._last=a._recent=null,a._sortChildren=!1,a.add=a.insert=function(t,e,i,n){var r,s;if(t._startTime=Number(e||0)+t._delay,t._paused&&this!==t._timeline&&(t._pauseTime=t._startTime+(this.rawTime()-t._startTime)/t._timeScale),t.timeline&&t.timeline._remove(t,!0),t.timeline=t._timeline=this,t._gc&&t._enabled(!0,!0),r=this._last,this._sortChildren)for(s=t._startTime;r&&r._startTime>s;)r=r._prev;return r?(t._next=r._next,r._next=t):(t._next=this._first,this._first=t),t._next?t._next._prev=t:this._last=t,t._prev=r,this._recent=t,this._timeline&&this._uncache(!0),this},a._remove=function(t,e){return t.timeline===this&&(e||t._enabled(!1,!0),t._prev?t._prev._next=t._next:this._first===t&&(this._first=t._next),t._next?t._next._prev=t._prev:this._last===t&&(this._last=t._prev),t._next=t._prev=t.timeline=null,t===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},a.render=function(t,e,i){var n,r=this._first;for(this._totalTime=this._time=this._rawPrevTime=t;r;)n=r._next,(r._active||t>=r._startTime&&!r._paused&&!r._gc)&&(r._reversed?r.render((r._dirty?r.totalDuration():r._totalDuration)-(t-r._startTime)*r._timeScale,e,i):r.render((t-r._startTime)*r._timeScale,e,i)),r=n},a.rawTime=function(){return h||l.wake(),this._totalTime};var M=_("TweenLite",function(e,i,n){if(O.call(this,i,n),this.render=M.prototype.render,null==e)throw"Cannot tween a null target.";this.target=e="string"!=typeof e?e:M.selector(e)||e;var r,s,o,a=e.jquery||e.length&&e!==t&&e[0]&&(e[0]===t||e[0].nodeType&&e[0].style&&!e.nodeType),l=this.vars.overwrite;if(this._overwrite=l=null==l?Z[M.defaultOverwrite]:"number"==typeof l?l>>0:Z[l],(a||e instanceof Array||e.push&&m(e))&&"number"!=typeof e[0])for(this._targets=o=d(e),this._propLookup=[],this._siblings=[],r=0;r<o.length;r++)s=o[r],s?"string"!=typeof s?s.length&&s!==t&&s[0]&&(s[0]===t||s[0].nodeType&&s[0].style&&!s.nodeType)?(o.splice(r--,1),this._targets=o=o.concat(d(s))):(this._siblings[r]=K(s,this,!1),1===l&&this._siblings[r].length>1&&tt(s,this,null,1,this._siblings[r])):(s=o[r--]=M.selector(s),"string"==typeof s&&o.splice(r+1,1)):o.splice(r--,1);else this._propLookup={},this._siblings=K(e,this,!1),1===l&&this._siblings.length>1&&tt(e,this,null,1,this._siblings);(this.vars.immediateRender||0===i&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-f,this.render(Math.min(0,-this._delay)))},!0),z=function(e){return e&&e.length&&e!==t&&e[0]&&(e[0]===t||e[0].nodeType&&e[0].style&&!e.nodeType)},L=function(t,e){var i,n={};for(i in t)H[i]||i in e&&"transform"!==i&&"x"!==i&&"y"!==i&&"width"!==i&&"height"!==i&&"className"!==i&&"border"!==i||!(!W[i]||W[i]&&W[i]._autoCSS)||(n[i]=t[i],delete t[i]);t.css=n};a=M.prototype=new O,a.constructor=M,a.kill()._gc=!1,a.ratio=0,a._firstPT=a._targets=a._overwrittenProps=a._startAt=null,a._notifyPluginsOfEnabled=a._lazy=!1,M.version="1.20.3",M.defaultEase=a._ease=new w(null,null,1,1),M.defaultOverwrite="auto",M.ticker=l,M.autoSleep=120,M.lagSmoothing=function(t,e){l.lagSmoothing(t,e)},M.selector=t.$||t.jQuery||function(e){var i=t.$||t.jQuery;return i?(M.selector=i,i(e)):"undefined"==typeof n?e:n.querySelectorAll?n.querySelectorAll(e):n.getElementById("#"===e.charAt(0)?e.substr(1):e)};var R=[],I={},F=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,N=/[\+-]=-?[\.\d]/,X=function(t){for(var e,i=this._firstPT,n=1e-6;i;)e=i.blob?1===t&&null!=this.end?this.end:t?this.join(""):this.start:i.c*t+i.s,i.m?e=i.m(e,this._target||i.t):e<n&&e>-n&&!i.blob&&(e=0),i.f?i.fp?i.t[i.p](i.fp,e):i.t[i.p](e):i.t[i.p]=e,i=i._next},j=function(t,e,i,n){var r,s,o,a,l,h,c,u=[],f=0,d="",p=0;for(u.start=t,u.end=e,t=u[0]=t+"",e=u[1]=e+"",i&&(i(u),t=u[0],e=u[1]),u.length=0,r=t.match(F)||[],s=e.match(F)||[],n&&(n._next=null,n.blob=1,u._firstPT=u._applyPT=n),l=s.length,a=0;a<l;a++)c=s[a],h=e.substr(f,e.indexOf(c,f)-f),d+=h||!a?h:",",f+=h.length,p?p=(p+1)%5:"rgba("===h.substr(-5)&&(p=1),c===r[a]||r.length<=a?d+=c:(d&&(u.push(d),d=""),o=parseFloat(r[a]),u.push(o),u._firstPT={_next:u._firstPT,t:u,p:u.length-1,s:o,c:("="===c.charAt(1)?parseInt(c.charAt(0)+"1",10)*parseFloat(c.substr(2)):parseFloat(c)-o)||0,f:0,m:p&&p<4?Math.round:0}),f+=c.length;return d+=e.substr(f),d&&u.push(d),u.setRatio=X,N.test(e)&&(u.end=null),u},B=function(t,e,i,n,r,s,o,a,l){"function"==typeof n&&(n=n(l||0,t));var h,c=typeof t[e],u="function"!==c?"":e.indexOf("set")||"function"!=typeof t["get"+e.substr(3)]?e:"get"+e.substr(3),f="get"!==i?i:u?o?t[u](o):t[u]():t[e],d="string"==typeof n&&"="===n.charAt(1),p={t:t,p:e,s:f,f:"function"===c,pg:0,n:r||e,m:s?"function"==typeof s?s:Math.round:0,pr:0,c:d?parseInt(n.charAt(0)+"1",10)*parseFloat(n.substr(2)):parseFloat(n)-f||0};if(("number"!=typeof f||"number"!=typeof n&&!d)&&(o||isNaN(f)||!d&&isNaN(n)||"boolean"==typeof f||"boolean"==typeof n?(p.fp=o,h=j(f,d?parseFloat(p.s)+p.c:n,a||M.defaultStringFilter,p),p={t:h,p:"setRatio",s:0,c:1,f:2,pg:0,n:r||e,pr:0,m:0}):(p.s=parseFloat(f),d||(p.c=parseFloat(n)-p.s||0))),p.c)return(p._next=this._firstPT)&&(p._next._prev=p),this._firstPT=p,p},U=M._internals={isArray:m,isSelector:z,lazyTweens:R,blobDif:j},W=M._plugins={},Y=U.tweenLookup={},q=0,H=U.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1,yoyoEase:1},Z={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},V=O._rootFramesTimeline=new D,G=O._rootTimeline=new D,Q=30,$=U.lazyRender=function(){var t,e=R.length;for(I={};--e>-1;)t=R[e],t&&t._lazy!==!1&&(t.render(t._lazy[0],t._lazy[1],!0),t._lazy=!1);R.length=0};G._startTime=l.time,V._startTime=l.frame,G._active=V._active=!0,setTimeout($,1),O._updateRoot=M.render=function(){var t,e,i;if(R.length&&$(),G.render((l.time-G._startTime)*G._timeScale,!1,!1),V.render((l.frame-V._startTime)*V._timeScale,!1,!1),R.length&&$(),l.frame>=Q){Q=l.frame+(parseInt(M.autoSleep,10)||120);for(i in Y){for(e=Y[i].tweens,t=e.length;--t>-1;)e[t]._gc&&e.splice(t,1);0===e.length&&delete Y[i]}if(i=G._first,(!i||i._paused)&&M.autoSleep&&!V._first&&1===l._listeners.tick.length){for(;i&&i._paused;)i=i._next;i||l.sleep()}}},l.addEventListener("tick",O._updateRoot);var K=function(t,e,i){var n,r,s=t._gsTweenID;if(Y[s||(t._gsTweenID=s="t"+q++)]||(Y[s]={target:t,tweens:[]}),e&&(n=Y[s].tweens,n[r=n.length]=e,i))for(;--r>-1;)n[r]===e&&n.splice(r,1);return Y[s].tweens},J=function(t,e,i,n){var r,s,o=t.vars.onOverwrite;return o&&(r=o(t,e,i,n)),o=M.onOverwrite,o&&(s=o(t,e,i,n)),r!==!1&&s!==!1},tt=function(t,e,i,n,r){var s,o,a,l;if(1===n||n>=4){for(l=r.length,s=0;s<l;s++)if((a=r[s])!==e)a._gc||a._kill(null,t,e)&&(o=!0);else if(5===n)break;return o}var h,c=e._startTime+f,u=[],d=0,p=0===e._duration;for(s=r.length;--s>-1;)(a=r[s])===e||a._gc||a._paused||(a._timeline!==e._timeline?(h=h||et(e,0,p),0===et(a,h,p)&&(u[d++]=a)):a._startTime<=c&&a._startTime+a.totalDuration()/a._timeScale>c&&((p||!a._initted)&&c-a._startTime<=2e-10||(u[d++]=a)));for(s=d;--s>-1;)if(a=u[s],2===n&&a._kill(i,t,e)&&(o=!0),2!==n||!a._firstPT&&a._initted){if(2!==n&&!J(a,e))continue;a._enabled(!1,!1)&&(o=!0)}return o},et=function(t,e,i){for(var n=t._timeline,r=n._timeScale,s=t._startTime;n._timeline;){if(s+=n._startTime,r*=n._timeScale,n._paused)return-100;n=n._timeline}return s/=r,s>e?s-e:i&&s===e||!t._initted&&s-e<2*f?f:(s+=t.totalDuration()/t._timeScale/r)>e+f?0:s-e-f};a._init=function(){var t,e,i,n,r,s,o=this.vars,a=this._overwrittenProps,l=this._duration,h=!!o.immediateRender,c=o.ease;if(o.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),r={};for(n in o.startAt)r[n]=o.startAt[n];if(r.data="isStart",r.overwrite=!1,r.immediateRender=!0,r.lazy=h&&o.lazy!==!1,r.startAt=r.delay=null,r.onUpdate=o.onUpdate,r.onUpdateParams=o.onUpdateParams,r.onUpdateScope=o.onUpdateScope||o.callbackScope||this,this._startAt=M.to(this.target,0,r),h)if(this._time>0)this._startAt=null;else if(0!==l)return}else if(o.runBackwards&&0!==l)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(h=!1),i={};for(n in o)H[n]&&"autoCSS"!==n||(i[n]=o[n]);if(i.overwrite=0,i.data="isFromStart",i.lazy=h&&o.lazy!==!1,i.immediateRender=h,this._startAt=M.to(this.target,0,i),h){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=c=c?c instanceof w?c:"function"==typeof c?new w(c,o.easeParams):b[c]||M.defaultEase:M.defaultEase,o.easeParams instanceof Array&&c.config&&(this._ease=c.config.apply(c,o.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(s=this._targets.length,t=0;t<s;t++)this._initProps(this._targets[t],this._propLookup[t]={},this._siblings[t],a?a[t]:null,t)&&(e=!0);else e=this._initProps(this.target,this._propLookup,this._siblings,a,0);if(e&&M._onPluginEvent("_onInitAllProps",this),a&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),o.runBackwards)for(i=this._firstPT;i;)i.s+=i.c,i.c=-i.c,i=i._next;this._onUpdate=o.onUpdate,this._initted=!0},a._initProps=function(e,i,n,r,s){var o,a,l,h,c,u;if(null==e)return!1;I[e._gsTweenID]&&$(),this.vars.css||e.style&&e!==t&&e.nodeType&&W.css&&this.vars.autoCSS!==!1&&L(this.vars,e);for(o in this.vars)if(u=this.vars[o],H[o])u&&(u instanceof Array||u.push&&m(u))&&u.join("").indexOf("{self}")!==-1&&(this.vars[o]=u=this._swapSelfInParams(u,this));else if(W[o]&&(h=new W[o])._onInitTween(e,this.vars[o],this,s)){for(this._firstPT=c={_next:this._firstPT,t:h,p:"setRatio",s:0,c:1,f:1,n:o,pg:1,pr:h._priority,m:0},a=h._overwriteProps.length;--a>-1;)i[h._overwriteProps[a]]=this._firstPT;(h._priority||h._onInitAllProps)&&(l=!0),(h._onDisable||h._onEnable)&&(this._notifyPluginsOfEnabled=!0),c._next&&(c._next._prev=c)}else i[o]=B.call(this,e,o,"get",u,o,0,null,this.vars.stringFilter,s);return r&&this._kill(r,e)?this._initProps(e,i,n,r,s):this._overwrite>1&&this._firstPT&&n.length>1&&tt(e,this,i,this._overwrite,n)?(this._kill(i,e),this._initProps(e,i,n,r,s)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(I[e._gsTweenID]=!0),l)},a.render=function(t,e,i){var n,r,s,o,a=this._time,l=this._duration,h=this._rawPrevTime;if(t>=l-1e-7&&t>=0)this._totalTime=this._time=l,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(n=!0,r="onComplete",i=i||this._timeline.autoRemoveChildren),0===l&&(this._initted||!this.vars.lazy||i)&&(this._startTime===this._timeline._duration&&(t=0),(h<0||t<=0&&t>=-1e-7||h===f&&"isPause"!==this.data)&&h!==t&&(i=!0,h>f&&(r="onReverseComplete")),this._rawPrevTime=o=!e||t||h===t?t:f);else if(t<1e-7)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==a||0===l&&h>0)&&(r="onReverseComplete",n=this._reversed),t<0&&(this._active=!1,0===l&&(this._initted||!this.vars.lazy||i)&&(h>=0&&(h!==f||"isPause"!==this.data)&&(i=!0),this._rawPrevTime=o=!e||t||h===t?t:f)),(!this._initted||this._startAt&&this._startAt.progress())&&(i=!0);else if(this._totalTime=this._time=t,this._easeType){var c=t/l,u=this._easeType,d=this._easePower;(1===u||3===u&&c>=.5)&&(c=1-c),3===u&&(c*=2),1===d?c*=c:2===d?c*=c*c:3===d?c*=c*c*c:4===d&&(c*=c*c*c*c),1===u?this.ratio=1-c:2===u?this.ratio=c:t/l<.5?this.ratio=c/2:this.ratio=1-c/2}else this.ratio=this._ease.getRatio(t/l);if(this._time!==a||i){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!i&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=a,this._rawPrevTime=h,R.push(this),void(this._lazy=[t,e]);this._time&&!n?this.ratio=this._ease.getRatio(this._time/l):n&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==a&&t>=0&&(this._active=!0),0===a&&(this._startAt&&(t>=0?this._startAt.render(t,!0,i):r||(r="_dummyGS")),this.vars.onStart&&(0===this._time&&0!==l||e||this._callback("onStart"))),s=this._firstPT;s;)s.f?s.t[s.p](s.c*this.ratio+s.s):s.t[s.p]=s.c*this.ratio+s.s,s=s._next;this._onUpdate&&(t<0&&this._startAt&&t!==-1e-4&&this._startAt.render(t,!0,i),e||(this._time!==a||n||i)&&this._callback("onUpdate")),r&&(this._gc&&!i||(t<0&&this._startAt&&!this._onUpdate&&t!==-1e-4&&this._startAt.render(t,!0,i),n&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!e&&this.vars[r]&&this._callback(r),0===l&&this._rawPrevTime===f&&o!==f&&(this._rawPrevTime=0)))}},a._kill=function(t,e,i){if("all"===t&&(t=null),null==t&&(null==e||e===this.target))return this._lazy=!1,this._enabled(!1,!1);e="string"!=typeof e?e||this._targets||this.target:M.selector(e)||e;var n,r,s,o,a,l,h,c,u,f=i&&this._time&&i._startTime===this._startTime&&this._timeline===i._timeline;if((m(e)||z(e))&&"number"!=typeof e[0])for(n=e.length;--n>-1;)this._kill(t,e[n],i)&&(l=!0);else{if(this._targets){for(n=this._targets.length;--n>-1;)if(e===this._targets[n]){a=this._propLookup[n]||{},this._overwrittenProps=this._overwrittenProps||[],r=this._overwrittenProps[n]=t?this._overwrittenProps[n]||{}:"all";break}}else{if(e!==this.target)return!1;a=this._propLookup,r=this._overwrittenProps=t?this._overwrittenProps||{}:"all"}if(a){if(h=t||a,c=t!==r&&"all"!==r&&t!==a&&("object"!=typeof t||!t._tempKill),i&&(M.onOverwrite||this.vars.onOverwrite)){for(s in h)a[s]&&(u||(u=[]),u.push(s));if((u||!t)&&!J(this,i,e,u))return!1}for(s in h)(o=a[s])&&(f&&(o.f?o.t[o.p](o.s):o.t[o.p]=o.s,l=!0),o.pg&&o.t._kill(h)&&(l=!0),o.pg&&0!==o.t._overwriteProps.length||(o._prev?o._prev._next=o._next:o===this._firstPT&&(this._firstPT=o._next),o._next&&(o._next._prev=o._prev),o._next=o._prev=null),delete a[s]),c&&(r[s]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return l},a.invalidate=function(){return this._notifyPluginsOfEnabled&&M._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],O.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-f,this.render(Math.min(0,-this._delay))),this},a._enabled=function(t,e){if(h||l.wake(),t&&this._gc){var i,n=this._targets;if(n)for(i=n.length;--i>-1;)this._siblings[i]=K(n[i],this,!0);else this._siblings=K(this.target,this,!0)}return O.prototype._enabled.call(this,t,e),!(!this._notifyPluginsOfEnabled||!this._firstPT)&&M._onPluginEvent(t?"_onEnable":"_onDisable",this)},M.to=function(t,e,i){return new M(t,e,i)},M.from=function(t,e,i){return i.runBackwards=!0,i.immediateRender=0!=i.immediateRender,new M(t,e,i)},M.fromTo=function(t,e,i,n){return n.startAt=i,n.immediateRender=0!=n.immediateRender&&0!=i.immediateRender,new M(t,e,n)},M.delayedCall=function(t,e,i,n,r){return new M(e,0,{delay:t,onComplete:e,onCompleteParams:i,callbackScope:n,onReverseComplete:e,onReverseCompleteParams:i,immediateRender:!1,lazy:!1,useFrames:r,overwrite:0})},M.set=function(t,e){return new M(t,0,e)},M.getTweensOf=function(t,e){if(null==t)return[];t="string"!=typeof t?t:M.selector(t)||t;var i,n,r,s;if((m(t)||z(t))&&"number"!=typeof t[0]){for(i=t.length,n=[];--i>-1;)n=n.concat(M.getTweensOf(t[i],e));for(i=n.length;--i>-1;)for(s=n[i],r=i;--r>-1;)s===n[r]&&n.splice(i,1)}else if(t._gsTweenID)for(n=K(t).concat(),i=n.length;--i>-1;)(n[i]._gc||e&&!n[i].isActive())&&n.splice(i,1);return n||[]},M.killTweensOf=M.killDelayedCallsTo=function(t,e,i){"object"==typeof e&&(i=e,e=!1);for(var n=M.getTweensOf(t,e),r=n.length;--r>-1;)n[r]._kill(i,t)};var it=_("plugins.TweenPlugin",function(t,e){this._overwriteProps=(t||"").split(","),this._propName=this._overwriteProps[0],this._priority=e||0,this._super=it.prototype},!0);if(a=it.prototype,it.version="1.19.0",it.API=2,a._firstPT=null,a._addTween=B,a.setRatio=X,a._kill=function(t){var e,i=this._overwriteProps,n=this._firstPT;if(null!=t[this._propName])this._overwriteProps=[];else for(e=i.length;--e>-1;)null!=t[i[e]]&&i.splice(e,1);for(;n;)null!=t[n.n]&&(n._next&&(n._next._prev=n._prev),n._prev?(n._prev._next=n._next,n._prev=null):this._firstPT===n&&(this._firstPT=n._next)),n=n._next;return!1},a._mod=a._roundProps=function(t){for(var e,i=this._firstPT;i;)e=t[this._propName]||null!=i.n&&t[i.n.split(this._propName+"_").join("")],e&&"function"==typeof e&&(2===i.f?i.t._applyPT.m=e:i.m=e),i=i._next},M._onPluginEvent=function(t,e){var i,n,r,s,o,a=e._firstPT;if("_onInitAllProps"===t){for(;a;){for(o=a._next,n=r;n&&n.pr>a.pr;)n=n._next;(a._prev=n?n._prev:s)?a._prev._next=a:r=a,(a._next=n)?n._prev=a:s=a,a=o}a=e._firstPT=r}for(;a;)a.pg&&"function"==typeof a.t[t]&&a.t[t]()&&(i=!0),a=a._next;return i},it.activate=function(t){for(var e=t.length;--e>-1;)t[e].API===it.API&&(W[(new t[e])._propName]=t[e]);return!0},y.plugin=function(t){if(!(t&&t.propName&&t.init&&t.API))throw"illegal plugin definition.";var e,i=t.propName,n=t.priority||0,r=t.overwriteProps,s={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},o=_("plugins."+i.charAt(0).toUpperCase()+i.substr(1)+"Plugin",function(){it.call(this,i,n),this._overwriteProps=r||[]},t.global===!0),a=o.prototype=new it(i);a.constructor=o,o.API=t.API;for(e in s)"function"==typeof t[e]&&(a[s[e]]=t[e]);return o.version=t.version,it.activate([o]),o},s=t._gsQueue){for(o=0;o<s.length;o++)s[o]();for(a in g)g[a].func||t.console.log("GSAP encountered missing dependency: "+a)}h=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenLite");var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(t,e,i){var n=function(t){e.call(this,t),this._labels={},this.autoRemoveChildren=this.vars.autoRemoveChildren===!0,this.smoothChildTiming=this.vars.smoothChildTiming===!0,this._sortChildren=!0,this._onUpdate=this.vars.onUpdate;var i,n,r=this.vars;for(n in r)i=r[n],l(i)&&i.join("").indexOf("{self}")!==-1&&(r[n]=this._swapSelfInParams(i));l(r.tweens)&&this.add(r.tweens,0,r.align,r.stagger)},r=1e-10,s=i._internals,o=n._internals={},a=s.isSelector,l=s.isArray,h=s.lazyTweens,c=s.lazyRender,u=_gsScope._gsDefine.globals,f=function(t){var e,i={};for(e in t)i[e]=t[e];return i},d=function(t,e,i){var n,r,s=t.cycle;for(n in s)r=s[n],t[n]="function"==typeof r?r(i,e[i]):r[i%r.length];delete t.cycle},p=o.pauseCallback=function(){},m=function(t){var e,i=[],n=t.length;for(e=0;e!==n;i.push(t[e++]));return i},g=n.prototype=new e;return n.version="1.20.3",g.constructor=n,g.kill()._gc=g._forcingPlayhead=g._hasPause=!1,g.to=function(t,e,n,r){var s=n.repeat&&u.TweenMax||i;return e?this.add(new s(t,e,n),r):this.set(t,n,r)},g.from=function(t,e,n,r){return this.add((n.repeat&&u.TweenMax||i).from(t,e,n),r)},g.fromTo=function(t,e,n,r,s){var o=r.repeat&&u.TweenMax||i;return e?this.add(o.fromTo(t,e,n,r),s):this.set(t,r,s)},g.staggerTo=function(t,e,r,s,o,l,h,c){var u,p,g=new n({onComplete:l,onCompleteParams:h,callbackScope:c,smoothChildTiming:this.smoothChildTiming}),v=r.cycle;for("string"==typeof t&&(t=i.selector(t)||t),t=t||[],a(t)&&(t=m(t)),s=s||0,s<0&&(t=m(t),t.reverse(),s*=-1),p=0;p<t.length;p++)u=f(r),u.startAt&&(u.startAt=f(u.startAt),u.startAt.cycle&&d(u.startAt,t,p)),v&&(d(u,t,p),null!=u.duration&&(e=u.duration,delete u.duration)),g.to(t[p],e,u,p*s);return this.add(g,o)},g.staggerFrom=function(t,e,i,n,r,s,o,a){return i.immediateRender=0!=i.immediateRender,i.runBackwards=!0,this.staggerTo(t,e,i,n,r,s,o,a)},g.staggerFromTo=function(t,e,i,n,r,s,o,a,l){return n.startAt=i,n.immediateRender=0!=n.immediateRender&&0!=i.immediateRender,this.staggerTo(t,e,n,r,s,o,a,l)},g.call=function(t,e,n,r){return this.add(i.delayedCall(0,t,e,n),r)},g.set=function(t,e,n){return n=this._parseTimeOrLabel(n,0,!0),null==e.immediateRender&&(e.immediateRender=n===this._time&&!this._paused),this.add(new i(t,0,e),n)},n.exportRoot=function(t,e){t=t||{},null==t.smoothChildTiming&&(t.smoothChildTiming=!0);var r,s,o,a,l=new n(t),h=l._timeline;for(null==e&&(e=!0),h._remove(l,!0),l._startTime=0,l._rawPrevTime=l._time=l._totalTime=h._time,
o=h._first;o;)a=o._next,e&&o instanceof i&&o.target===o.vars.onComplete||(s=o._startTime-o._delay,s<0&&(r=1),l.add(o,s)),o=a;return h.add(l,0),r&&l.totalDuration(),l},g.add=function(r,s,o,a){var h,c,u,f,d,p;if("number"!=typeof s&&(s=this._parseTimeOrLabel(s,0,!0,r)),!(r instanceof t)){if(r instanceof Array||r&&r.push&&l(r)){for(o=o||"normal",a=a||0,h=s,c=r.length,u=0;u<c;u++)l(f=r[u])&&(f=new n({tweens:f})),this.add(f,h),"string"!=typeof f&&"function"!=typeof f&&("sequence"===o?h=f._startTime+f.totalDuration()/f._timeScale:"start"===o&&(f._startTime-=f.delay())),h+=a;return this._uncache(!0)}if("string"==typeof r)return this.addLabel(r,s);if("function"!=typeof r)throw"Cannot add "+r+" into the timeline; it is not a tween, timeline, function, or string.";r=i.delayedCall(0,r)}if(e.prototype.add.call(this,r,s),r._time&&r.render((this.rawTime()-r._startTime)*r._timeScale,!1,!1),(this._gc||this._time===this._duration)&&!this._paused&&this._duration<this.duration())for(d=this,p=d.rawTime()>r._startTime;d._timeline;)p&&d._timeline.smoothChildTiming?d.totalTime(d._totalTime,!0):d._gc&&d._enabled(!0,!1),d=d._timeline;return this},g.remove=function(e){if(e instanceof t){this._remove(e,!1);var i=e._timeline=e.vars.useFrames?t._rootFramesTimeline:t._rootTimeline;return e._startTime=(e._paused?e._pauseTime:i._time)-(e._reversed?e.totalDuration()-e._totalTime:e._totalTime)/e._timeScale,this}if(e instanceof Array||e&&e.push&&l(e)){for(var n=e.length;--n>-1;)this.remove(e[n]);return this}return"string"==typeof e?this.removeLabel(e):this.kill(null,e)},g._remove=function(t,i){e.prototype._remove.call(this,t,i);var n=this._last;return n?this._time>this.duration()&&(this._time=this._duration,this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},g.append=function(t,e){return this.add(t,this._parseTimeOrLabel(null,e,!0,t))},g.insert=g.insertMultiple=function(t,e,i,n){return this.add(t,e||0,i,n)},g.appendMultiple=function(t,e,i,n){return this.add(t,this._parseTimeOrLabel(null,e,!0,t),i,n)},g.addLabel=function(t,e){return this._labels[t]=this._parseTimeOrLabel(e),this},g.addPause=function(t,e,n,r){var s=i.delayedCall(0,p,n,r||this);return s.vars.onComplete=s.vars.onReverseComplete=e,s.data="isPause",this._hasPause=!0,this.add(s,t)},g.removeLabel=function(t){return delete this._labels[t],this},g.getLabelTime=function(t){return null!=this._labels[t]?this._labels[t]:-1},g._parseTimeOrLabel=function(e,i,n,r){var s,o;if(r instanceof t&&r.timeline===this)this.remove(r);else if(r&&(r instanceof Array||r.push&&l(r)))for(o=r.length;--o>-1;)r[o]instanceof t&&r[o].timeline===this&&this.remove(r[o]);if(s="number"!=typeof e||i?this.duration()>99999999999?this.recent().endTime(!1):this._duration:0,"string"==typeof i)return this._parseTimeOrLabel(i,n&&"number"==typeof e&&null==this._labels[i]?e-s:0,n);if(i=i||0,"string"!=typeof e||!isNaN(e)&&null==this._labels[e])null==e&&(e=s);else{if(o=e.indexOf("="),o===-1)return null==this._labels[e]?n?this._labels[e]=s+i:i:this._labels[e]+i;i=parseInt(e.charAt(o-1)+"1",10)*Number(e.substr(o+1)),e=o>1?this._parseTimeOrLabel(e.substr(0,o-1),0,n):s}return Number(e)+i},g.seek=function(t,e){return this.totalTime("number"==typeof t?t:this._parseTimeOrLabel(t),e!==!1)},g.stop=function(){return this.paused(!0)},g.gotoAndPlay=function(t,e){return this.play(t,e)},g.gotoAndStop=function(t,e){return this.pause(t,e)},g.render=function(t,e,i){this._gc&&this._enabled(!0,!1);var n,s,o,a,l,u,f,d=this._time,p=this._dirty?this.totalDuration():this._totalDuration,m=this._startTime,g=this._timeScale,v=this._paused;if(d!==this._time&&(t+=this._time-d),t>=p-1e-7&&t>=0)this._totalTime=this._time=p,this._reversed||this._hasPausedChild()||(s=!0,a="onComplete",l=!!this._timeline.autoRemoveChildren,0===this._duration&&(t<=0&&t>=-1e-7||this._rawPrevTime<0||this._rawPrevTime===r)&&this._rawPrevTime!==t&&this._first&&(l=!0,this._rawPrevTime>r&&(a="onReverseComplete"))),this._rawPrevTime=this._duration||!e||t||this._rawPrevTime===t?t:r,t=p+1e-4;else if(t<1e-7)if(this._totalTime=this._time=0,(0!==d||0===this._duration&&this._rawPrevTime!==r&&(this._rawPrevTime>0||t<0&&this._rawPrevTime>=0))&&(a="onReverseComplete",s=this._reversed),t<0)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(l=s=!0,a="onReverseComplete"):this._rawPrevTime>=0&&this._first&&(l=!0),this._rawPrevTime=t;else{if(this._rawPrevTime=this._duration||!e||t||this._rawPrevTime===t?t:r,0===t&&s)for(n=this._first;n&&0===n._startTime;)n._duration||(s=!1),n=n._next;t=0,this._initted||(l=!0)}else{if(this._hasPause&&!this._forcingPlayhead&&!e){if(t>=d)for(n=this._first;n&&n._startTime<=t&&!u;)n._duration||"isPause"!==n.data||n.ratio||0===n._startTime&&0===this._rawPrevTime||(u=n),n=n._next;else for(n=this._last;n&&n._startTime>=t&&!u;)n._duration||"isPause"===n.data&&n._rawPrevTime>0&&(u=n),n=n._prev;u&&(this._time=t=u._startTime,this._totalTime=t+this._cycle*(this._totalDuration+this._repeatDelay))}this._totalTime=this._time=this._rawPrevTime=t}if(this._time!==d&&this._first||i||l||u){if(this._initted||(this._initted=!0),this._active||!this._paused&&this._time!==d&&t>0&&(this._active=!0),0===d&&this.vars.onStart&&(0===this._time&&this._duration||e||this._callback("onStart")),f=this._time,f>=d)for(n=this._first;n&&(o=n._next,f===this._time&&(!this._paused||v));)(n._active||n._startTime<=f&&!n._paused&&!n._gc)&&(u===n&&this.pause(),n._reversed?n.render((n._dirty?n.totalDuration():n._totalDuration)-(t-n._startTime)*n._timeScale,e,i):n.render((t-n._startTime)*n._timeScale,e,i)),n=o;else for(n=this._last;n&&(o=n._prev,f===this._time&&(!this._paused||v));){if(n._active||n._startTime<=d&&!n._paused&&!n._gc){if(u===n){for(u=n._prev;u&&u.endTime()>this._time;)u.render(u._reversed?u.totalDuration()-(t-u._startTime)*u._timeScale:(t-u._startTime)*u._timeScale,e,i),u=u._prev;u=null,this.pause()}n._reversed?n.render((n._dirty?n.totalDuration():n._totalDuration)-(t-n._startTime)*n._timeScale,e,i):n.render((t-n._startTime)*n._timeScale,e,i)}n=o}this._onUpdate&&(e||(h.length&&c(),this._callback("onUpdate"))),a&&(this._gc||m!==this._startTime&&g===this._timeScale||(0===this._time||p>=this.totalDuration())&&(s&&(h.length&&c(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!e&&this.vars[a]&&this._callback(a)))}},g._hasPausedChild=function(){for(var t=this._first;t;){if(t._paused||t instanceof n&&t._hasPausedChild())return!0;t=t._next}return!1},g.getChildren=function(t,e,n,r){r=r||-9999999999;for(var s=[],o=this._first,a=0;o;)o._startTime<r||(o instanceof i?e!==!1&&(s[a++]=o):(n!==!1&&(s[a++]=o),t!==!1&&(s=s.concat(o.getChildren(!0,e,n)),a=s.length))),o=o._next;return s},g.getTweensOf=function(t,e){var n,r,s=this._gc,o=[],a=0;for(s&&this._enabled(!0,!0),n=i.getTweensOf(t),r=n.length;--r>-1;)(n[r].timeline===this||e&&this._contains(n[r]))&&(o[a++]=n[r]);return s&&this._enabled(!1,!0),o},g.recent=function(){return this._recent},g._contains=function(t){for(var e=t.timeline;e;){if(e===this)return!0;e=e.timeline}return!1},g.shiftChildren=function(t,e,i){i=i||0;for(var n,r=this._first,s=this._labels;r;)r._startTime>=i&&(r._startTime+=t),r=r._next;if(e)for(n in s)s[n]>=i&&(s[n]+=t);return this._uncache(!0)},g._kill=function(t,e){if(!t&&!e)return this._enabled(!1,!1);for(var i=e?this.getTweensOf(e):this.getChildren(!0,!0,!1),n=i.length,r=!1;--n>-1;)i[n]._kill(t,e)&&(r=!0);return r},g.clear=function(t){var e=this.getChildren(!1,!0,!0),i=e.length;for(this._time=this._totalTime=0;--i>-1;)e[i]._enabled(!1,!1);return t!==!1&&(this._labels={}),this._uncache(!0)},g.invalidate=function(){for(var e=this._first;e;)e.invalidate(),e=e._next;return t.prototype.invalidate.call(this)},g._enabled=function(t,i){if(t===this._gc)for(var n=this._first;n;)n._enabled(t,!0),n=n._next;return e.prototype._enabled.call(this,t,i)},g.totalTime=function(e,i,n){this._forcingPlayhead=!0;var r=t.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,r},g.duration=function(t){return arguments.length?(0!==this.duration()&&0!==t&&this.timeScale(this._duration/t),this):(this._dirty&&this.totalDuration(),this._duration)},g.totalDuration=function(t){if(!arguments.length){if(this._dirty){for(var e,i,n=0,r=this._last,s=999999999999;r;)e=r._prev,r._dirty&&r.totalDuration(),r._startTime>s&&this._sortChildren&&!r._paused&&!this._calculatingDuration?(this._calculatingDuration=1,this.add(r,r._startTime-r._delay),this._calculatingDuration=0):s=r._startTime,r._startTime<0&&!r._paused&&(n-=r._startTime,this._timeline.smoothChildTiming&&(this._startTime+=r._startTime/this._timeScale,this._time-=r._startTime,this._totalTime-=r._startTime,this._rawPrevTime-=r._startTime),this.shiftChildren(-r._startTime,!1,-9999999999),s=0),i=r._startTime+r._totalDuration/r._timeScale,i>n&&(n=i),r=e;this._duration=this._totalDuration=n,this._dirty=!1}return this._totalDuration}return t&&this.totalDuration()?this.timeScale(this._totalDuration/t):this},g.paused=function(e){if(!e)for(var i=this._first,n=this._time;i;)i._startTime===n&&"isPause"===i.data&&(i._rawPrevTime=0),i=i._next;return t.prototype.paused.apply(this,arguments)},g.usesFrames=function(){for(var e=this._timeline;e._timeline;)e=e._timeline;return e===t._rootFramesTimeline},g.rawTime=function(t){return t&&(this._paused||this._repeat&&this.time()>0&&this.totalProgress()<1)?this._totalTime%(this._duration+this._repeatDelay):this._paused?this._totalTime:(this._timeline.rawTime(t)-this._startTime)*this._timeScale},n},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(t){"use strict";var e=function(){return(_gsScope.GreenSockGlobals||_gsScope)[t]};"undefined"!=typeof module&&module.exports?(require("./TweenLite.js"),module.exports=e()):"function"==typeof define&&define.amd&&define(["TweenLite"],e)}("TimelineLite");var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(t,e){var i,n,r,s,o=function(){t.call(this,"css"),this._overwriteProps.length=0,this.setRatio=o.prototype.setRatio},a=_gsScope._gsDefine.globals,l={},h=o.prototype=new t("css");h.constructor=o,o.version="1.20.3",o.API=2,o.defaultTransformPerspective=0,o.defaultSkewType="compensated",o.defaultSmoothOrigin=!0,h="px",o.suffixMap={top:h,right:h,bottom:h,left:h,width:h,height:h,fontSize:h,padding:h,margin:h,perspective:h,lineHeight:""};var c,u,f,d,p,m,g,v,y=/(?:\-|\.|\b)(\d|\.|e\-)+/g,_=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,x=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,w=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,b=/(?:\d|\-|\+|=|#|\.)*/g,T=/opacity *= *([^)]*)/i,S=/opacity:([^;]*)/i,P=/alpha\(opacity *=.+?\)/i,C=/^(rgb|hsl)/,k=/([A-Z])/g,E=/-([a-z])/gi,O=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,A=function(t,e){return e.toUpperCase()},D=/(?:Left|Right|Width)/i,M=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,z=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,L=/,(?=[^\)]*(?:\(|$))/gi,R=/[\s,\(]/i,I=Math.PI/180,F=180/Math.PI,N={},X={style:{}},j=_gsScope.document||{createElement:function(){return X}},B=function(t,e){return j.createElementNS?j.createElementNS(e||"http://www.w3.org/1999/xhtml",t):j.createElement(t)},U=B("div"),W=B("img"),Y=o._internals={_specialProps:l},q=(_gsScope.navigator||{}).userAgent||"",H=function(){var t=q.indexOf("Android"),e=B("a");return f=q.indexOf("Safari")!==-1&&q.indexOf("Chrome")===-1&&(t===-1||parseFloat(q.substr(t+8,2))>3),p=f&&parseFloat(q.substr(q.indexOf("Version/")+8,2))<6,d=q.indexOf("Firefox")!==-1,(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(q)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(q))&&(m=parseFloat(RegExp.$1)),!!e&&(e.style.cssText="top:1px;opacity:.55;",/^0.55/.test(e.style.opacity))}(),Z=function(t){return T.test("string"==typeof t?t:(t.currentStyle?t.currentStyle.filter:t.style.filter)||"")?parseFloat(RegExp.$1)/100:1},V=function(t){_gsScope.console&&console.log(t)},G="",Q="",$=function(t,e){e=e||U;var i,n,r=e.style;if(void 0!==r[t])return t;for(t=t.charAt(0).toUpperCase()+t.substr(1),i=["O","Moz","ms","Ms","Webkit"],n=5;--n>-1&&void 0===r[i[n]+t];);return n>=0?(Q=3===n?"ms":i[n],G="-"+Q.toLowerCase()+"-",Q+t):null},K=j.defaultView?j.defaultView.getComputedStyle:function(){},J=o.getStyle=function(t,e,i,n,r){var s;return H||"opacity"!==e?(!n&&t.style[e]?s=t.style[e]:(i=i||K(t))?s=i[e]||i.getPropertyValue(e)||i.getPropertyValue(e.replace(k,"-$1").toLowerCase()):t.currentStyle&&(s=t.currentStyle[e]),null==r||s&&"none"!==s&&"auto"!==s&&"auto auto"!==s?s:r):Z(t)},tt=Y.convertToPixels=function(t,i,n,r,s){if("px"===r||!r&&"lineHeight"!==i)return n;if("auto"===r||!n)return 0;var a,l,h,c=D.test(i),u=t,f=U.style,d=n<0,p=1===n;if(d&&(n=-n),p&&(n*=100),"lineHeight"!==i||r)if("%"===r&&i.indexOf("border")!==-1)a=n/100*(c?t.clientWidth:t.clientHeight);else{if(f.cssText="border:0 solid red;position:"+J(t,"position")+";line-height:0;","%"!==r&&u.appendChild&&"v"!==r.charAt(0)&&"rem"!==r)f[c?"borderLeftWidth":"borderTopWidth"]=n+r;else{if(u=t.parentNode||j.body,J(u,"display").indexOf("flex")!==-1&&(f.position="absolute"),l=u._gsCache,h=e.ticker.frame,l&&c&&l.time===h)return l.width*n/100;f[c?"width":"height"]=n+r}u.appendChild(U),a=parseFloat(U[c?"offsetWidth":"offsetHeight"]),u.removeChild(U),c&&"%"===r&&o.cacheWidths!==!1&&(l=u._gsCache=u._gsCache||{},l.time=h,l.width=a/n*100),0!==a||s||(a=tt(t,i,n,r,!0))}else l=K(t).lineHeight,t.style.lineHeight=n,a=parseFloat(K(t).lineHeight),t.style.lineHeight=l;return p&&(a/=100),d?-a:a},et=Y.calculateOffset=function(t,e,i){if("absolute"!==J(t,"position",i))return 0;var n="left"===e?"Left":"Top",r=J(t,"margin"+n,i);return t["offset"+n]-(tt(t,e,parseFloat(r),r.replace(b,""))||0)},it=function(t,e){var i,n,r,s={};if(e=e||K(t,null))if(i=e.length)for(;--i>-1;)r=e[i],r.indexOf("-transform")!==-1&&Ot!==r||(s[r.replace(E,A)]=e.getPropertyValue(r));else for(i in e)i.indexOf("Transform")!==-1&&Et!==i||(s[i]=e[i]);else if(e=t.currentStyle||t.style)for(i in e)"string"==typeof i&&void 0===s[i]&&(s[i.replace(E,A)]=e[i]);return H||(s.opacity=Z(t)),n=Wt(t,e,!1),s.rotation=n.rotation,s.skewX=n.skewX,s.scaleX=n.scaleX,s.scaleY=n.scaleY,s.x=n.x,s.y=n.y,Dt&&(s.z=n.z,s.rotationX=n.rotationX,s.rotationY=n.rotationY,s.scaleZ=n.scaleZ),s.filters&&delete s.filters,s},nt=function(t,e,i,n,r){var s,o,a,l={},h=t.style;for(o in i)"cssText"!==o&&"length"!==o&&isNaN(o)&&(e[o]!==(s=i[o])||r&&r[o])&&o.indexOf("Origin")===-1&&("number"!=typeof s&&"string"!=typeof s||(l[o]="auto"!==s||"left"!==o&&"top"!==o?""!==s&&"auto"!==s&&"none"!==s||"string"!=typeof e[o]||""===e[o].replace(w,"")?s:0:et(t,o),void 0!==h[o]&&(a=new yt(h,o,h[o],a))));if(n)for(o in n)"className"!==o&&(l[o]=n[o]);return{difs:l,firstMPT:a}},rt={width:["Left","Right"],height:["Top","Bottom"]},st=["marginLeft","marginRight","marginTop","marginBottom"],ot=function(t,e,i){if("svg"===(t.nodeName+"").toLowerCase())return(i||K(t))[e]||0;if(t.getCTM&&jt(t))return t.getBBox()[e]||0;var n=parseFloat("width"===e?t.offsetWidth:t.offsetHeight),r=rt[e],s=r.length;for(i=i||K(t,null);--s>-1;)n-=parseFloat(J(t,"padding"+r[s],i,!0))||0,n-=parseFloat(J(t,"border"+r[s]+"Width",i,!0))||0;return n},at=function(t,e){if("contain"===t||"auto"===t||"auto auto"===t)return t+" ";null!=t&&""!==t||(t="0 0");var i,n=t.split(" "),r=t.indexOf("left")!==-1?"0%":t.indexOf("right")!==-1?"100%":n[0],s=t.indexOf("top")!==-1?"0%":t.indexOf("bottom")!==-1?"100%":n[1];if(n.length>3&&!e){for(n=t.split(", ").join(",").split(","),t=[],i=0;i<n.length;i++)t.push(at(n[i]));return t.join(",")}return null==s?s="center"===r?"50%":"0":"center"===s&&(s="50%"),("center"===r||isNaN(parseFloat(r))&&(r+"").indexOf("=")===-1)&&(r="50%"),t=r+" "+s+(n.length>2?" "+n[2]:""),e&&(e.oxp=r.indexOf("%")!==-1,e.oyp=s.indexOf("%")!==-1,e.oxr="="===r.charAt(1),e.oyr="="===s.charAt(1),e.ox=parseFloat(r.replace(w,"")),e.oy=parseFloat(s.replace(w,"")),e.v=t),e||t},lt=function(t,e){return"function"==typeof t&&(t=t(v,g)),"string"==typeof t&&"="===t.charAt(1)?parseInt(t.charAt(0)+"1",10)*parseFloat(t.substr(2)):parseFloat(t)-parseFloat(e)||0},ht=function(t,e){return"function"==typeof t&&(t=t(v,g)),null==t?e:"string"==typeof t&&"="===t.charAt(1)?parseInt(t.charAt(0)+"1",10)*parseFloat(t.substr(2))+e:parseFloat(t)||0},ct=function(t,e,i,n){var r,s,o,a,l,h=1e-6;return"function"==typeof t&&(t=t(v,g)),null==t?a=e:"number"==typeof t?a=t:(r=360,s=t.split("_"),l="="===t.charAt(1),o=(l?parseInt(t.charAt(0)+"1",10)*parseFloat(s[0].substr(2)):parseFloat(s[0]))*(t.indexOf("rad")===-1?1:F)-(l?0:e),s.length&&(n&&(n[i]=e+o),t.indexOf("short")!==-1&&(o%=r,o!==o%(r/2)&&(o=o<0?o+r:o-r)),t.indexOf("_cw")!==-1&&o<0?o=(o+9999999999*r)%r-(o/r|0)*r:t.indexOf("ccw")!==-1&&o>0&&(o=(o-9999999999*r)%r-(o/r|0)*r)),a=e+o),a<h&&a>-h&&(a=0),a},ut={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},ft=function(t,e,i){return t=t<0?t+1:t>1?t-1:t,255*(6*t<1?e+(i-e)*t*6:t<.5?i:3*t<2?e+(i-e)*(2/3-t)*6:e)+.5|0},dt=o.parseColor=function(t,e){var i,n,r,s,o,a,l,h,c,u,f;if(t)if("number"==typeof t)i=[t>>16,t>>8&255,255&t];else{if(","===t.charAt(t.length-1)&&(t=t.substr(0,t.length-1)),ut[t])i=ut[t];else if("#"===t.charAt(0))4===t.length&&(n=t.charAt(1),r=t.charAt(2),s=t.charAt(3),t="#"+n+n+r+r+s+s),t=parseInt(t.substr(1),16),i=[t>>16,t>>8&255,255&t];else if("hsl"===t.substr(0,3))if(i=f=t.match(y),e){if(t.indexOf("=")!==-1)return t.match(_)}else o=Number(i[0])%360/360,a=Number(i[1])/100,l=Number(i[2])/100,r=l<=.5?l*(a+1):l+a-l*a,n=2*l-r,i.length>3&&(i[3]=Number(i[3])),i[0]=ft(o+1/3,n,r),i[1]=ft(o,n,r),i[2]=ft(o-1/3,n,r);else i=t.match(y)||ut.transparent;i[0]=Number(i[0]),i[1]=Number(i[1]),i[2]=Number(i[2]),i.length>3&&(i[3]=Number(i[3]))}else i=ut.black;return e&&!f&&(n=i[0]/255,r=i[1]/255,s=i[2]/255,h=Math.max(n,r,s),c=Math.min(n,r,s),l=(h+c)/2,h===c?o=a=0:(u=h-c,a=l>.5?u/(2-h-c):u/(h+c),o=h===n?(r-s)/u+(r<s?6:0):h===r?(s-n)/u+2:(n-r)/u+4,o*=60),i[0]=o+.5|0,i[1]=100*a+.5|0,i[2]=100*l+.5|0),i},pt=function(t,e){var i,n,r,s=t.match(mt)||[],o=0,a="";if(!s.length)return t;for(i=0;i<s.length;i++)n=s[i],r=t.substr(o,t.indexOf(n,o)-o),o+=r.length+n.length,n=dt(n,e),3===n.length&&n.push(1),a+=r+(e?"hsla("+n[0]+","+n[1]+"%,"+n[2]+"%,"+n[3]:"rgba("+n.join(","))+")";return a+t.substr(o)},mt="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(h in ut)mt+="|"+h+"\\b";mt=new RegExp(mt+")","gi"),o.colorStringFilter=function(t){var e,i=t[0]+" "+t[1];mt.test(i)&&(e=i.indexOf("hsl(")!==-1||i.indexOf("hsla(")!==-1,t[0]=pt(t[0],e),t[1]=pt(t[1],e)),mt.lastIndex=0},e.defaultStringFilter||(e.defaultStringFilter=o.colorStringFilter);var gt=function(t,e,i,n){if(null==t)return function(t){return t};var r,s=e?(t.match(mt)||[""])[0]:"",o=t.split(s).join("").match(x)||[],a=t.substr(0,t.indexOf(o[0])),l=")"===t.charAt(t.length-1)?")":"",h=t.indexOf(" ")!==-1?" ":",",c=o.length,u=c>0?o[0].replace(y,""):"";return c?r=e?function(t){var e,f,d,p;if("number"==typeof t)t+=u;else if(n&&L.test(t)){for(p=t.replace(L,"|").split("|"),d=0;d<p.length;d++)p[d]=r(p[d]);return p.join(",")}if(e=(t.match(mt)||[s])[0],f=t.split(e).join("").match(x)||[],d=f.length,c>d--)for(;++d<c;)f[d]=i?f[(d-1)/2|0]:o[d];return a+f.join(h)+h+e+l+(t.indexOf("inset")!==-1?" inset":"")}:function(t){var e,s,f;if("number"==typeof t)t+=u;else if(n&&L.test(t)){for(s=t.replace(L,"|").split("|"),f=0;f<s.length;f++)s[f]=r(s[f]);return s.join(",")}if(e=t.match(x)||[],f=e.length,c>f--)for(;++f<c;)e[f]=i?e[(f-1)/2|0]:o[f];return a+e.join(h)+l}:function(t){return t}},vt=function(t){return t=t.split(","),function(e,i,n,r,s,o,a){var l,h=(i+"").split(" ");for(a={},l=0;l<4;l++)a[t[l]]=h[l]=h[l]||h[(l-1)/2>>0];return r.parse(e,a,s,o)}},yt=(Y._setPluginRatio=function(t){this.plugin.setRatio(t);for(var e,i,n,r,s,o=this.data,a=o.proxy,l=o.firstMPT,h=1e-6;l;)e=a[l.v],l.r?e=Math.round(e):e<h&&e>-h&&(e=0),l.t[l.p]=e,l=l._next;if(o.autoRotate&&(o.autoRotate.rotation=o.mod?o.mod(a.rotation,this.t):a.rotation),1===t||0===t)for(l=o.firstMPT,s=1===t?"e":"b";l;){if(i=l.t,i.type){if(1===i.type){for(r=i.xs0+i.s+i.xs1,n=1;n<i.l;n++)r+=i["xn"+n]+i["xs"+(n+1)];i[s]=r}}else i[s]=i.s+i.xs0;l=l._next}},function(t,e,i,n,r){this.t=t,this.p=e,this.v=i,this.r=r,n&&(n._prev=this,this._next=n)}),_t=(Y._parseToProxy=function(t,e,i,n,r,s){var o,a,l,h,c,u=n,f={},d={},p=i._transform,m=N;for(i._transform=null,N=e,n=c=i.parse(t,e,n,r),N=m,s&&(i._transform=p,u&&(u._prev=null,u._prev&&(u._prev._next=null)));n&&n!==u;){if(n.type<=1&&(a=n.p,d[a]=n.s+n.c,f[a]=n.s,s||(h=new yt(n,"s",a,h,n.r),n.c=0),1===n.type))for(o=n.l;--o>0;)l="xn"+o,a=n.p+"_"+l,d[a]=n.data[l],f[a]=n[l],s||(h=new yt(n,l,a,h,n.rxp[l]));n=n._next}return{proxy:f,end:d,firstMPT:h,pt:c}},Y.CSSPropTween=function(t,e,n,r,o,a,l,h,c,u,f){this.t=t,this.p=e,this.s=n,this.c=r,this.n=l||e,t instanceof _t||s.push(this.n),this.r=h,this.type=a||0,c&&(this.pr=c,i=!0),this.b=void 0===u?n:u,this.e=void 0===f?n+r:f,o&&(this._next=o,o._prev=this)}),xt=function(t,e,i,n,r,s){var o=new _t(t,e,i,n-i,r,(-1),s);return o.b=i,o.e=o.xs0=n,o},wt=o.parseComplex=function(t,e,i,n,r,s,a,l,h,u){i=i||s||"","function"==typeof n&&(n=n(v,g)),a=new _t(t,e,0,0,a,u?2:1,null,(!1),l,i,n),n+="",r&&mt.test(n+i)&&(n=[i,n],o.colorStringFilter(n),i=n[0],n=n[1]);var f,d,p,m,x,w,b,T,S,P,C,k,E,O=i.split(", ").join(",").split(" "),A=n.split(", ").join(",").split(" "),D=O.length,M=c!==!1;for(n.indexOf(",")===-1&&i.indexOf(",")===-1||((n+i).indexOf("rgb")!==-1||(n+i).indexOf("hsl")!==-1?(O=O.join(" ").replace(L,", ").split(" "),A=A.join(" ").replace(L,", ").split(" ")):(O=O.join(" ").split(",").join(", ").split(" "),A=A.join(" ").split(",").join(", ").split(" ")),D=O.length),D!==A.length&&(O=(s||"").split(" "),D=O.length),a.plugin=h,a.setRatio=u,mt.lastIndex=0,f=0;f<D;f++)if(m=O[f],x=A[f],T=parseFloat(m),T||0===T)a.appendXtra("",T,lt(x,T),x.replace(_,""),M&&x.indexOf("px")!==-1,!0);else if(r&&mt.test(m))k=x.indexOf(")")+1,k=")"+(k?x.substr(k):""),E=x.indexOf("hsl")!==-1&&H,P=x,m=dt(m,E),x=dt(x,E),S=m.length+x.length>6,S&&!H&&0===x[3]?(a["xs"+a.l]+=a.l?" transparent":"transparent",a.e=a.e.split(A[f]).join("transparent")):(H||(S=!1),E?a.appendXtra(P.substr(0,P.indexOf("hsl"))+(S?"hsla(":"hsl("),m[0],lt(x[0],m[0]),",",!1,!0).appendXtra("",m[1],lt(x[1],m[1]),"%,",!1).appendXtra("",m[2],lt(x[2],m[2]),S?"%,":"%"+k,!1):a.appendXtra(P.substr(0,P.indexOf("rgb"))+(S?"rgba(":"rgb("),m[0],x[0]-m[0],",",!0,!0).appendXtra("",m[1],x[1]-m[1],",",!0).appendXtra("",m[2],x[2]-m[2],S?",":k,!0),S&&(m=m.length<4?1:m[3],a.appendXtra("",m,(x.length<4?1:x[3])-m,k,!1))),mt.lastIndex=0;else if(w=m.match(y)){if(b=x.match(_),!b||b.length!==w.length)return a;for(p=0,d=0;d<w.length;d++)C=w[d],P=m.indexOf(C,p),a.appendXtra(m.substr(p,P-p),Number(C),lt(b[d],C),"",M&&"px"===m.substr(P+C.length,2),0===d),p=P+C.length;a["xs"+a.l]+=m.substr(p)}else a["xs"+a.l]+=a.l||a["xs"+a.l]?" "+x:x;if(n.indexOf("=")!==-1&&a.data){for(k=a.xs0+a.data.s,f=1;f<a.l;f++)k+=a["xs"+f]+a.data["xn"+f];a.e=k+a["xs"+f]}return a.l||(a.type=-1,a.xs0=a.e),a.xfirst||a},bt=9;for(h=_t.prototype,h.l=h.pr=0;--bt>0;)h["xn"+bt]=0,h["xs"+bt]="";h.xs0="",h._next=h._prev=h.xfirst=h.data=h.plugin=h.setRatio=h.rxp=null,h.appendXtra=function(t,e,i,n,r,s){var o=this,a=o.l;return o["xs"+a]+=s&&(a||o["xs"+a])?" "+t:t||"",i||0===a||o.plugin?(o.l++,o.type=o.setRatio?2:1,o["xs"+o.l]=n||"",a>0?(o.data["xn"+a]=e+i,o.rxp["xn"+a]=r,o["xn"+a]=e,o.plugin||(o.xfirst=new _t(o,"xn"+a,e,i,o.xfirst||o,0,o.n,r,o.pr),o.xfirst.xs0=0),o):(o.data={s:e+i},o.rxp={},o.s=e,o.c=i,o.r=r,o)):(o["xs"+a]+=e+(n||""),o)};var Tt=function(t,e){e=e||{},this.p=e.prefix?$(t)||t:t,l[t]=l[this.p]=this,this.format=e.formatter||gt(e.defaultValue,e.color,e.collapsible,e.multi),e.parser&&(this.parse=e.parser),this.clrs=e.color,this.multi=e.multi,this.keyword=e.keyword,this.dflt=e.defaultValue,this.pr=e.priority||0},St=Y._registerComplexSpecialProp=function(t,e,i){"object"!=typeof e&&(e={parser:i});var n,r,s=t.split(","),o=e.defaultValue;for(i=i||[o],n=0;n<s.length;n++)e.prefix=0===n&&e.prefix,e.defaultValue=i[n]||o,r=new Tt(s[n],e)},Pt=Y._registerPluginProp=function(t){if(!l[t]){var e=t.charAt(0).toUpperCase()+t.substr(1)+"Plugin";St(t,{parser:function(t,i,n,r,s,o,h){var c=a.com.greensock.plugins[e];return c?(c._cssRegister(),l[n].parse(t,i,n,r,s,o,h)):(V("Error: "+e+" js file not loaded."),s)}})}};h=Tt.prototype,h.parseComplex=function(t,e,i,n,r,s){var o,a,l,h,c,u,f=this.keyword;if(this.multi&&(L.test(i)||L.test(e)?(a=e.replace(L,"|").split("|"),l=i.replace(L,"|").split("|")):f&&(a=[e],l=[i])),l){for(h=l.length>a.length?l.length:a.length,o=0;o<h;o++)e=a[o]=a[o]||this.dflt,i=l[o]=l[o]||this.dflt,f&&(c=e.indexOf(f),u=i.indexOf(f),c!==u&&(u===-1?a[o]=a[o].split(f).join(""):c===-1&&(a[o]+=" "+f)));e=a.join(", "),i=l.join(", ")}return wt(t,this.p,e,i,this.clrs,this.dflt,n,this.pr,r,s)},h.parse=function(t,e,i,n,s,o,a){return this.parseComplex(t.style,this.format(J(t,this.p,r,!1,this.dflt)),this.format(e),s,o)},o.registerSpecialProp=function(t,e,i){St(t,{parser:function(t,n,r,s,o,a,l){var h=new _t(t,r,0,0,o,2,r,(!1),i);return h.plugin=a,h.setRatio=e(t,n,s._tween,r),h},priority:i})},o.useSVGTransformAttr=!0;var Ct,kt="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Et=$("transform"),Ot=G+"transform",At=$("transformOrigin"),Dt=null!==$("perspective"),Mt=Y.Transform=function(){this.perspective=parseFloat(o.defaultTransformPerspective)||0,this.force3D=!(o.defaultForce3D===!1||!Dt)&&(o.defaultForce3D||"auto")},zt=_gsScope.SVGElement,Lt=function(t,e,i){var n,r=j.createElementNS("http://www.w3.org/2000/svg",t),s=/([a-z])([A-Z])/g;for(n in i)r.setAttributeNS(null,n.replace(s,"$1-$2").toLowerCase(),i[n]);return e.appendChild(r),r},Rt=j.documentElement||{},It=function(){var t,e,i,n=m||/Android/i.test(q)&&!_gsScope.chrome;return j.createElementNS&&!n&&(t=Lt("svg",Rt),e=Lt("rect",t,{width:100,height:50,x:100}),i=e.getBoundingClientRect().width,e.style[At]="50% 50%",e.style[Et]="scaleX(0.5)",n=i===e.getBoundingClientRect().width&&!(d&&Dt),Rt.removeChild(t)),n}(),Ft=function(t,e,i,n,r,s){var a,l,h,c,u,f,d,p,m,g,v,y,_,x,w=t._gsTransform,b=Ut(t,!0);w&&(_=w.xOrigin,x=w.yOrigin),(!n||(a=n.split(" ")).length<2)&&(d=t.getBBox(),0===d.x&&0===d.y&&d.width+d.height===0&&(d={x:parseFloat(t.hasAttribute("x")?t.getAttribute("x"):t.hasAttribute("cx")?t.getAttribute("cx"):0)||0,y:parseFloat(t.hasAttribute("y")?t.getAttribute("y"):t.hasAttribute("cy")?t.getAttribute("cy"):0)||0,width:0,height:0}),e=at(e).split(" "),a=[(e[0].indexOf("%")!==-1?parseFloat(e[0])/100*d.width:parseFloat(e[0]))+d.x,(e[1].indexOf("%")!==-1?parseFloat(e[1])/100*d.height:parseFloat(e[1]))+d.y]),i.xOrigin=c=parseFloat(a[0]),i.yOrigin=u=parseFloat(a[1]),n&&b!==Bt&&(f=b[0],d=b[1],p=b[2],m=b[3],g=b[4],v=b[5],y=f*m-d*p,y&&(l=c*(m/y)+u*(-p/y)+(p*v-m*g)/y,h=c*(-d/y)+u*(f/y)-(f*v-d*g)/y,c=i.xOrigin=a[0]=l,u=i.yOrigin=a[1]=h)),w&&(s&&(i.xOffset=w.xOffset,i.yOffset=w.yOffset,w=i),r||r!==!1&&o.defaultSmoothOrigin!==!1?(l=c-_,h=u-x,w.xOffset+=l*b[0]+h*b[2]-l,w.yOffset+=l*b[1]+h*b[3]-h):w.xOffset=w.yOffset=0),s||t.setAttribute("data-svg-origin",a.join(" "))},Nt=function(t){var e,i=B("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),n=this.parentNode,r=this.nextSibling,s=this.style.cssText;if(Rt.appendChild(i),i.appendChild(this),this.style.display="block",t)try{e=this.getBBox(),this._originalGetBBox=this.getBBox,this.getBBox=Nt}catch(o){}else this._originalGetBBox&&(e=this._originalGetBBox());return r?n.insertBefore(this,r):n.appendChild(this),Rt.removeChild(i),this.style.cssText=s,e},Xt=function(t){try{return t.getBBox()}catch(e){return Nt.call(t,!0)}},jt=function(t){return!(!zt||!t.getCTM||t.parentNode&&!t.ownerSVGElement||!Xt(t))},Bt=[1,0,0,1,0,0],Ut=function(t,e){var i,n,r,s,o,a,l=t._gsTransform||new Mt,h=1e5,c=t.style;if(Et?n=J(t,Ot,null,!0):t.currentStyle&&(n=t.currentStyle.filter.match(M),n=n&&4===n.length?[n[0].substr(4),Number(n[2].substr(4)),Number(n[1].substr(4)),n[3].substr(4),l.x||0,l.y||0].join(","):""),i=!n||"none"===n||"matrix(1, 0, 0, 1, 0, 0)"===n,!Et||!(a=!K(t)||"none"===K(t).display)&&t.parentNode||(a&&(s=c.display,c.display="block"),t.parentNode||(o=1,Rt.appendChild(t)),n=J(t,Ot,null,!0),i=!n||"none"===n||"matrix(1, 0, 0, 1, 0, 0)"===n,s?c.display=s:a&&Zt(c,"display"),o&&Rt.removeChild(t)),(l.svg||t.getCTM&&jt(t))&&(i&&(c[Et]+"").indexOf("matrix")!==-1&&(n=c[Et],i=0),r=t.getAttribute("transform"),i&&r&&(r.indexOf("matrix")!==-1?(n=r,i=0):r.indexOf("translate")!==-1&&(n="matrix(1,0,0,1,"+r.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",")+")",i=0))),i)return Bt;for(r=(n||"").match(y)||[],bt=r.length;--bt>-1;)s=Number(r[bt]),r[bt]=(o=s-(s|=0))?(o*h+(o<0?-.5:.5)|0)/h+s:s;return e&&r.length>6?[r[0],r[1],r[4],r[5],r[12],r[13]]:r},Wt=Y.getTransform=function(t,i,n,r){if(t._gsTransform&&n&&!r)return t._gsTransform;var s,a,l,h,c,u,f=n?t._gsTransform||new Mt:new Mt,d=f.scaleX<0,p=2e-5,m=1e5,g=Dt?parseFloat(J(t,At,i,!1,"0 0 0").split(" ")[2])||f.zOrigin||0:0,v=parseFloat(o.defaultTransformPerspective)||0;if(f.svg=!(!t.getCTM||!jt(t)),f.svg&&(Ft(t,J(t,At,i,!1,"50% 50%")+"",f,t.getAttribute("data-svg-origin")),Ct=o.useSVGTransformAttr||It),s=Ut(t),s!==Bt){if(16===s.length){var y,_,x,w,b,T=s[0],S=s[1],P=s[2],C=s[3],k=s[4],E=s[5],O=s[6],A=s[7],D=s[8],M=s[9],z=s[10],L=s[12],R=s[13],I=s[14],N=s[11],X=Math.atan2(O,z);f.zOrigin&&(I=-f.zOrigin,L=D*I-s[12],R=M*I-s[13],I=z*I+f.zOrigin-s[14]),f.rotationX=X*F,X&&(w=Math.cos(-X),b=Math.sin(-X),y=k*w+D*b,_=E*w+M*b,x=O*w+z*b,D=k*-b+D*w,M=E*-b+M*w,z=O*-b+z*w,N=A*-b+N*w,k=y,E=_,O=x),X=Math.atan2(-P,z),f.rotationY=X*F,X&&(w=Math.cos(-X),b=Math.sin(-X),y=T*w-D*b,_=S*w-M*b,x=P*w-z*b,M=S*b+M*w,z=P*b+z*w,N=C*b+N*w,T=y,S=_,P=x),X=Math.atan2(S,T),f.rotation=X*F,X&&(w=Math.cos(X),b=Math.sin(X),y=T*w+S*b,_=k*w+E*b,x=D*w+M*b,S=S*w-T*b,E=E*w-k*b,M=M*w-D*b,T=y,k=_,D=x),f.rotationX&&Math.abs(f.rotationX)+Math.abs(f.rotation)>359.9&&(f.rotationX=f.rotation=0,f.rotationY=180-f.rotationY),X=Math.atan2(k,E),f.scaleX=(Math.sqrt(T*T+S*S+P*P)*m+.5|0)/m,f.scaleY=(Math.sqrt(E*E+O*O)*m+.5|0)/m,f.scaleZ=(Math.sqrt(D*D+M*M+z*z)*m+.5|0)/m,T/=f.scaleX,k/=f.scaleY,S/=f.scaleX,E/=f.scaleY,Math.abs(X)>p?(f.skewX=X*F,k=0,"simple"!==f.skewType&&(f.scaleY*=1/Math.cos(X))):f.skewX=0,f.perspective=N?1/(N<0?-N:N):0,f.x=L,f.y=R,f.z=I,f.svg&&(f.x-=f.xOrigin-(f.xOrigin*T-f.yOrigin*k),f.y-=f.yOrigin-(f.yOrigin*S-f.xOrigin*E))}else if(!Dt||r||!s.length||f.x!==s[4]||f.y!==s[5]||!f.rotationX&&!f.rotationY){var j=s.length>=6,B=j?s[0]:1,U=s[1]||0,W=s[2]||0,Y=j?s[3]:1;f.x=s[4]||0,f.y=s[5]||0,l=Math.sqrt(B*B+U*U),h=Math.sqrt(Y*Y+W*W),c=B||U?Math.atan2(U,B)*F:f.rotation||0,u=W||Y?Math.atan2(W,Y)*F+c:f.skewX||0,f.scaleX=l,f.scaleY=h,f.rotation=c,f.skewX=u,Dt&&(f.rotationX=f.rotationY=f.z=0,f.perspective=v,f.scaleZ=1),f.svg&&(f.x-=f.xOrigin-(f.xOrigin*B+f.yOrigin*W),f.y-=f.yOrigin-(f.xOrigin*U+f.yOrigin*Y))}Math.abs(f.skewX)>90&&Math.abs(f.skewX)<270&&(d?(f.scaleX*=-1,f.skewX+=f.rotation<=0?180:-180,f.rotation+=f.rotation<=0?180:-180):(f.scaleY*=-1,f.skewX+=f.skewX<=0?180:-180)),f.zOrigin=g;for(a in f)f[a]<p&&f[a]>-p&&(f[a]=0)}return n&&(t._gsTransform=f,f.svg&&(Ct&&t.style[Et]?e.delayedCall(.001,function(){Zt(t.style,Et)}):!Ct&&t.getAttribute("transform")&&e.delayedCall(.001,function(){t.removeAttribute("transform")}))),f},Yt=function(t){var e,i,n=this.data,r=-n.rotation*I,s=r+n.skewX*I,o=1e5,a=(Math.cos(r)*n.scaleX*o|0)/o,l=(Math.sin(r)*n.scaleX*o|0)/o,h=(Math.sin(s)*-n.scaleY*o|0)/o,c=(Math.cos(s)*n.scaleY*o|0)/o,u=this.t.style,f=this.t.currentStyle;if(f){i=l,l=-h,h=-i,e=f.filter,u.filter="";var d,p,g=this.t.offsetWidth,v=this.t.offsetHeight,y="absolute"!==f.position,_="progid:DXImageTransform.Microsoft.Matrix(M11="+a+", M12="+l+", M21="+h+", M22="+c,x=n.x+g*n.xPercent/100,w=n.y+v*n.yPercent/100;
if(null!=n.ox&&(d=(n.oxp?g*n.ox*.01:n.ox)-g/2,p=(n.oyp?v*n.oy*.01:n.oy)-v/2,x+=d-(d*a+p*l),w+=p-(d*h+p*c)),y?(d=g/2,p=v/2,_+=", Dx="+(d-(d*a+p*l)+x)+", Dy="+(p-(d*h+p*c)+w)+")"):_+=", sizingMethod='auto expand')",e.indexOf("DXImageTransform.Microsoft.Matrix(")!==-1?u.filter=e.replace(z,_):u.filter=_+" "+e,0!==t&&1!==t||1===a&&0===l&&0===h&&1===c&&(y&&_.indexOf("Dx=0, Dy=0")===-1||T.test(e)&&100!==parseFloat(RegExp.$1)||e.indexOf(e.indexOf("Alpha"))===-1&&u.removeAttribute("filter")),!y){var S,P,C,k=m<8?1:-1;for(d=n.ieOffsetX||0,p=n.ieOffsetY||0,n.ieOffsetX=Math.round((g-((a<0?-a:a)*g+(l<0?-l:l)*v))/2+x),n.ieOffsetY=Math.round((v-((c<0?-c:c)*v+(h<0?-h:h)*g))/2+w),bt=0;bt<4;bt++)P=st[bt],S=f[P],i=S.indexOf("px")!==-1?parseFloat(S):tt(this.t,P,parseFloat(S),S.replace(b,""))||0,C=i!==n[P]?bt<2?-n.ieOffsetX:-n.ieOffsetY:bt<2?d-n.ieOffsetX:p-n.ieOffsetY,u[P]=(n[P]=Math.round(i-C*(0===bt||2===bt?1:k)))+"px"}}},qt=Y.set3DTransformRatio=Y.setTransformRatio=function(t){var e,i,n,r,s,o,a,l,h,c,u,f,p,m,g,v,y,_,x,w,b,T,S,P=this.data,C=this.t.style,k=P.rotation,E=P.rotationX,O=P.rotationY,A=P.scaleX,D=P.scaleY,M=P.scaleZ,z=P.x,L=P.y,R=P.z,F=P.svg,N=P.perspective,X=P.force3D,j=P.skewY,B=P.skewX;if(j&&(B+=j,k+=j),((1===t||0===t)&&"auto"===X&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!X)&&!R&&!N&&!O&&!E&&1===M||Ct&&F||!Dt)return void(k||B||F?(k*=I,T=B*I,S=1e5,i=Math.cos(k)*A,s=Math.sin(k)*A,n=Math.sin(k-T)*-D,o=Math.cos(k-T)*D,T&&"simple"===P.skewType&&(e=Math.tan(T-j*I),e=Math.sqrt(1+e*e),n*=e,o*=e,j&&(e=Math.tan(j*I),e=Math.sqrt(1+e*e),i*=e,s*=e)),F&&(z+=P.xOrigin-(P.xOrigin*i+P.yOrigin*n)+P.xOffset,L+=P.yOrigin-(P.xOrigin*s+P.yOrigin*o)+P.yOffset,Ct&&(P.xPercent||P.yPercent)&&(g=this.t.getBBox(),z+=.01*P.xPercent*g.width,L+=.01*P.yPercent*g.height),g=1e-6,z<g&&z>-g&&(z=0),L<g&&L>-g&&(L=0)),x=(i*S|0)/S+","+(s*S|0)/S+","+(n*S|0)/S+","+(o*S|0)/S+","+z+","+L+")",F&&Ct?this.t.setAttribute("transform","matrix("+x):C[Et]=(P.xPercent||P.yPercent?"translate("+P.xPercent+"%,"+P.yPercent+"%) matrix(":"matrix(")+x):C[Et]=(P.xPercent||P.yPercent?"translate("+P.xPercent+"%,"+P.yPercent+"%) matrix(":"matrix(")+A+",0,0,"+D+","+z+","+L+")");if(d&&(g=1e-4,A<g&&A>-g&&(A=M=2e-5),D<g&&D>-g&&(D=M=2e-5),!N||P.z||P.rotationX||P.rotationY||(N=0)),k||B)k*=I,v=i=Math.cos(k),y=s=Math.sin(k),B&&(k-=B*I,v=Math.cos(k),y=Math.sin(k),"simple"===P.skewType&&(e=Math.tan((B-j)*I),e=Math.sqrt(1+e*e),v*=e,y*=e,P.skewY&&(e=Math.tan(j*I),e=Math.sqrt(1+e*e),i*=e,s*=e))),n=-y,o=v;else{if(!(O||E||1!==M||N||F))return void(C[Et]=(P.xPercent||P.yPercent?"translate("+P.xPercent+"%,"+P.yPercent+"%) translate3d(":"translate3d(")+z+"px,"+L+"px,"+R+"px)"+(1!==A||1!==D?" scale("+A+","+D+")":""));i=o=1,n=s=0}c=1,r=a=l=h=u=f=0,p=N?-1/N:0,m=P.zOrigin,g=1e-6,w=",",b="0",k=O*I,k&&(v=Math.cos(k),y=Math.sin(k),l=-y,u=p*-y,r=i*y,a=s*y,c=v,p*=v,i*=v,s*=v),k=E*I,k&&(v=Math.cos(k),y=Math.sin(k),e=n*v+r*y,_=o*v+a*y,h=c*y,f=p*y,r=n*-y+r*v,a=o*-y+a*v,c*=v,p*=v,n=e,o=_),1!==M&&(r*=M,a*=M,c*=M,p*=M),1!==D&&(n*=D,o*=D,h*=D,f*=D),1!==A&&(i*=A,s*=A,l*=A,u*=A),(m||F)&&(m&&(z+=r*-m,L+=a*-m,R+=c*-m+m),F&&(z+=P.xOrigin-(P.xOrigin*i+P.yOrigin*n)+P.xOffset,L+=P.yOrigin-(P.xOrigin*s+P.yOrigin*o)+P.yOffset),z<g&&z>-g&&(z=b),L<g&&L>-g&&(L=b),R<g&&R>-g&&(R=0)),x=P.xPercent||P.yPercent?"translate("+P.xPercent+"%,"+P.yPercent+"%) matrix3d(":"matrix3d(",x+=(i<g&&i>-g?b:i)+w+(s<g&&s>-g?b:s)+w+(l<g&&l>-g?b:l),x+=w+(u<g&&u>-g?b:u)+w+(n<g&&n>-g?b:n)+w+(o<g&&o>-g?b:o),E||O||1!==M?(x+=w+(h<g&&h>-g?b:h)+w+(f<g&&f>-g?b:f)+w+(r<g&&r>-g?b:r),x+=w+(a<g&&a>-g?b:a)+w+(c<g&&c>-g?b:c)+w+(p<g&&p>-g?b:p)+w):x+=",0,0,0,0,1,0,",x+=z+w+L+w+R+w+(N?1+-R/N:1)+")",C[Et]=x};h=Mt.prototype,h.x=h.y=h.z=h.skewX=h.skewY=h.rotation=h.rotationX=h.rotationY=h.zOrigin=h.xPercent=h.yPercent=h.xOffset=h.yOffset=0,h.scaleX=h.scaleY=h.scaleZ=1,St("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{parser:function(t,e,i,n,s,a,l){if(n._lastParsedTransform===l)return s;n._lastParsedTransform=l;var h,c=l.scale&&"function"==typeof l.scale?l.scale:0;"function"==typeof l[i]&&(h=l[i],l[i]=e),c&&(l.scale=c(v,t));var u,f,d,p,m,y,_,x,w,b=t._gsTransform,T=t.style,S=1e-6,P=kt.length,C=l,k={},E="transformOrigin",O=Wt(t,r,!0,C.parseTransform),A=C.transform&&("function"==typeof C.transform?C.transform(v,g):C.transform);if(O.skewType=C.skewType||O.skewType||o.defaultSkewType,n._transform=O,A&&"string"==typeof A&&Et)f=U.style,f[Et]=A,f.display="block",f.position="absolute",j.body.appendChild(U),u=Wt(U,null,!1),"simple"===O.skewType&&(u.scaleY*=Math.cos(u.skewX*I)),O.svg&&(y=O.xOrigin,_=O.yOrigin,u.x-=O.xOffset,u.y-=O.yOffset,(C.transformOrigin||C.svgOrigin)&&(A={},Ft(t,at(C.transformOrigin),A,C.svgOrigin,C.smoothOrigin,!0),y=A.xOrigin,_=A.yOrigin,u.x-=A.xOffset-O.xOffset,u.y-=A.yOffset-O.yOffset),(y||_)&&(x=Ut(U,!0),u.x-=y-(y*x[0]+_*x[2]),u.y-=_-(y*x[1]+_*x[3]))),j.body.removeChild(U),u.perspective||(u.perspective=O.perspective),null!=C.xPercent&&(u.xPercent=ht(C.xPercent,O.xPercent)),null!=C.yPercent&&(u.yPercent=ht(C.yPercent,O.yPercent));else if("object"==typeof C){if(u={scaleX:ht(null!=C.scaleX?C.scaleX:C.scale,O.scaleX),scaleY:ht(null!=C.scaleY?C.scaleY:C.scale,O.scaleY),scaleZ:ht(C.scaleZ,O.scaleZ),x:ht(C.x,O.x),y:ht(C.y,O.y),z:ht(C.z,O.z),xPercent:ht(C.xPercent,O.xPercent),yPercent:ht(C.yPercent,O.yPercent),perspective:ht(C.transformPerspective,O.perspective)},m=C.directionalRotation,null!=m)if("object"==typeof m)for(f in m)C[f]=m[f];else C.rotation=m;"string"==typeof C.x&&C.x.indexOf("%")!==-1&&(u.x=0,u.xPercent=ht(C.x,O.xPercent)),"string"==typeof C.y&&C.y.indexOf("%")!==-1&&(u.y=0,u.yPercent=ht(C.y,O.yPercent)),u.rotation=ct("rotation"in C?C.rotation:"shortRotation"in C?C.shortRotation+"_short":"rotationZ"in C?C.rotationZ:O.rotation,O.rotation,"rotation",k),Dt&&(u.rotationX=ct("rotationX"in C?C.rotationX:"shortRotationX"in C?C.shortRotationX+"_short":O.rotationX||0,O.rotationX,"rotationX",k),u.rotationY=ct("rotationY"in C?C.rotationY:"shortRotationY"in C?C.shortRotationY+"_short":O.rotationY||0,O.rotationY,"rotationY",k)),u.skewX=ct(C.skewX,O.skewX),u.skewY=ct(C.skewY,O.skewY)}for(Dt&&null!=C.force3D&&(O.force3D=C.force3D,p=!0),d=O.force3D||O.z||O.rotationX||O.rotationY||u.z||u.rotationX||u.rotationY||u.perspective,d||null==C.scale||(u.scaleZ=1);--P>-1;)w=kt[P],A=u[w]-O[w],(A>S||A<-S||null!=C[w]||null!=N[w])&&(p=!0,s=new _t(O,w,O[w],A,s),w in k&&(s.e=k[w]),s.xs0=0,s.plugin=a,n._overwriteProps.push(s.n));return A=C.transformOrigin,O.svg&&(A||C.svgOrigin)&&(y=O.xOffset,_=O.yOffset,Ft(t,at(A),u,C.svgOrigin,C.smoothOrigin),s=xt(O,"xOrigin",(b?O:u).xOrigin,u.xOrigin,s,E),s=xt(O,"yOrigin",(b?O:u).yOrigin,u.yOrigin,s,E),y===O.xOffset&&_===O.yOffset||(s=xt(O,"xOffset",b?y:O.xOffset,O.xOffset,s,E),s=xt(O,"yOffset",b?_:O.yOffset,O.yOffset,s,E)),A="0px 0px"),(A||Dt&&d&&O.zOrigin)&&(Et?(p=!0,w=At,A=(A||J(t,w,r,!1,"50% 50%"))+"",s=new _t(T,w,0,0,s,(-1),E),s.b=T[w],s.plugin=a,Dt?(f=O.zOrigin,A=A.split(" "),O.zOrigin=(A.length>2&&(0===f||"0px"!==A[2])?parseFloat(A[2]):f)||0,s.xs0=s.e=A[0]+" "+(A[1]||"50%")+" 0px",s=new _t(O,"zOrigin",0,0,s,(-1),s.n),s.b=f,s.xs0=s.e=O.zOrigin):s.xs0=s.e=A):at(A+"",O)),p&&(n._transformType=O.svg&&Ct||!d&&3!==this._transformType?2:3),h&&(l[i]=h),c&&(l.scale=c),s},prefix:!0}),St("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),St("borderRadius",{defaultValue:"0px",parser:function(t,e,i,s,o,a){e=this.format(e);var l,h,c,u,f,d,p,m,g,v,y,_,x,w,b,T,S=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],P=t.style;for(g=parseFloat(t.offsetWidth),v=parseFloat(t.offsetHeight),l=e.split(" "),h=0;h<S.length;h++)this.p.indexOf("border")&&(S[h]=$(S[h])),f=u=J(t,S[h],r,!1,"0px"),f.indexOf(" ")!==-1&&(u=f.split(" "),f=u[0],u=u[1]),d=c=l[h],p=parseFloat(f),_=f.substr((p+"").length),x="="===d.charAt(1),x?(m=parseInt(d.charAt(0)+"1",10),d=d.substr(2),m*=parseFloat(d),y=d.substr((m+"").length-(m<0?1:0))||""):(m=parseFloat(d),y=d.substr((m+"").length)),""===y&&(y=n[i]||_),y!==_&&(w=tt(t,"borderLeft",p,_),b=tt(t,"borderTop",p,_),"%"===y?(f=w/g*100+"%",u=b/v*100+"%"):"em"===y?(T=tt(t,"borderLeft",1,"em"),f=w/T+"em",u=b/T+"em"):(f=w+"px",u=b+"px"),x&&(d=parseFloat(f)+m+y,c=parseFloat(u)+m+y)),o=wt(P,S[h],f+" "+u,d+" "+c,!1,"0px",o);return o},prefix:!0,formatter:gt("0px 0px 0px 0px",!1,!0)}),St("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(t,e,i,n,s,o){return wt(t.style,i,this.format(J(t,i,r,!1,"0px 0px")),this.format(e),!1,"0px",s)},prefix:!0,formatter:gt("0px 0px",!1,!0)}),St("backgroundPosition",{defaultValue:"0 0",parser:function(t,e,i,n,s,o){var a,l,h,c,u,f,d="background-position",p=r||K(t,null),g=this.format((p?m?p.getPropertyValue(d+"-x")+" "+p.getPropertyValue(d+"-y"):p.getPropertyValue(d):t.currentStyle.backgroundPositionX+" "+t.currentStyle.backgroundPositionY)||"0 0"),v=this.format(e);if(g.indexOf("%")!==-1!=(v.indexOf("%")!==-1)&&v.split(",").length<2&&(f=J(t,"backgroundImage").replace(O,""),f&&"none"!==f)){for(a=g.split(" "),l=v.split(" "),W.setAttribute("src",f),h=2;--h>-1;)g=a[h],c=g.indexOf("%")!==-1,c!==(l[h].indexOf("%")!==-1)&&(u=0===h?t.offsetWidth-W.width:t.offsetHeight-W.height,a[h]=c?parseFloat(g)/100*u+"px":parseFloat(g)/u*100+"%");g=a.join(" ")}return this.parseComplex(t.style,g,v,s,o)},formatter:at}),St("backgroundSize",{defaultValue:"0 0",formatter:function(t){return t+="",at(t.indexOf(" ")===-1?t+" "+t:t)}}),St("perspective",{defaultValue:"0px",prefix:!0}),St("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),St("transformStyle",{prefix:!0}),St("backfaceVisibility",{prefix:!0}),St("userSelect",{prefix:!0}),St("margin",{parser:vt("marginTop,marginRight,marginBottom,marginLeft")}),St("padding",{parser:vt("paddingTop,paddingRight,paddingBottom,paddingLeft")}),St("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(t,e,i,n,s,o){var a,l,h;return m<9?(l=t.currentStyle,h=m<8?" ":",",a="rect("+l.clipTop+h+l.clipRight+h+l.clipBottom+h+l.clipLeft+")",e=this.format(e).split(",").join(h)):(a=this.format(J(t,this.p,r,!1,this.dflt)),e=this.format(e)),this.parseComplex(t.style,a,e,s,o)}}),St("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),St("autoRound,strictUnits",{parser:function(t,e,i,n,r){return r}}),St("border",{defaultValue:"0px solid #000",parser:function(t,e,i,n,s,o){var a=J(t,"borderTopWidth",r,!1,"0px"),l=this.format(e).split(" "),h=l[0].replace(b,"");return"px"!==h&&(a=parseFloat(a)/tt(t,"borderTopWidth",1,h)+h),this.parseComplex(t.style,this.format(a+" "+J(t,"borderTopStyle",r,!1,"solid")+" "+J(t,"borderTopColor",r,!1,"#000")),l.join(" "),s,o)},color:!0,formatter:function(t){var e=t.split(" ");return e[0]+" "+(e[1]||"solid")+" "+(t.match(mt)||["#000"])[0]}}),St("borderWidth",{parser:vt("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),St("float,cssFloat,styleFloat",{parser:function(t,e,i,n,r,s){var o=t.style,a="cssFloat"in o?"cssFloat":"styleFloat";return new _t(o,a,0,0,r,(-1),i,(!1),0,o[a],e)}});var Ht=function(t){var e,i=this.t,n=i.filter||J(this.data,"filter")||"",r=this.s+this.c*t|0;100===r&&(n.indexOf("atrix(")===-1&&n.indexOf("radient(")===-1&&n.indexOf("oader(")===-1?(i.removeAttribute("filter"),e=!J(this.data,"filter")):(i.filter=n.replace(P,""),e=!0)),e||(this.xn1&&(i.filter=n=n||"alpha(opacity="+r+")"),n.indexOf("pacity")===-1?0===r&&this.xn1||(i.filter=n+" alpha(opacity="+r+")"):i.filter=n.replace(T,"opacity="+r))};St("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(t,e,i,n,s,o){var a=parseFloat(J(t,"opacity",r,!1,"1")),l=t.style,h="autoAlpha"===i;return"string"==typeof e&&"="===e.charAt(1)&&(e=("-"===e.charAt(0)?-1:1)*parseFloat(e.substr(2))+a),h&&1===a&&"hidden"===J(t,"visibility",r)&&0!==e&&(a=0),H?s=new _t(l,"opacity",a,e-a,s):(s=new _t(l,"opacity",100*a,100*(e-a),s),s.xn1=h?1:0,l.zoom=1,s.type=2,s.b="alpha(opacity="+s.s+")",s.e="alpha(opacity="+(s.s+s.c)+")",s.data=t,s.plugin=o,s.setRatio=Ht),h&&(s=new _t(l,"visibility",0,0,s,(-1),null,(!1),0,0!==a?"inherit":"hidden",0===e?"hidden":"inherit"),s.xs0="inherit",n._overwriteProps.push(s.n),n._overwriteProps.push(i)),s}});var Zt=function(t,e){e&&(t.removeProperty?("ms"!==e.substr(0,2)&&"webkit"!==e.substr(0,6)||(e="-"+e),t.removeProperty(e.replace(k,"-$1").toLowerCase())):t.removeAttribute(e))},Vt=function(t){if(this.t._gsClassPT=this,1===t||0===t){this.t.setAttribute("class",0===t?this.b:this.e);for(var e=this.data,i=this.t.style;e;)e.v?i[e.p]=e.v:Zt(i,e.p),e=e._next;1===t&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};St("className",{parser:function(t,e,n,s,o,a,l){var h,c,u,f,d,p=t.getAttribute("class")||"",m=t.style.cssText;if(o=s._classNamePT=new _t(t,n,0,0,o,2),o.setRatio=Vt,o.pr=-11,i=!0,o.b=p,c=it(t,r),u=t._gsClassPT){for(f={},d=u.data;d;)f[d.p]=1,d=d._next;u.setRatio(1)}return t._gsClassPT=o,o.e="="!==e.charAt(1)?e:p.replace(new RegExp("(?:\\s|^)"+e.substr(2)+"(?![\\w-])"),"")+("+"===e.charAt(0)?" "+e.substr(2):""),t.setAttribute("class",o.e),h=nt(t,c,it(t),l,f),t.setAttribute("class",p),o.data=h.firstMPT,t.style.cssText=m,o=o.xfirst=s.parse(t,h.difs,o,a)}});var Gt=function(t){if((1===t||0===t)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var e,i,n,r,s,o=this.t.style,a=l.transform.parse;if("all"===this.e)o.cssText="",r=!0;else for(e=this.e.split(" ").join("").split(","),n=e.length;--n>-1;)i=e[n],l[i]&&(l[i].parse===a?r=!0:i="transformOrigin"===i?At:l[i].p),Zt(o,i);r&&(Zt(o,Et),s=this.t._gsTransform,s&&(s.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(St("clearProps",{parser:function(t,e,n,r,s){return s=new _t(t,n,0,0,s,2),s.setRatio=Gt,s.e=e,s.pr=-10,s.data=r._tween,i=!0,s}}),h="bezier,throwProps,physicsProps,physics2D".split(","),bt=h.length;bt--;)Pt(h[bt]);h=o.prototype,h._firstPT=h._lastParsedTransform=h._transform=null,h._onInitTween=function(t,e,a,h){if(!t.nodeType)return!1;this._target=g=t,this._tween=a,this._vars=e,v=h,c=e.autoRound,i=!1,n=e.suffixMap||o.suffixMap,r=K(t,""),s=this._overwriteProps;var d,m,y,_,x,w,b,T,P,C=t.style;if(u&&""===C.zIndex&&(d=J(t,"zIndex",r),"auto"!==d&&""!==d||this._addLazySet(C,"zIndex",0)),"string"==typeof e&&(_=C.cssText,d=it(t,r),C.cssText=_+";"+e,d=nt(t,d,it(t)).difs,!H&&S.test(e)&&(d.opacity=parseFloat(RegExp.$1)),e=d,C.cssText=_),e.className?this._firstPT=m=l.className.parse(t,e.className,"className",this,null,null,e):this._firstPT=m=this.parse(t,e,null),this._transformType){for(P=3===this._transformType,Et?f&&(u=!0,""===C.zIndex&&(b=J(t,"zIndex",r),"auto"!==b&&""!==b||this._addLazySet(C,"zIndex",0)),p&&this._addLazySet(C,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(P?"visible":"hidden"))):C.zoom=1,y=m;y&&y._next;)y=y._next;T=new _t(t,"transform",0,0,null,2),this._linkCSSP(T,null,y),T.setRatio=Et?qt:Yt,T.data=this._transform||Wt(t,r,!0),T.tween=a,T.pr=-1,s.pop()}if(i){for(;m;){for(w=m._next,y=_;y&&y.pr>m.pr;)y=y._next;(m._prev=y?y._prev:x)?m._prev._next=m:_=m,(m._next=y)?y._prev=m:x=m,m=w}this._firstPT=_}return!0},h.parse=function(t,e,i,s){var o,a,h,u,f,d,p,m,y,_,x=t.style;for(o in e){if(d=e[o],"function"==typeof d&&(d=d(v,g)),a=l[o])i=a.parse(t,d,o,this,i,s,e);else{if("--"===o.substr(0,2)){this._tween._propLookup[o]=this._addTween.call(this._tween,t.style,"setProperty",K(t).getPropertyValue(o)+"",d+"",o,!1,o);continue}f=J(t,o,r)+"",y="string"==typeof d,"color"===o||"fill"===o||"stroke"===o||o.indexOf("Color")!==-1||y&&C.test(d)?(y||(d=dt(d),d=(d.length>3?"rgba(":"rgb(")+d.join(",")+")"),i=wt(x,o,f,d,!0,"transparent",i,0,s)):y&&R.test(d)?i=wt(x,o,f,d,!0,null,i,0,s):(h=parseFloat(f),p=h||0===h?f.substr((h+"").length):"",""!==f&&"auto"!==f||("width"===o||"height"===o?(h=ot(t,o,r),p="px"):"left"===o||"top"===o?(h=et(t,o,r),p="px"):(h="opacity"!==o?0:1,p="")),_=y&&"="===d.charAt(1),_?(u=parseInt(d.charAt(0)+"1",10),d=d.substr(2),u*=parseFloat(d),m=d.replace(b,"")):(u=parseFloat(d),m=y?d.replace(b,""):""),""===m&&(m=o in n?n[o]:p),d=u||0===u?(_?u+h:u)+m:e[o],p!==m&&(""===m&&"lineHeight"!==o||(u||0===u)&&h&&(h=tt(t,o,h,p),"%"===m?(h/=tt(t,o,100,"%")/100,e.strictUnits!==!0&&(f=h+"%")):"em"===m||"rem"===m||"vw"===m||"vh"===m?h/=tt(t,o,1,m):"px"!==m&&(u=tt(t,o,u,m),m="px"),_&&(u||0===u)&&(d=u+h+m))),_&&(u+=h),!h&&0!==h||!u&&0!==u?void 0!==x[o]&&(d||d+""!="NaN"&&null!=d)?(i=new _t(x,o,u||h||0,0,i,(-1),o,(!1),0,f,d),i.xs0="none"!==d||"display"!==o&&o.indexOf("Style")===-1?d:f):V("invalid "+o+" tween value: "+e[o]):(i=new _t(x,o,h,u-h,i,0,o,c!==!1&&("px"===m||"zIndex"===o),0,f,d),i.xs0=m))}s&&i&&!i.plugin&&(i.plugin=s)}return i},h.setRatio=function(t){var e,i,n,r=this._firstPT,s=1e-6;if(1!==t||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(t||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;r;){if(e=r.c*t+r.s,r.r?e=Math.round(e):e<s&&e>-s&&(e=0),r.type)if(1===r.type)if(n=r.l,2===n)r.t[r.p]=r.xs0+e+r.xs1+r.xn1+r.xs2;else if(3===n)r.t[r.p]=r.xs0+e+r.xs1+r.xn1+r.xs2+r.xn2+r.xs3;else if(4===n)r.t[r.p]=r.xs0+e+r.xs1+r.xn1+r.xs2+r.xn2+r.xs3+r.xn3+r.xs4;else if(5===n)r.t[r.p]=r.xs0+e+r.xs1+r.xn1+r.xs2+r.xn2+r.xs3+r.xn3+r.xs4+r.xn4+r.xs5;else{for(i=r.xs0+e+r.xs1,n=1;n<r.l;n++)i+=r["xn"+n]+r["xs"+(n+1)];r.t[r.p]=i}else r.type===-1?r.t[r.p]=r.xs0:r.setRatio&&r.setRatio(t);else r.t[r.p]=e+r.xs0;r=r._next}else for(;r;)2!==r.type?r.t[r.p]=r.b:r.setRatio(t),r=r._next;else for(;r;){if(2!==r.type)if(r.r&&r.type!==-1)if(e=Math.round(r.s+r.c),r.type){if(1===r.type){for(n=r.l,i=r.xs0+e+r.xs1,n=1;n<r.l;n++)i+=r["xn"+n]+r["xs"+(n+1)];r.t[r.p]=i}}else r.t[r.p]=e+r.xs0;else r.t[r.p]=r.e;else r.setRatio(t);r=r._next}},h._enableTransforms=function(t){this._transform=this._transform||Wt(this._target,r,!0),this._transformType=this._transform.svg&&Ct||!t&&3!==this._transformType?2:3};var Qt=function(t){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};h._addLazySet=function(t,e,i){var n=this._firstPT=new _t(t,e,0,0,this._firstPT,2);n.e=i,n.setRatio=Qt,n.data=this},h._linkCSSP=function(t,e,i,n){return t&&(e&&(e._prev=t),t._next&&(t._next._prev=t._prev),t._prev?t._prev._next=t._next:this._firstPT===t&&(this._firstPT=t._next,n=!0),i?i._next=t:n||null!==this._firstPT||(this._firstPT=t),t._next=e,t._prev=i),t},h._mod=function(t){for(var e=this._firstPT;e;)"function"==typeof t[e.p]&&t[e.p]===Math.round&&(e.r=1),e=e._next},h._kill=function(e){var i,n,r,s=e;if(e.autoAlpha||e.alpha){s={};for(n in e)s[n]=e[n];s.opacity=1,s.autoAlpha&&(s.visibility=1)}for(e.className&&(i=this._classNamePT)&&(r=i.xfirst,r&&r._prev?this._linkCSSP(r._prev,i._next,r._prev._prev):r===this._firstPT&&(this._firstPT=i._next),i._next&&this._linkCSSP(i._next,i._next._next,r._prev),this._classNamePT=null),i=this._firstPT;i;)i.plugin&&i.plugin!==n&&i.plugin._kill&&(i.plugin._kill(e),n=i.plugin),i=i._next;return t.prototype._kill.call(this,s)};var $t=function(t,e,i){var n,r,s,o;if(t.slice)for(r=t.length;--r>-1;)$t(t[r],e,i);else for(n=t.childNodes,r=n.length;--r>-1;)s=n[r],o=s.type,s.style&&(e.push(it(s)),i&&i.push(s)),1!==o&&9!==o&&11!==o||!s.childNodes.length||$t(s,e,i)};return o.cascadeTo=function(t,i,n){var r,s,o,a,l=e.to(t,i,n),h=[l],c=[],u=[],f=[],d=e._internals.reservedProps;for(t=l._targets||l.target,$t(t,c,f),l.render(i,!0,!0),$t(t,u),l.render(0,!0,!0),l._enabled(!0),r=f.length;--r>-1;)if(s=nt(f[r],c[r],u[r]),s.firstMPT){s=s.difs;for(o in n)d[o]&&(s[o]=n[o]);a={};for(o in s)a[o]=c[r][o];h.push(e.fromTo(f[r],i,a,s))}return h},t.activate([o]),o},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(t){"use strict";var e=function(){return(_gsScope.GreenSockGlobals||_gsScope)[t]};"undefined"!=typeof module&&module.exports?(require("../TweenLite.js"),module.exports=e()):"function"==typeof define&&define.amd&&define(["TweenLite"],e)}("CSSPlugin");



(function (factory) {
     typeof define === 'function' && define.amd ? define('index', factory) :
     factory();
   }((function () { 'use strict';
   
     function _classCallCheck(instance, Constructor) {
       if (!(instance instanceof Constructor)) {
         throw new TypeError("Cannot call a class as a function");
       }
     }
   
     function _defineProperties(target, props) {
       for (var i = 0; i < props.length; i++) {
         var descriptor = props[i];
         descriptor.enumerable = descriptor.enumerable || false;
         descriptor.configurable = true;
         if ("value" in descriptor) descriptor.writable = true;
         Object.defineProperty(target, descriptor.key, descriptor);
       }
     }
   
     function _createClass(Constructor, protoProps, staticProps) {
       if (protoProps) _defineProperties(Constructor.prototype, protoProps);
       if (staticProps) _defineProperties(Constructor, staticProps);
       return Constructor;
     }
   
     function _defineProperty(obj, key, value) {
       if (key in obj) {
         Object.defineProperty(obj, key, {
           value: value,
           enumerable: true,
           configurable: true,
           writable: true
         });
       } else {
         obj[key] = value;
       }
   
       return obj;
     }
   
     function _inherits(subClass, superClass) {
       if (typeof superClass !== "function" && superClass !== null) {
         throw new TypeError("Super expression must either be null or a function");
       }
   
       subClass.prototype = Object.create(superClass && superClass.prototype, {
         constructor: {
           value: subClass,
           writable: true,
           configurable: true
         }
       });
       if (superClass) _setPrototypeOf(subClass, superClass);
     }
   
     function _getPrototypeOf(o) {
       _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
         return o.__proto__ || Object.getPrototypeOf(o);
       };
       return _getPrototypeOf(o);
     }
   
     function _setPrototypeOf(o, p) {
       _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
         o.__proto__ = p;
         return o;
       };
   
       return _setPrototypeOf(o, p);
     }
   
     function _isNativeReflectConstruct() {
       if (typeof Reflect === "undefined" || !Reflect.construct) return false;
       if (Reflect.construct.sham) return false;
       if (typeof Proxy === "function") return true;
   
       try {
         Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
         return true;
       } catch (e) {
         return false;
       }
     }
   
     function _construct(Parent, args, Class) {
       if (_isNativeReflectConstruct()) {
         _construct = Reflect.construct;
       } else {
         _construct = function _construct(Parent, args, Class) {
           var a = [null];
           a.push.apply(a, args);
           var Constructor = Function.bind.apply(Parent, a);
           var instance = new Constructor();
           if (Class) _setPrototypeOf(instance, Class.prototype);
           return instance;
         };
       }
   
       return _construct.apply(null, arguments);
     }
   
     function _isNativeFunction(fn) {
       return Function.toString.call(fn).indexOf("[native code]") !== -1;
     }
   
     function _wrapNativeSuper(Class) {
       var _cache = typeof Map === "function" ? new Map() : undefined;
   
       _wrapNativeSuper = function _wrapNativeSuper(Class) {
         if (Class === null || !_isNativeFunction(Class)) return Class;
   
         if (typeof Class !== "function") {
           throw new TypeError("Super expression must either be null or a function");
         }
   
         if (typeof _cache !== "undefined") {
           if (_cache.has(Class)) return _cache.get(Class);
   
           _cache.set(Class, Wrapper);
         }
   
         function Wrapper() {
           return _construct(Class, arguments, _getPrototypeOf(this).constructor);
         }
   
         Wrapper.prototype = Object.create(Class.prototype, {
           constructor: {
             value: Wrapper,
             enumerable: false,
             writable: true,
             configurable: true
           }
         });
         return _setPrototypeOf(Wrapper, Class);
       };
   
       return _wrapNativeSuper(Class);
     }
   
     function _assertThisInitialized(self) {
       if (self === void 0) {
         throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
       }
   
       return self;
     }
   
     function _possibleConstructorReturn(self, call) {
       if (call && (typeof call === "object" || typeof call === "function")) {
         return call;
       }
   
       return _assertThisInitialized(self);
     }
   
     function _createSuper(Derived) {
       var hasNativeReflectConstruct = _isNativeReflectConstruct();
   
       return function _createSuperInternal() {
         var Super = _getPrototypeOf(Derived),
             result;
   
         if (hasNativeReflectConstruct) {
           var NewTarget = _getPrototypeOf(this).constructor;
   
           result = Reflect.construct(Super, arguments, NewTarget);
         } else {
           result = Super.apply(this, arguments);
         }
   
         return _possibleConstructorReturn(this, result);
       };
     }
   
     var Responsive = /*#__PURE__*/function () {
       function Responsive() {
         var _this = this;
   
         _classCallCheck(this, Responsive);
   
         this.currentBreakpoint = Responsive.getCurrentBreakpoint();
         window.addEventListener('resize', function () {
           var newBreakpoint = Responsive.getCurrentBreakpoint();
   
           if (_this.currentBreakpoint === newBreakpoint) {
             return;
           }
   
           document.dispatchEvent(new CustomEvent('breakpoint:changed', {
             detail: {
               previousBreakpoint: _this.currentBreakpoint,
               currentBreakpoint: newBreakpoint
             }
           }));
           _this.currentBreakpoint = newBreakpoint;
         });
       }
   
       _createClass(Responsive, null, [{
         key: "matchesBreakpoint",
         value: function matchesBreakpoint(breakpoint) {
           switch (breakpoint) {
             case 'phone':
               return window.matchMedia('screen and (max-width: 640px)').matches;
   
             case 'tablet':
               return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;
   
             case 'tablet-and-up':
               return window.matchMedia('screen and (min-width: 641px)').matches;
   
             case 'pocket':
               return window.matchMedia('screen and (max-width: 1007px)').matches;
   
             case 'lap':
               return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;
   
             case 'lap-and-up':
               return window.matchMedia('screen and (min-width: 1008px)').matches;
   
             case 'desk':
               return window.matchMedia('screen and (min-width: 1280px)').matches;
   
             case 'widescreen':
               return window.matchMedia('screen and (min-width: 1600px)').matches;
   
             case 'supports-hover':
               return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
           }
         }
       }, {
         key: "getCurrentBreakpoint",
         value: function getCurrentBreakpoint() {
           if (window.matchMedia('screen and (max-width: 640px)').matches) {
             return 'phone';
           }
   
           if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
             return 'tablet';
           }
   
           if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
             return 'lap';
           }
   
           if (window.matchMedia('screen and (min-width: 1280px)').matches) {
             return 'desk';
           }
         }
       }]);
   
       return Responsive;
     }();
   
     var Carousel = /*#__PURE__*/function () {
       function Carousel(element) {
         var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
         var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
   
         _classCallCheck(this, Carousel);
   
         this.element = element;
         this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings);
         this.options = options;
   
         this._attachListeners();
   
         this._build();
       }
   
       _createClass(Carousel, [{
         key: "destroy",
         value: function destroy() {
           this.flickityInstance.destroy();
   
           if (this.initialConfig['breakpoints'] !== undefined) {
             document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
           }
         }
       }, {
         key: "getFlickityInstance",
         value: function getFlickityInstance() {
           return this.flickityInstance;
         }
       }, {
         key: "selectCell",
         value: function selectCell(index) {
           var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
           var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
   
           if (shouldPause) {
             this.flickityInstance.pausePlayer();
           }
   
           this.flickityInstance.select(index, false, !shouldAnimate);
         }
       }, {
         key: "next",
         value: function next() {
           this.flickityInstance.next();
         }
       }, {
         key: "previous",
         value: function previous() {
           this.flickityInstance.previous();
         }
       }, {
         key: "pausePlayer",
         value: function pausePlayer() {
           this.flickityInstance.pausePlayer();
         }
       }, {
         key: "unpausePlayer",
         value: function unpausePlayer() {
           this.flickityInstance.unpausePlayer();
         }
       }, {
         key: "resize",
         value: function resize() {
           this.flickityInstance.resize();
         }
       }, {
         key: "getSelectedIndex",
         value: function getSelectedIndex() {
           return this.flickityInstance.selectedIndex;
         }
       }, {
         key: "getSelectedCell",
         value: function getSelectedCell() {
           return this.flickityInstance.selectedCell.element;
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           if (this.initialConfig['breakpoints'] !== undefined) {
             this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
             document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
           }
         }
         /**
          * Create the carousel instance
          */
   
       }, {
         key: "_build",
         value: function _build() {
           var _this = this;
   
           var config = this._processConfig();
   
           this.flickityInstance = new Flickity(this.element, config);
   
           this._validateDraggable();
   
           this.selectedIndex = this.flickityInstance.selectedIndex;
           this.flickityInstance.on('resize', this._validateDraggable.bind(this));
   
           if (this.options['onSelect']) {
             this.flickityInstance.on('select', function () {
               // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
               // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
               if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
                 _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
   
                 _this.selectedIndex = _this.flickityInstance.selectedIndex;
               }
             });
           }
   
           if (this.options['onSettle']) {
             this.flickityInstance.on('settle', function (index) {
               _this.options['onSettle'](index, _this.flickityInstance.selectedCell.element);
             });
           }
   
           if (this.options['onClick']) {
             this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
               _this.options['onClick'](cell, index);
             });
           }
         }
         /**
          * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
          * if the displayed elements equals to the amount of elements
          */
   
       }, {
         key: "_validateDraggable",
         value: function _validateDraggable() {
           var isActive = this.flickityInstance.isActive || false;
   
           if (!isActive || !this.flickityInstance.options['draggable']) {
             return; // Not draggable, so nothing to do
           }
   
           if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
             this.flickityInstance.unbindDrag();
           } else {
             this.flickityInstance.bindDrag();
           }
         }
         /**
          * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
          */
   
       }, {
         key: "_processConfig",
         value: function _processConfig() {
           var config = Object.assign({}, this.initialConfig);
           delete config['breakpoints'];
   
           if (this.initialConfig['breakpoints'] === undefined) {
             return config; // No change, we simply return the config as it is
           }
   
           var breakpoints = this.initialConfig['breakpoints'];
           breakpoints.forEach(function (breakpoint) {
             if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
               config = Object.assign(config, breakpoint['settings']);
             }
           });
           return config;
         }
         /**
          * Verify if the breakpoint has changed, and optionally update the carousel
          */
   
       }, {
         key: "_onBreakpointChanged",
         value: function _onBreakpointChanged() {
           // The breakpoint may have changed, so we delete the carousel and rebuild it
           this.flickityInstance.destroy();
   
           this._build();
         }
       }]);
   
       return Carousel;
     }();
   
     var Animation = /*#__PURE__*/function () {
       function Animation() {
         _classCallCheck(this, Animation);
       }
   
       _createClass(Animation, null, [{
         key: "slideUp",
         value:
         /**
          * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
          * force an animation
          */
         function slideUp(element) {
           element.style.height = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition
   
           element.offsetHeight; // Force redraw
   
           element.style.height = 0;
         }
         /**
          * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
          * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
          */
   
       }, {
         key: "slideDown",
         value: function slideDown(element) {
           if (element.style.height === 'auto') {
             return;
           } // To do the animation we temporarily hide it, check the height, and transition to it
   
   
           element.style.height = "".concat(element.firstElementChild.scrollHeight, "px");
   
           var transitionEnded = function transitionEnded(event) {
             if (event.propertyName === 'height') {
               element.style.height = 'auto'; // Allows the content to grow normally
   
               element.removeEventListener('transitionend', transitionEnded);
             }
           };
   
           element.addEventListener('transitionend', transitionEnded);
         }
       }]);
   
       return Animation;
     }();
   
     /**
      * Various DOM helper
      */
     var Dom = /*#__PURE__*/function () {
       function Dom() {
         _classCallCheck(this, Dom);
       }
   
       _createClass(Dom, null, [{
         key: "getSiblings",
         value:
         /**
          * Get all the previous and next siblings, optionally filtered by a selector
          */
         function getSiblings(element, filter) {
           var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
           var siblings = [];
           var currentElement = element; // Do the previous first
   
           while (currentElement = currentElement.previousElementSibling) {
             if (!filter || currentElement.matches(filter)) {
               siblings.push(currentElement);
             }
           }
   
           if (includeSelf) {
             siblings.push(element);
           } // Then the next side
   
   
           currentElement = element;
   
           while (currentElement = currentElement.nextElementSibling) {
             if (!filter || currentElement.matches(filter)) {
               siblings.push(currentElement);
             }
           }
   
           return siblings;
         }
         /**
          * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
          * we need to normalize it
          */
   
       }, {
         key: "nodeListToArray",
         value: function nodeListToArray(nodeList, filter) {
           var items = [];
   
           for (var i = 0; i !== nodeList.length; ++i) {
             if (!filter || nodeList[i].matches(filter)) {
               items.push(nodeList[i]);
             }
           }
   
           return items;
         }
         /**
          * Calculate an element width with its margin
          */
   
       }, {
         key: "outerWidthWithMargin",
         value: function outerWidthWithMargin(element) {
           var width = element.offsetWidth,
               style = getComputedStyle(element);
           width += parseInt(style.marginLeft) + parseInt(style.marginRight);
           return width;
         }
         /**
          * Calculate an element height with its margin
          */
   
       }, {
         key: "outerHeightWithMargin",
         value: function outerHeightWithMargin(element) {
           var height = element.offsetHeight,
               style = getComputedStyle(element);
           height += parseInt(style.marginTop) + parseInt(style.marginBottom);
           return height;
         }
       }]);
   
       return Dom;
     }();
   
     var Collapsible = /*#__PURE__*/function () {
       function Collapsible() {
         _classCallCheck(this, Collapsible);
   
         this.domDelegate = new domDelegate.Delegate(document.body);
   
         this._attachListeners();
       }
   
       _createClass(Collapsible, [{
         key: "_attachListeners",
         value: function _attachListeners() {
           this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
         }
         /**
          * Toggle a given collapsible
          */
   
       }, {
         key: "_toggleCollapsible",
         value: function _toggleCollapsible(event, target) {
           var _this = this;
   
           // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
           var parentCollapsible = target.closest('.Collapsible');
   
           if (parentCollapsible.classList.contains('Collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
             return;
           }
   
           var isOpen = target.getAttribute('aria-expanded') === 'true';
   
           if (isOpen) {
      
           //  this._close(parentCollapsible, target); If this is commentarised we make sure that the element stays open
           } else {
             this._open(parentCollapsible, target);
           } // We make sure to close any siblings collapsible as well
   
           Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
             return _this._close(collapsibleToClose);
           });
           event.preventDefault();
         }
         /**
          * Open a given collapsible
          */
   
       }, {
         key: "_open",
         value: function _open(collapsible) {
           var toggleButton = collapsible.querySelector('.Collapsible__Button'),
               collapsibleInner = collapsible.querySelector('.Collapsible__Inner');
   
           if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
               
             return; // It's already open
           }
   
           toggleButton.setAttribute('aria-expanded', 'true');
           collapsibleInner.style.overflow = 'visible';
           Animation.slideDown(collapsibleInner);
           setTimeout(function () {
             collapsible.style.overflow = 'visible';
           }, 155);
      
         }
         /**
          * Close a given collapsible
          */
   
       }, {
         key: "_close",
         value: function _close(collapsible) {
           var toggleButton = collapsible.querySelector('.Collapsible__Button'),
               collapsibleInner = collapsible.querySelector('.Collapsible__Inner');
   
           if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
             return; // It's already closed
           }
   
           toggleButton.setAttribute('aria-expanded', 'false');
           collapsibleInner.style.overflow = 'hidden';
           collapsible.style.overflow = 'hidden';
           Animation.slideUp(collapsibleInner);
         }
       }]);
   
       return Collapsible;
     }();
   
     var Accessibility = /*#__PURE__*/function () {
       function Accessibility() {
         _classCallCheck(this, Accessibility);
       }
   
       _createClass(Accessibility, null, [{
         key: "trapFocus",
         value:
         /**
          * Traps the focus in a particular container
          */
         function trapFocus(container, namespace) {
           this.listeners = this.listeners || {}; // We check if there is an element with the attribute "autofocus"
   
           var elementToFocus = container.querySelector('[autofocus]') || container;
           container.setAttribute('tabindex', '-1');
           elementToFocus.focus();
   
           this.listeners[namespace] = function (event) {
             if (container !== event.target && !container.contains(event.target)) {
               container.focus();
             }
           };
   
           document.addEventListener('focusin', this.listeners[namespace]);
         }
         /**
          * Removes the trap of focus in a particular container
          */
   
       }, {
         key: "removeTrapFocus",
         value: function removeTrapFocus(container, namespace) {
           if (container) {
             container.removeAttribute('tabindex');
           }
   
           if (this.listeners && this.listeners[namespace]) {
             document.removeEventListener('focusin', this.listeners[namespace]);
           }
         }
         /**
          * Reset any previous trap focus
          */
   
       }, {
         key: "clearTrapFocus",
         value: function clearTrapFocus() {
           for (var key in this.listeners) {
             if (this.listeners.hasOwnProperty(key)) {
               document.removeEventListener('focusin', this.listeners[key]);
             }
           }
   
           this.listeners = {};
         }
       }]);
   
       return Accessibility;
     }();
   
     var Drawer = /*#__PURE__*/function () {
       function Drawer(element) {
         var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
         _classCallCheck(this, Drawer);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.delegateBody = new domDelegate.Delegate(document.body);
   
         this.onOpen = options['onOpen'] || function () {};
   
         this.onClose = options['onClose'] || function () {};
   
         this.isOpen = false;
         this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';
         this.pageOverlayElement = document.querySelector('.PageOverlay');
   
         this._attachListeners();
       }
   
       _createClass(Drawer, [{
         key: "destroy",
         value: function destroy() {
           this.delegateBody.off('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
           this.delegateBody.off('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
           window.removeEventListener('resize', this._calculateMaxHeightListener);
         }
       }, {
         key: "toggle",
         value: function toggle() {
           this.isOpen ? this.close() : this.open();
         }
       }, {
         key: "open",
         value: function open(event) {
           if (this.isOpen) {
             return;
           } // Make sure that the search is closed whenever a drawer is opened
   
   
           this.element.dispatchEvent(new CustomEvent('search:close', {
             bubbles: true
           }));
   
           if (event) {
             event.preventDefault();
           }
   
           this.element.setAttribute('aria-hidden', 'false');
   
           this._calculateMaxHeight();
   
           document.documentElement.classList.add('no-scroll'); // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
           // other browsers, this is the only way to achieve that
           //disableBodyScroll(true, '[data-scrollable]');
   
           Accessibility.trapFocus(this.element, 'drawer');
           document.querySelector('#shopify-section-header').style.zIndex = ''; // Ugly hack
           // We attach an event to the page overlay to close it
   
           this.pageOverlayElement.classList.add('is-visible');
           this.pageOverlayElement.addEventListener('click', this._closeListener);
           this.isOpen = true;
           this.onOpen(); // Call the callback to allow other code to hook their logic
   
           return false;
         }
       }, {
         key: "close",
         value: function close(event) {
           if (!this.isOpen) {
             return;
           }
   
           if (event) {
             event.preventDefault();
           }
   
           this.element.setAttribute('aria-hidden', 'true');
           document.documentElement.classList.remove('no-scroll'); //disableBodyScroll(false, '[data-scrollable]');
   
           Accessibility.removeTrapFocus(this.element, 'drawer');
           this.pageOverlayElement.classList.remove('is-visible');
           this.pageOverlayElement.removeEventListener('click', this._closeListener);
           this.isOpen = false;
           this.onClose(); // Call the callback to allow other code to hook their logic
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._openListener = this.open.bind(this);
           this._closeListener = this.close.bind(this);
           this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
           this.delegateBody.on('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._openListener);
           this.delegateBody.on('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._closeListener);
           this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
           window.addEventListener('resize', this._calculateMaxHeightListener);
         }
         /**
          * Make sure that we force a max-height so that the drawer always stays on screen
          */
   
       }, {
         key: "_calculateMaxHeight",
         value: function _calculateMaxHeight() {
           this.element.style.maxHeight = window.innerHeight + 'px';
         }
       }, {
         key: "_handleKeyboard",
         value:
         /**
          * Handle a11y events
          */
         function _handleKeyboard(event) {
           if (this.isOpen && event.keyCode === 27) {
             this.close();
           }
         }
       }]);
   
       return Drawer;
     }();
   
     /**
      * Simple plugin that handles the loading bar actions
      *
      * This plugin uses delegate events so it's independent of the sections.
      */
     var LoadingBar = /*#__PURE__*/function () {
       function LoadingBar() {
         _classCallCheck(this, LoadingBar);
   
         this.element = document.querySelector('.LoadingBar');
         document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
         document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
         this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
       }
   
       _createClass(LoadingBar, [{
         key: "_onLoadingStart",
         value: function _onLoadingStart() {
           this.element.classList.add('is-visible');
           this.element.style.width = '40%';
         }
       }, {
         key: "_onLoadingEnd",
         value: function _onLoadingEnd() {
           this.element.style.width = '100%';
           this.element.classList.add('is-finished');
         }
       }, {
         key: "_onTransitionEnd",
         value: function _onTransitionEnd(event) {
           if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
             this.element.classList.remove('is-visible');
             this.element.classList.remove('is-finished');
             this.element.style.width = '0';
           }
         }
       }]);
   
       return LoadingBar;
     }();
   
     var Modal = /*#__PURE__*/function () {
       function Modal() {
         _classCallCheck(this, Modal);
   
         this.domDelegate = new domDelegate.Delegate(document.body);
         this.activeModal = null; // Keep track of the active modal
   
         this.wasLocked = false;
         this.pageOverlayElement = document.querySelector('.PageOverlay');
   
         this._attachListeners();
   
         this._checkOpenByHash();
       }
   
       _createClass(Modal, [{
         key: "_attachListeners",
         value: function _attachListeners() {
           this._closeListener = this._closeModal.bind(this);
           this._handleKeyboardListener = this._handleKeyboard.bind(this);
           this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
           this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
         }
       }, {
         key: "_openModalEvent",
         value: function _openModalEvent(event, target) {
           this._openModal(document.getElementById(target.getAttribute('aria-controls')));
   
           event.preventDefault();
           event.stopPropagation();
         }
       }, {
         key: "_openModal",
         value: function _openModal(modal) {
           var _this = this;
   
           if (this.activeModal || !modal) {
             return; // If there is already an open modal, we return as we only allows one modal at a time
           }
   
           this.activeModal = modal;
           this.domDelegate.on('keyup', this._handleKeyboardListener);
   
           if (document.documentElement.classList.contains('no-scroll')) {
             this.wasLocked = true;
           }
   
           fastdom.mutate(function () {
             Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover
   
             _this._onTransitionEndedListener = _this._onTransitionEnded.bind(_this);
   
             _this.activeModal.addEventListener('transitionend', _this._onTransitionEndedListener);
   
             _this.activeModal.setAttribute('aria-hidden', 'false');
   
             document.documentElement.classList.add('no-scroll'); // If the modal is not a fullscreen modal, then we also display the overlay
   
             if (!_this.activeModal.classList.contains('Modal--fullScreen')) {
               _this.pageOverlayElement.classList.add('is-visible');
   
               _this.pageOverlayElement.addEventListener('click', _this._closeListener);
             }
           });
         }
       }, {
         key: "_closeModal",
         value: function _closeModal() {
           var _this2 = this;
   
           if (!this.activeModal) {
             return; // If no modal are open, we return immediately
           }
   
           this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
           this.domDelegate.off('keyup');
           fastdom.mutate(function () {
             // If the modal is of video type, we need to remove the iframe to stop the video
             if (_this2.activeModal.classList.contains('Modal--videoContent')) {
               _this2._resetVideoListener = _this2._resetVideo.bind(_this2);
   
               _this2.activeModal.addEventListener('transitionend', _this2._resetVideoListener);
             }
   
             Accessibility.removeTrapFocus(_this2.activeModal, 'modal');
   
             if (!_this2.activeModal.classList.contains('Modal--fullScreen')) {
               _this2.pageOverlayElement.classList.remove('is-visible');
   
               _this2.pageOverlayElement.removeEventListener('click', _this2._closeListener);
             }
   
             _this2.activeModal.setAttribute('aria-hidden', 'true');
   
             _this2.activeModal = null;
   
             if (!_this2.wasLocked) {
               document.documentElement.classList.remove('no-scroll');
             }
           });
         }
       }, {
         key: "_onTransitionEnded",
         value: function _onTransitionEnded(event) {
           if (event.propertyName !== 'visibility') {
             return;
           }
   
           Accessibility.trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)
   
           this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
         }
       }, {
         key: "_resetVideo",
         value: function _resetVideo(event) {
           if (event.propertyName !== 'visibility') {
             return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
           }
   
           var iframe = event.target.querySelector('iframe');
           iframe.parentNode.innerHTML = "<iframe class=\"Image--lazyLoad\" data-src=".concat(iframe.getAttribute('data-src'), " frameborder=\"0\" allowfullscreen>");
           event.target.removeEventListener('transitionend', this._resetVideoListener);
         }
         /**
          * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
          */
   
       }, {
         key: "_checkOpenByHash",
         value: function _checkOpenByHash() {
           var hash = window.location.hash,
               modal = document.getElementById(hash.replace('#', ''));
   
           if (modal && modal.classList.contains('Modal')) {
             this._openModal(modal);
           }
         }
         /**
          * Handle a11y events
          */
   
       }, {
         key: "_handleKeyboard",
         value: function _handleKeyboard(event) {
           if (null !== this.activeModal && event.keyCode === 27) {
             this._closeModal();
           }
         }
       }]);
   
       return Modal;
     }();
   
     var Popover = /*#__PURE__*/function () {
       function Popover(element, options) {
         _classCallCheck(this, Popover);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
         this.preferredPosition = options['preferredPosition'] || 'bottom';
         this.preferredAlignment = options['preferredAlignment'] || undefined;
         this.threshold = options['threshold'] || 20;
         this.isOpen = false;
   
         this.onValueChanged = options['onValueChanged'] || function () {};
   
         this.onOpen = options['onOpen'] || function () {};
   
         this.onClose = options['onClose'] || function () {};
   
         this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
         this.pageOverlayElement = document.querySelector('.PageOverlay');
   
         this._attachListeners();
       }
   
       _createClass(Popover, [{
         key: "destroy",
         value: function destroy() {
           this.element.removeEventListener('keyup', this._handleKeyboardListener);
           this.delegateElement.off('click');
           this.activator.removeEventListener('click', this._toggleListener);
         }
       }, {
         key: "toggle",
         value: function toggle() {
           this.isOpen ? this.close() : this.open();
         }
       }, {
         key: "open",
         value: function open() {
           var _this = this;
   
           // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
           //       popovers and be modified dynamically in JavaScript
           if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
             return;
           }
   
           this.element.setAttribute('aria-hidden', 'false');
           this.activator.setAttribute('aria-expanded', 'true');
           disableBodyScroll(true, '[data-scrollable]');
           document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open
   
           if (Responsive.matchesBreakpoint('lap-and-up')) {
             document.body.addEventListener('click', this._clickOutsideListener);
   
             this._position();
   
             this.element.setAttribute('tabindex', '-1');
             this.element.addEventListener('transitionend', function () {
               _this.element.focus();
             }, {
               once: true
             });
           } else {
             this.element.removeAttribute('style');
   
             if (this.showOverlay) {
               this.pageOverlayElement.classList.add('is-visible');
               this.pageOverlayElement.addEventListener('click', this._closeListener);
             }
           }
   
           this.onOpen(this); // Call the callback to allow other code to hook their logic
   
           this.isOpen = true;
         }
       }, {
         key: "close",
         value: function close() {
           if (!this.isOpen) {
             return;
           }
   
           this.element.setAttribute('aria-hidden', 'true');
           this.activator.setAttribute('aria-expanded', 'false');
           disableBodyScroll(false, '[data-scrollable]');
           document.documentElement.classList.remove('no-scroll');
   
           if (Responsive.matchesBreakpoint('lap-and-up')) {
             document.body.removeEventListener('click', this._clickOutsideListener);
           } else if (this.showOverlay) {
             this.pageOverlayElement.classList.remove('is-visible');
             this.pageOverlayElement.removeEventListener('click', this._closeListener);
           }
   
           this.element.removeAttribute('tabindex');
           this.activator.focus();
           this.onClose(this); // Call the callback to allow other code to hook their logic
   
           this.isOpen = false;
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._handleKeyboardListener = this._handleKeyboard.bind(this);
           this._clickOutsideListener = this._clickOutside.bind(this);
           this._closeListener = this.close.bind(this);
           this._toggleListener = this.toggle.bind(this);
           this.element.addEventListener('keyup', this._handleKeyboardListener);
           this.activator.addEventListener('click', this._toggleListener);
           this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
           this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));
   
           if (this.element.hasAttribute('id')) {
             this.delegateElement.on('focusout', "#".concat(this.element.getAttribute('id')), this._onFocusOut.bind(this));
           }
         }
         /**
          * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
          * of the value change
          */
   
       }, {
         key: "_valueChanged",
         value: function _valueChanged(event) {
           Dom.getSiblings(event.target, '.is-selected').forEach(function (item) {
             return item.classList.remove('is-selected');
           });
           event.target.classList.add('is-selected'); // If there is a callback in option we call it with the value
   
           this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
           this.close();
         }
       }, {
         key: "_onFocusOut",
         value: function _onFocusOut(event) {
           if (!this.element.contains(event.relatedTarget) && event.relatedTarget !== this.activator) {
             this.close();
           }
         }
         /**
          * Callback that is called to decide if we should close the popover when a click is captured outside
          */
   
       }, {
         key: "_clickOutside",
         value: function _clickOutside(event) {
           if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
             this.close();
           }
         }
         /**
          * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
          */
   
       }, {
         key: "_position",
         value: function _position() {
           var _this2 = this;
   
           var topPosition = 0,
               rightPosition = 0,
               position = '',
               alignment = '',
               threshold = this.threshold;
           fastdom.measure(function () {
             var windowHeight = window.innerHeight,
                 activatorBoundingRect = _this2.activator.getBoundingClientRect(),
                 halfHeight = windowHeight / 2;
   
             if (_this2.preferredPosition === 'bottom') {
               alignment = 'right';
   
               if (_this2.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
                 position = 'bottom';
               } else {
                 position = 'top';
               }
             } else if (_this2.preferredPosition === 'top') {
               alignment = 'right';
   
               if (_this2.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
                 position = 'top';
               } else {
                 position = 'bottom';
               }
             } else {
               position = 'left'; // Is there enough space to use the center alignment (which is preferred)?
   
               var halfElementHeight = _this2.element.clientHeight / 2;
   
               if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
                 alignment = 'center';
               } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
                 alignment = 'bottom';
               } else {
                 alignment = 'top';
               }
             }
   
             if (_this2.preferredAlignment) {
               alignment = _this2.preferredAlignment;
             }
   
             if (position === 'top') {
               topPosition = activatorBoundingRect.top - _this2.element.clientHeight - threshold;
   
               if (alignment === 'center') {
                 rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
               } else {
                 rightPosition = window.innerWidth - activatorBoundingRect.right;
               }
             } else if (position === 'bottom') {
               topPosition = activatorBoundingRect.bottom + threshold;
   
               if (alignment === 'center') {
                 rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
               } else {
                 rightPosition = window.innerWidth - activatorBoundingRect.right;
               }
             } else {
               rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
   
               if (alignment === 'center') {
                 topPosition = activatorBoundingRect.top - _this2.element.clientHeight / 2 + _this2.activator.clientHeight / 2;
               } else if (alignment === 'top') {
                 topPosition = activatorBoundingRect.bottom - _this2.element.clientHeight;
               } else {
                 topPosition = activatorBoundingRect.top;
               }
             }
           });
           fastdom.mutate(function () {
             ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
               return _this2.element.classList.remove(item);
             });
   
             _this2.element.classList.add("Popover--position".concat(position.charAt(0).toUpperCase() + position.slice(1)));
   
             _this2.element.classList.add("Popover--align".concat(alignment.charAt(0).toUpperCase() + alignment.slice(1)));
   
             _this2.element.setAttribute('style', "top: ".concat(parseInt(topPosition), "px; right: ").concat(parseInt(rightPosition), "px;"));
           });
         }
         /**
          * Handle a11y events
          */
   
       }, {
         key: "_handleKeyboard",
         value: function _handleKeyboard(event) {
           if (this.isOpen && event.keyCode === 27) {
             this.close();
           }
         }
       }]);
   
       return Popover;
     }();
   
     /**
      * This class will coordinate all the transitions from the website
      */
     var PageTransition = /*#__PURE__*/function () {
       function PageTransition() {
         _classCallCheck(this, PageTransition);
   
         this.domDelegate = new domDelegate.Delegate(document.body);
         this.pageTransition = document.querySelector('.PageTransition');
   
         this._attachListeners();
       }
   
       _createClass(PageTransition, [{
         key: "_attachListeners",
         value: function _attachListeners() {
           this.domDelegate.on('click', 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
         }
         /**
          * This callback captures click and transition from one page to another by doing a transition
          */
   
       }, {
         key: "_onPageUnload",
         value: function _onPageUnload(event, target) {
           var _this = this;
   
           if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageTransition) {
             return;
           }
   
           event.preventDefault(); // Prevent the click to happen
   
           if (window.theme.showPageTransition && this.pageTransition) {
             var doTransition = function doTransition(event) {
               // Animation is finished, we can transition
               if (event.propertyName === 'opacity') {
                 _this.pageTransition.removeEventListener('transitionend', doTransition);
   
                 window.location.href = target.href;
               }
             };
   
             this.pageTransition.addEventListener('transitionend', doTransition);
             this.pageTransition.style.visibility = 'visible';
             this.pageTransition.style.opacity = '1';
           }
         }
       }], [{
         key: "getInstance",
         value: function getInstance() {
           if (!this.instance) {
             this.instance = new PageTransition();
           }
   
           return this.instance;
         }
       }]);
   
       return PageTransition;
     }();
   
     /**
      * Note: this was a feature that was added at the very end and couldn't do something much cleaner without rewriting large parts of the theme...
      */
     var ProductItemColorSwatch = /*#__PURE__*/function () {
       function ProductItemColorSwatch(element) {
         _classCallCheck(this, ProductItemColorSwatch);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.delegateElement.on('change', '.ColorSwatch__Radio', this._colorChanged.bind(this));
       }
   
       _createClass(ProductItemColorSwatch, [{
         key: "_colorChanged",
         value: function _colorChanged(event, target) {
           // We need to change the URL of the various links
           var productItem = target.closest('.ProductItem'),
               variantUrl = target.getAttribute('data-variant-url');
           productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);
           productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl); // If we have a custom image for the variant, we change it
   
           var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
   
           if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
             var newImageElement = document.createElement('img');
             newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
             newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
             newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
             newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
             newImageElement.setAttribute('data-sizes', 'auto'); // Replace the original node
   
             if (window.theme.productImageSize === 'natural') {
               originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / target.getAttribute('data-image-aspect-ratio'), "%");
             }
   
             originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
             originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
           }
         }
       }]);
   
       return ProductItemColorSwatch;
     }();
   
     var Image = /*#__PURE__*/function () {
       function Image() {
         _classCallCheck(this, Image);
       }
   
       _createClass(Image, null, [{
         key: "getSizedImageUrl",
         value:
         /**
          * Create a CDN URL (similar to the img_url filter in Liquid)
          */
         function getSizedImageUrl(src, size) {
           if (size === null) {
             return src;
           }
   
           if (size === 'master') {
             return src.replace(/http(s)?:/, '');
           }
   
           var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
   
           if (match) {
             var prefix = src.split(match[0]);
             var suffix = match[0];
             return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
           } else {
             return null;
           }
         }
         /**
          * From a given set of desired sizes and a given image, filter out any unwanted sizes
          */
   
       }, {
         key: "getSupportedSizes",
         value: function getSupportedSizes(image, desiredSizes) {
           var supportedSizes = [],
               imageWidth = image['width'];
           desiredSizes.forEach(function (width) {
             if (imageWidth >= width) {
               supportedSizes.push(width);
             }
           });
           return supportedSizes;
         }
       }]);
   
       return Image;
     }();
   
     var ProductImageZoom = /*#__PURE__*/function () {
       function ProductImageZoom(element, slideshow) {
         _classCallCheck(this, ProductImageZoom);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.delegateRoot = new domDelegate.Delegate(document.body);
         this.slideshow = slideshow;
   
         this._attachListeners();
       }
   
       _createClass(ProductImageZoom, [{
         key: "destroy",
         value: function destroy() {
           this.delegateElement.off('click');
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           //this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
           //this.delegateElement.on('click', '.Product__SlideItem--image', this._initPhotoSwipeFromImageClick.bind(this));
         }
         /**
          * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
          * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
          * whenever it is closed, so it stays super snappy
          */
   
       }, {
         key: "_initPhotoSwipe",
         value: function _initPhotoSwipe() {
           var images = [];
           this.slideshow.flickityInstance.cells.forEach(function (item) {
             if (item.element.classList.contains('Product__SlideItem--image')) {
               images.push(item.element.querySelector('img'));
             }
           });
   
           this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute('data-image-media-position')));
         }
         /**
          * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
          */
   
       }, {
         key: "_initPhotoSwipeFromImageClick",
         value: function _initPhotoSwipeFromImageClick(event, target) {
           // Opening this way is only available on desktop
           if (Responsive.matchesBreakpoint('pocket')) {
             return;
           }
   
           var images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img'));
   
           this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(target.getAttribute('data-image-media-position')));
         }
         /**
          * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
          */
   
       }, {
         key: "_createPhotoSwipeItemsFromImages",
         value: function _createPhotoSwipeItemsFromImages(images) {
           return images.map(function (image) {
             var maxWidth = parseInt(image.getAttribute('data-max-width')),
                 maxHeight = parseInt(image.getAttribute('data-max-height')),
                 maxDimension = Responsive.matchesBreakpoint('phone') ? 1200 : 1800,
                 // 1200 is max size for mobile and 1800 for larger devices
             reduceFactor = 1.0;
   
             if (maxWidth >= maxHeight) {
               reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
             } else {
               reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
             }
   
             var requestedWidth = Math.floor(maxWidth / reduceFactor);
             var requestedHeight = Math.floor(maxHeight / reduceFactor);
             return {
               msrc: image.currentSrc || image.src,
               // For browser that supports srcset, currentSrc is the currently used image
               w: requestedWidth,
               h: requestedHeight,
               initialZoomLevel: 0.65,
               src: Image.getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight)
             };
           });
         }
         /**
          * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
          * whenever the gallery is initialized.
          */
   
       }, {
         key: "_createPhotoSwipeInstance",
         value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
           var _this = this;
   
           var photoswipeContainer = document.querySelector('.pswp');
           this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
             index: selectedImageIndex,
             showHideOpacity: true,
             showAnimationDuration: 500,
             loop: false,
             history: false,
             closeOnVerticalDrag: false,
             allowPanToNext: false,
             pinchToClose: false,
             errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
             scaleMode: 'zoom',
             getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
               if (isMouseClick) {
                 return 1.6;
               } else {
                 return item.initialZoomLevel < 0.7 ? 1 : 1.33;
               }
             },
             getThumbBoundsFn: function getThumbBoundsFn(index) {
               var thumbnail = _this.element.querySelector(".Product__Slideshow .Carousel__Cell[data-image-media-position=\"".concat(parseInt(index), "\"] img")),
                   pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                   rect = thumbnail.getBoundingClientRect();
   
               return {
                 x: rect.left,
                 y: rect.top + pageYScroll,
                 w: rect.width
               };
             }
           }); // We need to patch PhotoSwipe update size to solve iOS 15 issue
   
           var originalUpdateSize = this.photoSwipeInstance.updateSize,
               lastWidth = null;
   
           this.photoSwipeInstance.updateSize = function () {
             if (lastWidth === null || lastWidth !== window.innerWidth) {
               originalUpdateSize(this, arguments);
             }
   
             lastWidth = window.innerWidth;
           };
   
           this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
           this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
           this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
           this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
           this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));
           this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
           this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
           this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
           this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);
           this.photoSwipeInstance.init();
         }
         /**
          * Update the nav
          */
   
       }, {
         key: "_onSlideChanged",
         value: function _onSlideChanged() {
           if (this.photoSwipeInstance.getCurrentIndex() === 0) {
             this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
           } else {
             this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
           }
   
           if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
             this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
           } else {
             this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
           }
         }
         /**
          * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
          * zoom out in the image on desktop and use for the UI
          */
   
       }, {
         key: "_onSingleTap",
         value: function _onSingleTap(event) {
           if (!event.detail || event.detail.pointerType === 'mouse') {
             if (event.target.classList.contains('pswp__img')) {
               this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
             }
           } else {
             if (event.target.classList.contains('pswp__button')) {
               return;
             }
   
             event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
           }
         }
       }, {
         key: "_onDoubleTap",
         value: function _onDoubleTap(point) {
           var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
   
           if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
             this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
           } else {
             this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
           }
         }
       }, {
         key: "_onInitialZoomIn",
         value: function _onInitialZoomIn() {
           document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
         }
       }, {
         key: "_onInitialZoomOut",
         value: function _onInitialZoomOut() {
           document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
         }
         /**
          * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
          * our in-memory instance to null and our own events
          */
   
       }, {
         key: "_destroyPhotoSwipe",
         value: function _destroyPhotoSwipe() {
           this.delegateRoot.off('pswpTap');
           this.photoSwipeInstance = null;
         }
       }]);
   
       return ProductImageZoom;
     }();
   
     var ProductModel = /*#__PURE__*/function () {
       function ProductModel(element, stackProductImages) {
         _classCallCheck(this, ProductModel);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.delegateRoot = new domDelegate.Delegate(document.documentElement);
         this.stackProductImages = stackProductImages;
   
         this._attachListeners();
   
         var stylesheet = document.createElement('link');
         stylesheet.rel = 'stylesheet';
         stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
         document.head.appendChild(stylesheet);
         window.Shopify.loadFeatures([{
           name: 'model-viewer-ui',
           version: '1.0',
           onLoad: this._setupModelViewerUI.bind(this)
         }, {
           name: 'shopify-xr',
           version: '1.0'
         }]);
       }
   
       _createClass(ProductModel, [{
         key: "destroy",
         value: function destroy() {}
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           var _this = this;
   
           this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_play', function () {
             _this.element.dispatchEvent(new CustomEvent('model:played', {
               bubbles: true
             }));
           });
           this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
             _this.element.dispatchEvent(new CustomEvent('model:paused', {
               bubbles: true
             }));
           });
         }
       }, {
         key: "hasBeenSelected",
         value: function hasBeenSelected() {
           // As per guidelines, we only need to autoplay when it's not a touch device
           if (Responsive.matchesBreakpoint('supports-hover')) {
             this.modelUi.play();
           }
         }
       }, {
         key: "hasBeenDeselected",
         value: function hasBeenDeselected() {
           // In all cases, we just turn it off
           this.modelUi.pause();
         }
       }, {
         key: "_setupModelViewerUI",
         value: function _setupModelViewerUI() {
           this.modelElement = this.element.querySelector('model-viewer');
           this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
         }
       }]);
   
       return ProductModel;
     }();
   
     var ProductReviews = /*#__PURE__*/function () {
       function ProductReviews(container) {
         _classCallCheck(this, ProductReviews);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.delegateElement.on('click', '.spr-summary-actions-newreview', this._onNewReviewClicked.bind(this)); // Extending Shopify Reviews is a bit manual, but let's do it!
   
         window.SPRCallbacks = {};
         window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this);
         window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this);
       }
   
       _createClass(ProductReviews, [{
         key: "destroy",
         value: function destroy() {
           this.delegateElement.off();
         }
       }, {
         key: "_updatePagination",
         value: function _updatePagination(event, target) {
           // Unfortunately, we have to use this ugly jQuery style stuff
           SPR.$(target).data('page', parseInt(target.getAttribute('data-page')) + 1);
         }
       }, {
         key: "_onFormSuccess",
         value: function _onFormSuccess() {
           var formSuccess = this.element.querySelector('.spr-form-message-success');
           window.scrollTo(0, formSuccess.offsetTop - 45);
         }
       }, {
         key: "_onReviewsLoad",
         value: function _onReviewsLoad() {
           // We want to move "spr-pagination-next" before the "new review" button in the "spr-summary-actions" div
           var sprSummaryActions = this.element.querySelector('.spr-summary-actions'),
               previousSprPaginationNext = sprSummaryActions.querySelector('.spr-pagination-next'),
               sprPaginationNext = this.element.querySelector('.spr-pagination .spr-pagination-next');
   
           if (previousSprPaginationNext) {
             previousSprPaginationNext.remove();
           }
   
           if (sprPaginationNext) {
             sprSummaryActions.insertBefore(sprPaginationNext, sprSummaryActions.firstChild);
           }
         }
       }, {
         key: "_onNewReviewClicked",
         value: function _onNewReviewClicked(event, target) {
           target.style.display = 'none';
   
           if (target.previousElementSibling) {
             target.previousElementSibling.style.display = 'none';
           }
         }
       }]);
   
       return ProductReviews;
     }();
   
     /**
      * This implementation allows to serialize a form
      */
     var Form = /*#__PURE__*/function () {
       function Form() {
         _classCallCheck(this, Form);
       }
   
       _createClass(Form, null, [{
         key: "serialize",
         value: function serialize(form) {
           function stringKey(key, value) {
             var beginBracket = key.lastIndexOf('[');
   
             if (beginBracket === -1) {
               var _hash = {};
               _hash[key] = value;
               return _hash;
             }
   
             var newKey = key.substr(0, beginBracket);
             var newValue = {};
             newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
             return stringKey(newKey, newValue);
           }
   
           var hash = {};
   
           for (var i = 0, len = form.elements.length; i < len; i++) {
             var formElement = form.elements[i];
   
             if (formElement.name === '' || formElement.disabled) {
               continue;
             }
   
             if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
               var stringKeys = stringKey(formElement.name, formElement.value);
               hash = Form.extend(hash, stringKeys);
             }
           }
   
           return hash;
         }
       }, {
         key: "extend",
         value: function extend() {
           var extended = {};
           var i = 0; // Merge the object into the extended object
   
           var merge = function merge(obj) {
             for (var prop in obj) {
               if (obj.hasOwnProperty(prop)) {
                 // If property is an object, merge properties
                 if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                   extended[prop] = Form.extend(extended[prop], obj[prop]);
                 } else {
                   extended[prop] = obj[prop];
                 }
               }
             }
           }; // Loop through each object and conduct a merge
   
   
           for (; i < arguments.length; i++) {
             merge(arguments[i]);
           }
   
           return extended;
         }
       }]);
   
       return Form;
     }();
   
     var Currency = /*#__PURE__*/function () {
       function Currency() {
         _classCallCheck(this, Currency);
       }
   
       _createClass(Currency, null, [{
         key: "formatMoney",
         value:
         /**
          * Format money values based on your shop currency settings
          *
          * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
          * @param  {String} format - shop money_format setting
          * @return {String} value - formatted value
          */
         function formatMoney(cents, format) {
           if (typeof cents === 'string') {
             cents = cents.replace('.', '');
           }
   
           var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
               formatString = format || '${{amount}}';
   
           function defaultTo(value, defaultValue) {
             return value == null || value !== value ? defaultValue : value;
           }
   
           function formatWithDelimiters(number, precision, thousands, decimal) {
             precision = defaultTo(precision, 2);
             thousands = defaultTo(thousands, ',');
             decimal = defaultTo(decimal, '.');
   
             if (isNaN(number) || number == null) {
               return 0;
             }
   
             number = (number / 100.0).toFixed(precision);
             var parts = number.split('.'),
                 dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                 centsAmount = parts[1] ? decimal + parts[1] : '';
             return dollarsAmount + centsAmount;
           }
   
           var value = '';
   
           switch (formatString.match(placeholderRegex)[1]) {
             case 'amount':
               value = formatWithDelimiters(cents, 2);
               break;
   
             case 'amount_no_decimals':
               value = formatWithDelimiters(cents, 0);
               break;
   
             case 'amount_with_space_separator':
               value = formatWithDelimiters(cents, 2, ' ', '.');
               break;
   
             case 'amount_no_decimals_with_comma_separator':
               value = formatWithDelimiters(cents, 0, ',', '.');
               break;
   
             case 'amount_no_decimals_with_space_separator':
               value = formatWithDelimiters(cents, 0, ' ');
               break;
   
             case 'amount_with_comma_separator':
               value = formatWithDelimiters(cents, 2, '.', ',');
               break;
           }
   
           if (formatString.indexOf('with_comma_separator') !== -1) {
             return formatString.replace(placeholderRegex, value).replace(',00', '');
           } else {
             return formatString.replace(placeholderRegex, value).replace('.00', '');
           }
         }
       }]);
   
       return Currency;
     }();
   
     var VariantSelector = /*#__PURE__*/function () {
       function VariantSelector(element, parentProductVariants) {
         var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
   
         _classCallCheck(this, VariantSelector);
   
         this.element = element;
         this.parentProductVariants = parentProductVariants;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
   
         this.onValueChangedCallback = options['onValueChanged'] || function () {};
   
         this.isOpen = false;
         this.pageOverlayElement = document.querySelector('.PageOverlay');
         this.variantChoiceList = Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__Choice'));
         this.variantCarousel = new Carousel(this.element.querySelector('.VariantSelector__Carousel'), {
           onSelect: this._variantChanged.bind(this),
           onClick: this._variantSelected.bind(this)
         });
   
         this._attachListeners();
       }
   
       _createClass(VariantSelector, [{
         key: "destroy",
         value: function destroy() {
           this.element.removeEventListener('keyup', this._handleKeyboardListener);
           this.delegateElement.off('click');
           this.activator.removeEventListener('click', this._toggleListener);
           this.variantCarousel.destroy();
         }
       }, {
         key: "toggle",
         value: function toggle() {
           this.isOpen ? this.close() : this.open();
         }
       }, {
         key: "open",
         value: function open() {
           if (this.isOpen) {
             return;
           }
   
           this.element.setAttribute('aria-hidden', 'false');
           this.activator.setAttribute('aria-expanded', 'true');
           Accessibility.trapFocus(this.element, 'variant-selector');
           document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open
   
           this.element.setAttribute('style', '');
           this.pageOverlayElement.classList.add('is-visible');
           this.pageOverlayElement.addEventListener('click', this._closeListener);
           this.isOpen = true;
         }
       }, {
         key: "close",
         value: function close() {
           if (!this.isOpen) {
             return;
           }
   
           this.element.setAttribute('aria-hidden', 'true');
           this.activator.setAttribute('aria-expanded', 'false');
           Accessibility.removeTrapFocus(this.element, 'variant-selector');
           document.documentElement.classList.remove('no-scroll');
           this.pageOverlayElement.classList.remove('is-visible');
           this.pageOverlayElement.removeEventListener('click', this._closeListener);
           this.isOpen = false;
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._handleKeyboardListener = this._handleKeyboard.bind(this);
           this._closeListener = this.close.bind(this);
           this._toggleListener = this.toggle.bind(this);
           this.element.addEventListener('keyup', this._handleKeyboardListener);
           this.activator.addEventListener('click', this._toggleListener);
           this.delegateElement.on('click', '[data-action="select-variant"]', this._onVariantSelect.bind(this));
           this.parentProductVariants.delegateElement.on('variant:changed', this._onVariantChanged.bind(this));
         }
         /**
          * Called when the variant is changed (but not yet selected)
          */
   
       }, {
         key: "_variantChanged",
         value: function _variantChanged(selectedIndex) {
           var activeChoice = this.variantChoiceList[selectedIndex];
           activeChoice.classList.add('is-selected');
           Dom.getSiblings(activeChoice, '.is-selected').forEach(function (item) {
             return item.classList.remove('is-selected');
           });
         }
         /**
          * Called when a variant is clicked or selected
          */
   
       }, {
         key: "_variantSelected",
         value: function _variantSelected(cellElement, cellIndex) {
           if (this.variantCarousel.getSelectedIndex() === cellIndex) {
             this.onValueChangedCallback(cellElement.getAttribute('data-option-value'), cellElement, this.activator);
             this.close();
           } else {
             this.variantCarousel.selectCell(cellIndex);
           }
         }
       }, {
         key: "_onVariantChanged",
         value: function _onVariantChanged(event) {
           var _this = this;
   
           var selectedVariant = event.detail.variant,
               imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
               found = false;
           Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
             var colorPosition = parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
                 combinationExcludedColor = '';
             selectedVariant.options.forEach(function (optionValue, index) {
               if (index !== colorPosition) {
                 combinationExcludedColor += optionValue;
               }
             });
   
             if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
               image.setAttribute('aria-hidden', 'false');
               found = true;
             } else {
               image.setAttribute('aria-hidden', 'true');
             }
           });
   
           if (!found) {
             imageWrapperElements.children[0].setAttribute('aria-hidden', 'false');
           }
   
           var foundColorIndex = 0;
           Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__ChoicePrice')).forEach(function (priceElement, index) {
             var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1;
   
             _this.parentProductVariants.productData['variants'].forEach(function (variant) {
               var matchOptionsExcludedColor = true;
               variant['options'].forEach(function (option, index) {
                 if (index !== colorPosition) {
                   if (variant['options'][index] !== selectedVariant['options'][index]) {
                     matchOptionsExcludedColor = false;
                   }
                 }
               });
   
               if (matchOptionsExcludedColor && variant['options'][colorPosition] === selectedVariant['options'][colorPosition]) {
                 if (foundColorIndex++ === index) {
                   priceElement.innerHTML = "<span class=\"Heading Text--subdued\">".concat(Currency.formatMoney(variant['price'], window.theme.moneyFormat), "</span>");
                 }
               }
             });
           });
         }
         /**
          * Called when the button "choose this variant" is explicitly clicked
          */
   
       }, {
         key: "_onVariantSelect",
         value: function _onVariantSelect() {
           var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;
           this.onValueChangedCallback(selectedCell.getAttribute('data-option-value'), selectedCell, this.activator);
           this.close();
         }
         /**
          * Handle a11y events
          */
   
       }, {
         key: "_handleKeyboard",
         value: function _handleKeyboard(event) {
           if (this.isOpen && event.keyCode === 27) {
             this.close();
           }
         }
       }]);
   
       return VariantSelector;
     }();
   
     /**
      * Handle the store availability management. The parameter is the div that will hold the content. The function
      * "updateWithVariant" must be called whenever the variant is changed.
      */
   
     var StoreAvailability = /*#__PURE__*/function () {
       function StoreAvailability(element, productTitle) {
         _classCallCheck(this, StoreAvailability);
   
         this.element = element;
         this.productTitle = productTitle;
         this.existingDrawers = {};
       }
   
       _createClass(StoreAvailability, [{
         key: "updateWithVariant",
         value: function updateWithVariant(variant) {
           if (!this.element) {
             return; // If the element to inject the store availability does not exist, we return immediately
           } // If the variant is null (for instance unavailable variant), we clear the container
   
   
           if (!variant) {
             this.element.textContent = '';
             return;
           } // If we have a new variant we render the section
   
   
           this._renderAvailabilitySection(variant['id']);
         }
       }, {
         key: "_renderAvailabilitySection",
         value: function _renderAvailabilitySection(id) {
           var _this = this;
   
           // First we clear the previous content
           this.element.innerHTML = ''; // If there is already an element with the given modal we remove it first
   
           var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
   
           if (availabilityModal) {
             availabilityModal.remove();
           }
   
           if (this.existingDrawers["StoreAvailabilityModal-".concat(id)]) {
             this.existingDrawers["StoreAvailabilityModal-".concat(id)].destroy();
             delete this.existingDrawers["StoreAvailabilityModal-".concat(id)];
           }
   
           return fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function (response) {
             return response.text().then(function (content) {
               _this.element.innerHTML = content;
               _this.element.innerHTML = _this.element.firstElementChild.innerHTML; // The product title is not rendered so we have to render it manually
   
               var productTitle = _this.element.querySelector('.store-availabilities-modal__product-title');
   
               if (productTitle) {
                 productTitle.textContent = _this.productTitle;
               } // In order for our modal system to work we have to append the modal to the body instead
   
   
               var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
               document.body.appendChild(availabilityModal); // Create the drawer
   
               _this.existingDrawers["StoreAvailabilityModal-".concat(id)] = new Drawer(availabilityModal);
             });
           });
         }
       }]);
   
       return StoreAvailability;
     }();
   
     var ProductVariants = /*#__PURE__*/function () {
       function ProductVariants(container, options) {
         var _this = this;
   
         _classCallCheck(this, ProductVariants);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.options = options;
         var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
         this.productData = jsonData['product'];
         this.variantsInventories = jsonData['inventories'] || {};
         this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData['id'])); // We init value with the first selected variant
   
         this.productData['variants'].forEach(function (variant) {
           if (variant['id'] === jsonData['selected_variant_id']) {
             _this.currentVariant = variant;
             _this.option1 = variant['option1'];
             _this.option2 = variant['option2'];
             _this.option3 = variant['option3'];
           }
         });
         this.storeAvailability = new StoreAvailability(this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData['title']);
         this.storeAvailability.updateWithVariant(this.currentVariant);
   
         this._attachListeners();
   
         this._createSelectors();
       }
   
       _createClass(ProductVariants, [{
         key: "destroy",
         value: function destroy() {
           this.delegateElement.off('click');
           this.formPopovers.forEach(function (popover) {
             return popover.destroy();
           });
           this.formVariantSelectors.forEach(function (selector) {
             return selector.destroy();
           });
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
           this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
           this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
           this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this)); // Hook when a radio button change
   
           this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
         }
         /**
          * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
          */
   
       }, {
         key: "_createSelectors",
         value: function _createSelectors() {
           var _this2 = this;
   
           // Create the instances for each selector
           this.formPopovers = [];
           this.formVariantSelectors = [];
           Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
             var popover = new Popover(item, {
               preferredPosition: 'left',
               onValueChanged: _this2._onOptionChanged.bind(_this2)
             });
   
             _this2.formPopovers.push(popover);
           });
           Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (item) {
             var variantSelector = new VariantSelector(item, _this2, {
               onValueChanged: _this2._onOptionChanged.bind(_this2)
             });
   
             _this2.formVariantSelectors.push(variantSelector);
           });
         }
         /**
          * ---------------------------------------------------------------------------------------------------
          * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
          *
          * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
          * edit this code
          * ---------------------------------------------------------------------------------------------------
          */
   
         /**
          * This callback is called whenever the variant changes and allows to update data about the active variant
          */
   
       }, {
         key: "_onVariantChanged",
         value: function _onVariantChanged(previousVariant, newVariant) {
           // 1st: the prices
           this._updateProductPrices(newVariant, previousVariant); // 2nd: update inventory
   
   
           this._updateInventory(newVariant, previousVariant); // 3rd: update SKU
   
   
           this._updateSku(newVariant, previousVariant); // 4th: update the price measurement
   
   
           this._updateUnitPrice(newVariant, previousVariant); // 5th: the add to cart button
   
   
           this._updateAddToCartButton(newVariant, previousVariant); // 6th: store availability
   
   
           this.storeAvailability.updateWithVariant(newVariant); // Finally, we send an event so that other system could hook and do their own logic
   
           this.element.dispatchEvent(new CustomEvent('variant:changed', {
             bubbles: true,
             detail: {
               variant: newVariant,
               previousVariant: previousVariant
             }
           }));
         }
         /**
          * Update the prices (optionally showing compare at price)
          */
   
       }, {
         key: "_updateProductPrices",
         value: function _updateProductPrices(newVariant, previousVariant) {
           var productMetaPrices = this.element.querySelector('.ProductMeta__PriceList'),
               currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
   
           if (!productMetaPrices) {
             return;
           }
   
           if (!newVariant) {
             productMetaPrices.style.display = 'none';
           } else {
             if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
               return; // The price do not have changed so let's return to avoid changing the DOM for nothing
             }
   
             productMetaPrices.innerHTML = '';
   
             if (newVariant['compare_at_price'] > newVariant['price']) {
               productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--highlight Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
               productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--compareAt Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['compare_at_price'], currencyFormat), "</span>");
             } else {
               productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
             }
   
             productMetaPrices.style.display = '';
           }
         }
         /**
          * Update the inventory (if needed)
          */
   
       }, {
         key: "_updateInventory",
         value: function _updateInventory(newVariant) {
           if (!this.options['showInventoryQuantity']) {
             return;
           }
   
           var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
               variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null;
   
           if (!newVariant || null === variantInventory['inventory_management'] || variantInventory['inventory_quantity'] <= 0 || this.options['inventoryQuantityThreshold'] > 0 && variantInventory['inventory_quantity'] > this.options['inventoryQuantityThreshold']) {
             productFormInventory.style.display = 'none';
           } else {
             productFormInventory.innerHTML = variantInventory['inventory_message'];
             productFormInventory.style.display = '';
           }
         }
         /**
          * Update the SKU
          */
   
       }, {
         key: "_updateSku",
         value: function _updateSku(newVariant) {
           if (!this.options['showSku'] || !newVariant) {
             return;
           }
   
           var productSkuNumber = this.element.querySelector('.ProductMeta__SkuNumber');
   
           if (productSkuNumber && newVariant['sku']) {
             productSkuNumber.innerText = newVariant['sku'];
           }
         }
         /**
          * Update the unit price
          */
   
       }, {
         key: "_updateUnitPrice",
         value: function _updateUnitPrice(newVariant) {
           if (!newVariant) {
             return;
           }
   
           var unitPriceMeasurement = this.element.querySelector('.ProductMeta__UnitPriceMeasurement');
   
           if (!unitPriceMeasurement) {
             return;
           }
   
           if (!newVariant.hasOwnProperty('unit_price')) {
             unitPriceMeasurement.style.display = 'none';
             return;
           }
   
           unitPriceMeasurement.style.display = 'block';
           unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = Currency.formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
           unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];
           var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
           unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
           unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
         }
         /**
          * Update the add to cart
          */
   
       }, {
         key: "_updateAddToCartButton",
         value: function _updateAddToCartButton(newVariant) {
           var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
               shopifyPaymentButton = this.element.querySelector('.shopify-payment-button');
   
           if (addToCartButton) {
             addToCartButton.classList.remove('Button--secondary');
             addToCartButton.classList.remove('Button--primary');
   
             if (!newVariant) {
               addToCartButton.setAttribute('disabled', 'disabled');
               addToCartButton.removeAttribute('data-action');
               addToCartButton.classList.add('Button--secondary');
               addToCartButton.innerHTML = window.languages.productFormUnavailable;
             } else {
               if (newVariant['available']) {
                 addToCartButton.removeAttribute('disabled');
                 addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
                 addToCartButton.setAttribute('data-action', 'add-to-cart');
   
                 if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
                   addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span data-money-convertible>").concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), "</span>\n          ");
                 } else {
                   addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
                 }
               } else {
                 addToCartButton.setAttribute('disabled', 'disabled');
                 addToCartButton.classList.add('Button--secondary');
                 addToCartButton.removeAttribute('data-action');
                 addToCartButton.innerHTML = window.languages.productFormSoldOut;
               }
             }
           }
   
           if (this.options['showPaymentButton'] && shopifyPaymentButton) {
             if (!newVariant || !newVariant['available']) {
               shopifyPaymentButton.style.display = 'none';
             } else {
               shopifyPaymentButton.style.display = 'block';
             }
           }
         }
         /**
          * ---------------------------------------------------------------------------------------------------
          * INTERNAL CODE THAT HANDLE VARIANT CHANGES
          * ---------------------------------------------------------------------------------------------------
          */
   
         /**
          * Whenever an option is changed, this code fetch the corresponding active variant
          */
   
       }, {
         key: "_onOptionChanged",
         value: function _onOptionChanged(newValue, target, activator) {
           // We change the value associated with the activator, and check if we have a color swatch
           if (activator) {
             this['option' + target.getAttribute('data-option-position')] = newValue;
             activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
           } else {
             this['option' + target.getAttribute('data-option-position')] = target.value;
             var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');
   
             if (selectedValue) {
               selectedValue.innerHTML = target.value;
             }
           } // Finally, we get the new variant
   
   
           var previousVariant = this.currentVariant;
           this.currentVariant = this._getCurrentVariantFromOptions();
   
           this._onVariantChanged(previousVariant, this.currentVariant);
   
           if (this.currentVariant) {
             if (this.options['enableHistoryState']) {
               this._updateHistoryState(this.currentVariant);
             } // We need to modify the hidden select that contain the id attribute as well
   
   
             this.masterSelector.querySelector('[selected]').removeAttribute('selected');
             this.masterSelector.querySelector("[value=\"".concat(this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
             this.masterSelector.dispatchEvent(new Event('change', {
               bubbles: true
             }));
           }
         }
         /**
          * Get the active variant based on the options
          */
   
       }, {
         key: "_getCurrentVariantFromOptions",
         value: function _getCurrentVariantFromOptions() {
           var _this3 = this;
   
           var found = false;
           this.productData['variants'].forEach(function (variant) {
             if (variant['option1'] === _this3.option1 && variant['option2'] === _this3.option2 && variant['option3'] === _this3.option3) {
               found = variant;
             }
           });
           return found || null;
         }
         /**
          * Update the history state for browsers that support it
          */
   
       }, {
         key: "_updateHistoryState",
         value: function _updateHistoryState(variant) {
           if (!history.replaceState) {
             return;
           }
   
           var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variant.id);
           window.history.replaceState({
             path: newUrl
           }, '', newUrl);
         }
         /**
          * ---------------------------------------------------------------------------------------------------
          * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
          * ---------------------------------------------------------------------------------------------------
          */
   
       }, {
         key: "_addToCart",
         value: function _addToCart(event) {
           var _this4 = this;
   
           if (!this.options['useAjaxCart']) {
             return; // When using a cart type of page, we just simply redirect to the cart page
           }
   
           event.preventDefault(); // Prevent form to be submitted
   
           var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'); // First, we switch the status of the button
   
           addToCartButton.setAttribute('disabled', 'disabled');
           document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
   
           var formElement = this.element.querySelector('form[action*="/cart/add"]');
           fetch("".concat(window.routes.cartAddUrl, ".js"), {
             body: JSON.stringify(Form.serialize(formElement)),
             credentials: 'same-origin',
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
   
             }
           }).then(function (response) {
             document.dispatchEvent(new CustomEvent('theme:loading:end'));
             var quantityElement = formElement.querySelector('[name="quantity"]');
   
             if (response.ok) {
               addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
   
               _this4.element.dispatchEvent(new CustomEvent('product:added', {
                 bubbles: true,
                 detail: {
                   variant: _this4.currentVariant,
                   quantity: quantityElement ? parseInt(quantityElement.value) : 1
                 }
               }));
             } else {
               response.json().then(function (content) {
                 var errorMessageElement = document.createElement('span');
                 errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                 errorMessageElement.innerHTML = content['description'];
                 addToCartButton.removeAttribute('disabled');
                 addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                 setTimeout(function () {
                   errorMessageElement.remove();
                 }, 2500);
               });
             }
           });
           event.preventDefault();
         }
         /**
          * ---------------------------------------------------------------------------------------------------
          * OTHER
          * ---------------------------------------------------------------------------------------------------
          */
   
         /**
          * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
          */
   
       }, {
         key: "_decreaseQuantity",
         value: function _decreaseQuantity(event, target) {
           target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
         }
         /**
          * When using the quantity selector, this can be used to increase the quantity
          */
   
       }, {
         key: "_increaseQuantity",
         value: function _increaseQuantity(event, target) {
           target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
         }
         /**
          * Make sure the quantity does not go below when manually changed
          */
   
       }, {
         key: "_validateQuantity",
         value: function _validateQuantity(event, target) {
           target.value = Math.max(parseInt(target.value) || 1, 1);
         }
       }]);
   
       return ProductVariants;
     }();
   
     var ProductVideo = /*#__PURE__*/function () {
       function ProductVideo(element, stackProductImages, enableVideoLooping) {
         _classCallCheck(this, ProductVideo);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.stackProductImages = stackProductImages;
         this.enableVideoLooping = enableVideoLooping;
         this.player = null;
   
         switch (this.element.getAttribute('data-media-type')) {
           case 'video':
             var stylesheet = document.createElement('link');
             stylesheet.rel = 'stylesheet';
             stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
             document.head.appendChild(stylesheet);
             window.Shopify.loadFeatures([{
               name: 'video-ui',
               version: '1.0',
               onLoad: this._setupHtml5Video.bind(this)
             }]);
             break;
   
           case 'external_video':
             this._setupExternalVideo();
   
             break;
         }
       }
   
       _createClass(ProductVideo, [{
         key: "destroy",
         value: function destroy() {
           if (this.player) {
             this.player.destroy(); // Both Plyr and YouTube API use the same name
           }
         }
       }, {
         key: "hasBeenSelected",
         value: function hasBeenSelected() {
           // As per guidelines, we only need to autoplay when it's not a touch device
           if (Responsive.matchesBreakpoint('supports-hover')) {
             this.play();
           }
         }
       }, {
         key: "hasBeenDeselected",
         value: function hasBeenDeselected() {
           this.pause();
         }
       }, {
         key: "play",
         value: function play() {
           switch (this.element.getAttribute('data-media-type')) {
             case 'video':
               this.player.play();
               break;
   
             case 'external_video':
               this.player.playVideo();
               break;
           }
         }
       }, {
         key: "pause",
         value: function pause() {
           switch (this.element.getAttribute('data-media-type')) {
             case 'video':
               this.player.pause();
               break;
   
             case 'external_video':
               this.player.pauseVideo();
               break;
           }
         }
       }, {
         key: "_setupHtml5Video",
         value: function _setupHtml5Video() {
           var _this = this;
   
           this.player = new Shopify.Plyr(this.element.querySelector('video'), {
             controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
             loop: {
               active: this.enableVideoLooping
             },
             hideControlsOnPause: true,
             clickToPlay: true,
             iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
             tooltips: {
               controls: false,
               seek: true
             }
           });
           this.player.on('ready', function () {
             var rangeInputs = _this.element.querySelectorAll('input[type="range"]');
             rangeInputs.forEach(function(input) {
               input.removeAttribute('aria-valuemax');
               input.removeAttribute('aria-valuemin');
             });
           });
           this.player.on('play', function () {
             _this.element.dispatchEvent(new CustomEvent('video:played', {
               bubbles: true
             }));
           });
           this.player.on('pause', function () {
             _this.element.dispatchEvent(new CustomEvent('video:paused', {
               bubbles: true
             }));
           });
         }
       }, {
         key: "_setupExternalVideo",
         value: function _setupExternalVideo() {
           if (this.element.getAttribute('data-video-host') === 'youtube') {
             this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
           }
         }
       }, {
         key: "_setupYouTubePlayer",
         value: function _setupYouTubePlayer() {
           var _this2 = this;
   
           var playerLoadingInterval = setInterval(function () {
             if (window.YT !== undefined && window.YT.Player !== undefined) {
               _this2.player = new YT.Player(_this2.element.querySelector('iframe'), {
                 videoId: _this2.element.getAttribute('data-video-id'),
                 events: {
                   onStateChange: function onStateChange(event) {
                     if (event.data === window.YT.PlayerState.PLAYING) {
                       _this2.element.dispatchEvent(new CustomEvent('video:played', {
                         bubbles: true
                       }));
                     } else if (event.data === YT.PlayerState.PAUSED) {
                       _this2.element.dispatchEvent(new CustomEvent('video:paused', {
                         bubbles: true
                       }));
                     }
   
                     if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
                       event.target.seekTo(0);
                     }
                   }
                 }
               });
               clearInterval(playerLoadingInterval);
             }
           }, 50);
         }
       }, {
         key: "_loadYouTubeScript",
         value: function _loadYouTubeScript() {
           return new Promise(function (resolve, reject) {
             var script = document.createElement('script');
             document.body.appendChild(script);
             script.onload = resolve;
             script.onerror = reject;
             script.async = true;
             script.src = '//www.youtube.com/iframe_api';
           });
         }
       }]);
   
       return ProductVideo;
     }();
   
     /**
      * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
      */
     var ScrollSpy = /*#__PURE__*/function () {
       function ScrollSpy(container, elementsToSpy, observerOptions) {
         var _this = this;
   
         _classCallCheck(this, ScrollSpy);
   
         this.container = container;
         this.targets = [];
         this.targetIndices = {};
         this.indicesInViewPort = [];
         this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);
         elementsToSpy.forEach(function (elementToSpy, index) {
           _this.targets.push(elementToSpy);
   
           _this.targetIndices[elementToSpy.id] = index;
   
           _this.observer.observe(elementToSpy);
         });
       }
   
       _createClass(ScrollSpy, [{
         key: "destroy",
         value: function destroy() {
           this.observer.disconnect();
         }
         /**
          * Called whenever there is a change of visibility
          */
   
       }, {
         key: "_onIntersectionChange",
         value: function _onIntersectionChange(changes) {
           var oldTargetIndex = this.indicesInViewPort[0] || 0;
   
           for (var i = changes.length - 1; i >= 0; i--) {
             this._updateIndicesInViewPort(changes[i], oldTargetIndex);
           } // Firefox generates duplicates so make sure to remove
   
   
           this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
             return self.indexOf(value) === index;
           });
   
           if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
             return;
           }
   
           var event = new CustomEvent('scrollspy:target:changed', {
             detail: {
               newTarget: this.targets[this.indicesInViewPort[0]],
               oldTarget: this.targets[oldTargetIndex]
             }
           });
           this.container.dispatchEvent(event);
         }
         /**
          * Update indices visible in the view port
          */
   
       }, {
         key: "_updateIndicesInViewPort",
         value: function _updateIndicesInViewPort(change, oldTargetIndex) {
           var index = this.targetIndices[change.target.id];
   
           if (change.intersectionRatio === 0) {
             var indexInViewPort = this.indicesInViewPort.indexOf(index);
   
             if (indexInViewPort !== -1) {
               this.indicesInViewPort.splice(indexInViewPort, 1);
             }
           } else {
             if (index < oldTargetIndex) {
               this.indicesInViewPort.unshift(index);
             } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
               this.indicesInViewPort.push(index);
             } else {
               this.indicesInViewPort.push(index);
               this.indicesInViewPort.sort();
             }
           }
         }
       }]);
   
       return ScrollSpy;
     }();
   
     var SearchBar = /*#__PURE__*/function () {
       function SearchBar() {
         _classCallCheck(this, SearchBar);
   
         this.documentDelegate = new domDelegate.Delegate(document.body);
         this.searchElement = document.getElementById('Search');
         this.searchInputElement = this.searchElement.querySelector('[name="q"]');
         this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
         this.queryMap = {};
         this.isOpen = false;
         this.pageOverlayElement = document.querySelector('.PageOverlay');
   
         this._attachListeners();
       }
   
       _createClass(SearchBar, [{
         key: "destroy",
         value: function destroy() {
           this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
           this.searchInputElement.removeEventListener('input', this._onInputListener);
           this.documentDelegate.off();
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._preventSubmissionListener = this._preventSubmission.bind(this);
           this._onInputListener = this._debounce(this._onInput.bind(this), 250);
           this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
           this.searchInputElement.addEventListener('input', this._onInputListener);
           this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
           this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
           this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
           this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
         }
         /**
          * Toggle the search
          */
   
       }, {
         key: "_toggleSearch",
         value: function _toggleSearch(event) {
           if (this.isOpen) {
             this._closeSearch(event);
           } else {
             this._openSearch(event);
           }
   
           event.preventDefault();
         }
         /**
          * Open the search form and trap focus
          */
   
       }, {
         key: "_openSearch",
         value: function _openSearch() {
           var _this = this;
   
           this.searchElement.setAttribute('aria-hidden', 'false');
           document.documentElement.classList.add('no-scroll');
           Accessibility.trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));
   
           var onFocusListener = function onFocusListener() {
             _this.searchInputElement.focus();
   
             _this.searchElement.removeEventListener('transitionend', onFocusListener);
           };
   
           this.searchElement.addEventListener('transitionend', onFocusListener);
           this.isOpen = true;
           this.pageOverlayElement.classList.add('is-visible');
           document.querySelector('#shopify-section-header').style.zIndex = 10;
         }
         /**
          * Close the search form and clear focus
          */
   
       }, {
         key: "_closeSearch",
         value: function _closeSearch() {
           var _this2 = this;
   
           this.searchElement.setAttribute('aria-hidden', 'true');
           document.documentElement.classList.remove('no-scroll');
           Accessibility.removeTrapFocus(this.searchElement, 'search');
           this.isOpen = false;
   
           var onTransitionEnd = function onTransitionEnd(event) {
             if (event.propertyName === 'visibility') {
               document.querySelector('#shopify-section-header').style.zIndex = '';
   
               _this2.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
             }
           };
   
           this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
           this.pageOverlayElement.classList.remove('is-visible');
         }
         /**
          * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
          * then we disable submission using enter key
          */
   
       }, {
         key: "_preventSubmission",
         value: function _preventSubmission(event) {
           if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
             event.preventDefault();
           }
         }
         /**
          * This is called when the user has stopped typing (after debounce delay)
          */
   
       }, {
         key: "_onInput",
         value: function _onInput(event) {
           var _this3 = this;
   
           if (event.keyCode === 13) {
             return;
           } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
           // keep track of sent requests, and only use the results of the last one
   
   
           this.lastInputValue = event.target.value;
   
           if (this.lastInputValue === '') {
             this._resetSearch();
   
             return;
           }
   
           var queryOptions = {
             method: 'GET',
             credentials: 'same-origin'
           };
           var queries = [fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "*&type=product"), queryOptions)];
   
           if (window.theme.searchMode !== 'product') {
             queries.push(fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "*&type=").concat(window.theme.searchMode.replace('product,', '')), queryOptions));
           }
   
           this.queryMap[this.lastInputValue] = true;
           document.dispatchEvent(new CustomEvent('theme:loading:start'));
           Promise.all(queries).then(function (responses) {
             // If we receive the result for a query that is not the last one, we simply do not process the result
             if (_this3.lastInputValue !== event.target.value) {
               return;
             }
   
             delete _this3.queryMap[event.target.value];
             Promise.all(responses.map(function (response) {
               return response.text();
             })).then(function (contents) {
               // If we have only one content then we only have product, otherwise we have products and articles
               if (window.theme.searchMode === 'product') {
                 _this3.searchResultsElement.innerHTML = contents[0];
               } else {
                 _this3.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\">".concat(contents[0], "</div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\">").concat(contents[1], "</div>\n            </div>");
               }
   
               _this3.searchResultsElement.setAttribute('aria-hidden', 'false');
             });
             document.dispatchEvent(new CustomEvent('theme:loading:end'));
           });
         }
       }, {
         key: "_resetSearch",
         value: function _resetSearch() {
           if (window.theme.searchMode === 'product') {
             this.searchResultsElement.innerHTML = '';
           } else {
             this.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\"></div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\"></div>\n            </div>";
           }
   
           this.searchResultsElement.setAttribute('aria-hidden', 'true');
           document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
         }
         /**
          * Simple function that allows to debounce
          */
   
       }, {
         key: "_debounce",
         value: function _debounce(fn, delay) {
           var _this4 = this;
   
           var timer = null;
           return function () {
             for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
               args[_key] = arguments[_key];
             }
   
             clearTimeout(timer);
             timer = setTimeout(function () {
               fn.apply(_this4, args);
             }, delay);
           };
         }
       }]);
   
       return SearchBar;
     }();
   
     var CountrySelector = /*#__PURE__*/function () {
       function CountrySelector(countrySelect, provinceSelect) {
         _classCallCheck(this, CountrySelector);
   
         this.countrySelect = countrySelect;
         this.provinceSelect = provinceSelect;
   
         if (this.countrySelect && this.provinceSelect) {
           this._attachListeners();
   
           this._initSelectors();
         }
       }
   
       _createClass(CountrySelector, [{
         key: "destroy",
         value: function destroy() {
           if (this.countrySelect) {
             this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
           }
         }
       }, {
         key: "_initSelectors",
         value: function _initSelectors() {
           // Check first the default value of country
           var defaultCountry = this.countrySelect.getAttribute('data-default');
   
           if (defaultCountry) {
             for (var i = 0; i !== this.countrySelect.options.length; ++i) {
               if (this.countrySelect.options[i].text === defaultCountry) {
                 this.countrySelect.selectedIndex = i;
                 break;
               }
             }
           } else {
             this.countrySelect.selectedIndex = 0;
           }
   
           var event = new Event('change', {
             bubbles: true
           });
           this.countrySelect.dispatchEvent(event); // Then the province
   
           var defaultProvince = this.provinceSelect.getAttribute('data-default');
   
           if (defaultProvince) {
             for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
               if (this.provinceSelect.options[_i].text === defaultProvince) {
                 this.provinceSelect.selectedIndex = _i;
                 break;
               }
             }
           }
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._onCountryChangedListener = this._onCountryChanged.bind(this);
           this.countrySelect.addEventListener('change', this._onCountryChangedListener);
         }
       }, {
         key: "_onCountryChanged",
         value: function _onCountryChanged() {
           var _this = this;
   
           var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
               provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]'); // First remove all options
   
           this.provinceSelect.innerHTML = '';
   
           if (provinces.length === 0) {
             this.provinceSelect.parentNode.style.display = 'none';
             return;
           } // We need to build the provinces array
   
   
           provinces.forEach(function (data) {
             _this.provinceSelect.options.add(new Option(data[1], data[0]));
           });
           this.provinceSelect.parentNode.style.display = 'block';
         }
       }]);
   
       return CountrySelector;
     }();
   
     var ShippingEstimator = /*#__PURE__*/function () {
       function ShippingEstimator(element) {
         _classCallCheck(this, ShippingEstimator);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));
   
         this._attachListeners();
       }
   
       _createClass(ShippingEstimator, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off('click');
           this.countrySelector.destroy();
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '.ShippingEstimator__Submit', this._fetchRates.bind(this));
         }
       }, {
         key: "_fetchRates",
         value: function _fetchRates() {
           var _this = this;
   
           var country = this.element.querySelector('[name="country"]').value,
               province = this.element.querySelector('[name="province"]').value,
               zip = this.element.querySelector('[name="zip"]').value;
           document.dispatchEvent(new CustomEvent('theme:loading:start'));
           fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
             credentials: 'same-origin',
             method: 'GET'
           }).then(function (response) {
             response.json().then(function (result) {
               document.dispatchEvent(new CustomEvent('theme:loading:end'));
   
               var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
                   errorContainer = _this.element.querySelector('.ShippingEstimator__Error');
   
               if (response.ok) {
                 var shippingRates = result['shipping_rates'];
   
                 if (shippingRates.length === 0) {
                   resultsContainer.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
                 } else {
                   var html = '';
   
                   if (shippingRates.length === 1) {
                     html += "<p>".concat(window.languages.shippingEstimatorOneResult, "</p><ul>");
                   } else {
                     html += "<p>".concat(window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length), "</p><ul>");
                   }
   
                   shippingRates.forEach(function (item) {
                     html += "<li>".concat(item['name'], ": ").concat(Currency.formatMoney(item['price'], window.theme.moneyFormat), "</li>");
                   });
                   html += '</ul>';
                   resultsContainer.firstElementChild.innerHTML = html;
                 }
   
                 TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, {
                   autoAlpha: 0,
                   y: -15
                 }, {
                   autoAlpha: 1,
                   y: 0,
                   delay: 0.35
                 });
                 errorContainer.style.display = 'none';
                 resultsContainer.style.display = 'block';
                 Animation.slideDown(resultsContainer);
               } else {
                 var errorHtml = '';
                 Object.keys(result).forEach(function (key) {
                   errorHtml += "<li class=\"Alert__ErrorItem\">".concat(key, " ").concat(result[key], "</li>");
                 });
                 errorContainer.innerHTML = "<ul class=\"Alert__ErrorList\">".concat(errorHtml, "</ul>");
                 resultsContainer.style.display = 'none';
                 errorContainer.style.display = 'block';
               }
             });
           });
         }
       }]);
   
       return ShippingEstimator;
     }();
   
     var AddressesSection = function AddressesSection() {
       var _this = this;
   
       _classCallCheck(this, AddressesSection);
   
       this.countrySelectors = [];
       Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
         _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
       });
     };
   
     var ArticleList = /*#__PURE__*/function () {
       function ArticleList(container) {
         var _this = this;
   
         _classCallCheck(this, ArticleList);
   
         this.element = container;
   
         if (window.theme.showElementStaggering) {
           this.timeline = new TimelineLite({
             delay: window.theme.showPageTransition ? 0.5 : 0
           });
           this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
           Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
             _this.intersectionObserver.observe(item);
           });
         }
       }
   
       _createClass(ArticleList, [{
         key: "onUnload",
         value: function onUnload() {
           if (window.theme.showElementStaggering) {
             this.intersectionObserver.disconnect();
             this.timeline.kill();
           }
         }
       }, {
         key: "_reveal",
         value: function _reveal(results) {
           var _this2 = this;
   
           var toReveal = [];
           results.forEach(function (result) {
             if (result.isIntersecting || result.intersectionRatio > 0) {
               // isIntersecting does not exist on Samsung Android browser
               toReveal.push(result.target);
   
               _this2.intersectionObserver.unobserve(result.target);
             }
           });
   
           if (toReveal.length === 0) {
             return;
           }
   
           this.timeline.staggerFromTo(toReveal, 0.45, {
             autoAlpha: 0,
             y: 30
           }, {
             autoAlpha: 1,
             y: 0
           }, 0.2);
         }
       }]);
   
       return ArticleList;
     }();
   
     var ArticleSection = /*#__PURE__*/function () {
       function ArticleSection(container) {
         var _this = this;
   
         _classCallCheck(this, ArticleSection);
   
         this.element = container;
         this.toolbarElement = this.element.querySelector('.ArticleToolbar');
         this.articleNavElement = this.element.querySelector('.ArticleNav');
         var articleImageElement = this.element.querySelector('.Article__Image');
   
         if (articleImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
           this.parallaxInstance = new Rellax('.Article__Image', {
             speed: -7,
             center: false,
             round: true
           });
         }
   
         if (window.theme.showElementStaggering) {
           this.timeline = new TimelineLite({
             delay: window.theme.showPageTransition ? 0.5 : 0
           });
           this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
           Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
             _this.intersectionObserver.observe(item);
           });
         }
   
         this._attachListeners();
       }
   
       _createClass(ArticleSection, [{
         key: "onUnload",
         value: function onUnload() {
           if (this.parallaxInstance) {
             this.parallaxInstance.destroy();
           }
   
           if (window.theme.showElementStaggering) {
             this.intersectionObserver.disconnect();
             this.timeline.kill();
           }
   
           window.removeEventListener('scroll', this._onScrollListener);
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._onScrollListener = this._checkToolbarVisibility.bind(this);
           window.addEventListener('scroll', this._onScrollListener);
         }
       }, {
         key: "_checkToolbarVisibility",
         value: function _checkToolbarVisibility() {
           var _this2 = this;
   
           var lastYPosition = 0,
               headerHeight = 0,
               navBottom = 0,
               isFixedHeader = 0,
               header = document.querySelector('.Header');
           fastdom.measure(function () {
             lastYPosition = window.pageYOffset;
             headerHeight = header.offsetHeight;
             isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0);
   
             if (_this2.articleNavElement) {
               navBottom = _this2.articleNavElement.offsetTop + _this2.articleNavElement.clientHeight - headerHeight;
             }
           });
           fastdom.mutate(function () {
             const clubBar = document.getElementById('club_bar');
             const clubBarHeight = clubBar ? parseInt(clubBar.offsetHeight) : 0;
             headerHeight = clubBarHeight > 0 ? (headerHeight + clubBarHeight) : headerHeight; 
             _this2.toolbarElement.style.top = isFixedHeader ? headerHeight + 'px' : null;
   
             if (_this2.articleNavElement) {
               if (lastYPosition > 150 && _this2.articleNavElement && lastYPosition < navBottom) {
                 _this2.toolbarElement.classList.add('is-visible');
               } else {
                 _this2.toolbarElement.classList.remove('is-visible');
               }
             } else {
               if (lastYPosition > 150) {
                 _this2.toolbarElement.classList.add('is-visible');
               } else {
                 _this2.toolbarElement.classList.remove('is-visible');
               }
             }
           });
         }
       }, {
         key: "_reveal",
         value: function _reveal(results) {
           var _this3 = this;
   
           var toReveal = [];
           results.forEach(function (result) {
             if (result.isIntersecting || result.intersectionRatio > 0) {
               // isIntersecting does not exist on Samsung Android browser
               toReveal.push(result.target);
   
               _this3.intersectionObserver.unobserve(result.target);
             }
           });
   
           if (toReveal.length === 0) {
             return;
           }
   
           this.timeline.staggerFromTo(toReveal, 0.45, {
             autoAlpha: 0,
             y: 30
           }, {
             autoAlpha: 1,
             y: 0
           }, 0.2);
         }
       }]);
   
       return ArticleSection;
     }();
   
     var CartSection = /*#__PURE__*/function () {
       function CartSection(container) {
         _classCallCheck(this, CartSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.documentDelegate = new domDelegate.Delegate(document.documentElement);
         this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
         this.itemCount = this.options['itemCount'];
         this.isCartNoteOpen = false;
   
         if (this.options['drawer']) {
           this.sidebarDrawer = new Drawer(this.element, {
             onClose: this._onDrawerClosed.bind(this)
           });
         }
   
         if (this.options['hasShippingEstimator']) {
           this.shippingEstimator = new ShippingEstimator(this.element.querySelector('.ShippingEstimator'));
         }
   
         this._attachListeners();
       }
   
       _createClass(CartSection, [{
         key: "onUnload",
         value: function onUnload() {
           if (this.options['hasShippingEstimator']) {
             this.shippingEstimator.destroy();
           }
   
           this.delegateElement.off();
           document.removeEventListener('product:added', this._onProductAddedListener);
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._onProductAddedListener = this._onProductAdded.bind(this);
           this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));
   
           if (this.options['type'] !== 'page') {
             this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
             this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._updateItemQuantity.bind(this));
           } else {
             this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._reloadPageWithQuantity.bind(this));
           } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page
   
   
           if (this.options['drawer']) {
             this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
           }
   
           document.addEventListener('product:added', this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart
   
           this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
         }
       }, {
         key: "_updateCartNote",
         value: function _updateCartNote(event, target) {
           fetch("".concat(window.routes.cartUrl, "/update.js"), {
             body: JSON.stringify({
               note: target.value
             }),
             credentials: 'same-origin',
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
   
             }
           });
         }
       }, {
         key: "_toggleCartNote",
         value: function _toggleCartNote() {
           var _this = this;
   
           var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
               cartNote = this.element.querySelector('#cart-note');
           this.element.classList.toggle('has-note-open');
           this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
           noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
           this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';
   
           if (this.element.classList.contains('has-note-open')) {
             var transitionEndListener = function transitionEndListener() {
               _this.element.querySelector('#cart-note').focus();
   
               noteContainer.removeEventListener('transitionend', transitionEndListener);
             };
   
             noteContainer.addEventListener('transitionend', transitionEndListener);
           }
         }
       }, {
         key: "_updateItemQuantity",
         value: function _updateItemQuantity(event, target) {
           var _this2 = this;
   
           document.dispatchEvent(new CustomEvent('theme:loading:start'));
           var quantity = null,
               elementToAnimate = null;
   
           if (target.tagName === 'INPUT') {
             quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
           } else {
             quantity = parseInt(target.getAttribute('data-quantity'));
           } // If the quantity is 0, then we will animate the product with a removal effect
   
   
           if (quantity === 0) {
             elementToAnimate = target.closest('.CartItemWrapper');
           }
   
           fetch("".concat(window.routes.cartChangeUrl, ".js"), {
             body: JSON.stringify({
               line: target.getAttribute('data-line'),
               quantity: quantity
             }),
             credentials: 'same-origin',
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
   
             }
           }).then(function (cart) {
             cart.json().then(function (content) {
               _this2.itemCount = content['item_count'];
   
               _this2._rerenderCart(elementToAnimate);
   
               document.dispatchEvent(new CustomEvent('theme:loading:end'));
             });
           });
           event.preventDefault();
         }
       }, {
         key: "_reloadPageWithQuantity",
         value: function _reloadPageWithQuantity(event, target) {
           window.location.href = "".concat(window.routes.cartChangeUrl, "?quantity=").concat(parseInt(target.value), "&line=").concat(target.getAttribute('data-line'));
         }
       }, {
         key: "_onProductAdded",
         value: function _onProductAdded(event) {
           var _this3 = this;
   
           this.itemCount += event.detail.quantity;
   
           this._rerenderCart().then(function () {
             _this3.sidebarDrawer.open();
           });
         }
       }, {
         key: "_onDrawerClosed",
         value: function _onDrawerClosed() {
           if (this.isCartNoteOpen) {
             this._toggleCartNote();
           }
         }
         /**
          * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
          * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
          * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
          * all the time and hence having easier logic.
          */
   
       }, {
         key: "_rerenderCart",
         value: function _rerenderCart(elementToAnimate) {
           var _this4 = this;
   
           // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
           return fetch("".concat(window.routes.cartUrl, "?section_id=").concat(this.options['drawer'] && window.theme.pageType !== 'cart' ? 'mini-cart' : 'main-cart', "&timestamp=").concat(Date.now()), {
             credentials: 'same-origin',
             method: 'GET'
           }).then(function (content) {
             // If there is an element to animate, we animate it using a transition
             if (_this4.options['drawer'] && elementToAnimate) {
               var timelineLite = new TimelineLite({
                 onComplete: function onComplete() {
                   content.text().then(function (html) {
                     _this4._replaceContent(html);
                   });
                 }
               });
               timelineLite.to(elementToAnimate, 0.5, {
                 height: 0,
                 opacity: 0,
                 ease: Cubic.easeOut
               }, 0);
   
               if (_this4.itemCount === 0) {
                 timelineLite.to(_this4.element.querySelector('.Drawer__Footer'), 0.5, {
                   y: '100%',
                   transition: 'none',
                   ease: Cubic.easeInOut
                 }, 0);
               }
             } else {
               content.text().then(function (html) {
                 _this4._replaceContent(html);
               });
             }
           });
         }
       }, {
         key: "_replaceContent",
         value: function _replaceContent(html) {
           var _this5 = this;
   
           var tempElement = document.createElement('div');
           tempElement.innerHTML = html;
           var cartNodeParent = this.element.querySelector('.Cart').parentNode;
   
           if (this.options['drawer'] && window.theme.pageType !== 'cart') {
             var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
             cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
             this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
           } else {
             // For dedicated page we replace the whole section if there is no more product
             if (this.itemCount === 0) {
               this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
             } else {
               cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
               this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
             }
           } // We can also update the dot and the quantity
   
   
           var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
           var cartDot = Dom.nodeListToArray(document.querySelectorAll('.Header__CartDot')),
               cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.Header__CartCount'));
           this.itemCount = cartResult['itemCount'];
           cartDot.forEach(function (item) {
             if (_this5.itemCount === 0) {
               item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
             } else {
               item.classList.add('is-visible');
             }
           });
           cartQuantity.forEach(function (item) {
             item.textContent = _this5.itemCount;
           });
         }
       }]);
   
       return CartSection;
     }();
   
     var CollectionListSection = /*#__PURE__*/function () {
       function CollectionListSection(container) {
         _classCallCheck(this, CollectionListSection);
   
         this.element = container;
         var collectionListElement = this.element.querySelector('[data-flickity-config]');
   
         if (collectionListElement) {
           this.carousel = new Carousel(collectionListElement);
         }
       }
   
       _createClass(CollectionListSection, [{
         key: "onUnload",
         value: function onUnload() {
           if (this.carousel) {
             this.carousel.destroy();
           }
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           if (this.carousel) {
             this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
           }
         }
       }, {
         key: "onBlockDeselect",
         value: function onBlockDeselect() {
           if (this.carousel) {
             this.carousel.unpausePlayer();
           }
         }
       }]);
   
       return CollectionListSection;
     }();
   
     /**
      * This class allows to automatically scrolls within a div when this div does not fit into the visible space
      */
     var OverflowScroller = /*#__PURE__*/function () {
       function OverflowScroller(element) {
         _classCallCheck(this, OverflowScroller);
   
         if (!element) {
           return;
         }
   
         this.element = element;
         this.lastKnownY = window.scrollY;
         this.currentTop = 0;
         this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);
   
         this._attachListeners();
       }
   
       _createClass(OverflowScroller, [{
         key: "destroy",
         value: function destroy() {
           window.removeEventListener('scroll', this._checkPositionListener);
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._checkPositionListener = this._checkPosition.bind(this);
           window.addEventListener('scroll', this._checkPositionListener);
         }
       }, {
         key: "_checkPosition",
         value: function _checkPosition() {
           var _this = this;
   
           fastdom.measure(function () {
             var bounds = _this.element.getBoundingClientRect(),
                 maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
                 minTop = _this.element.clientHeight - window.innerHeight;
   
             if (window.scrollY < _this.lastKnownY) {
               _this.currentTop -= window.scrollY - _this.lastKnownY;
             } else {
               _this.currentTop += _this.lastKnownY - window.scrollY;
             }
   
             _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset);
             _this.lastKnownY = window.scrollY;
           });
           fastdom.mutate(function () {
             _this.element.style.top = "".concat(_this.currentTop, "px");
           });
         }
       }]);
   
       return OverflowScroller;
     }();
   
     var CollectionSection = /*#__PURE__*/function () {
       function CollectionSection(element) {
         _classCallCheck(this, CollectionSection);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.toolbarElement = this.element.querySelector('.CollectionToolbar');
         this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products');
         this.settings = JSON.parse(this.element.getAttribute('data-section-settings')); // Create the popover if available
   
         var sortPopoverElement = document.getElementById('collection-sort-popover');
   
         if (sortPopoverElement) {
           this.sortPopover = new Popover(sortPopoverElement, {
             onValueChanged: this._sortByChanged.bind(this)
           });
         } // Create the filter drawer if available
   
   
         var filterDrawerElement = document.getElementById('collection-filter-drawer');
   
         if (filterDrawerElement) {
           this.filterDrawer = new Drawer(filterDrawerElement);
         } // Create scroller of sidebar
   
   
         if (this.settings['filterPosition'] === 'sidebar') {
           this.filterInnerSidebarScroller = new OverflowScroller(this.element.querySelector('.CollectionInner__Sidebar'));
         } // Setup parallax on image (if any)
   
   
         var collectionImageElement = this.element.querySelector('.PageHeader__ImageWrapper');
   
         if (collectionImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
           this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
             speed: -7,
             center: false,
             round: true
           });
         } // Setup product item color swatch
   
   
         new ProductItemColorSwatch(this.element.querySelector('.ProductList')); // Setup animation
   
         this.timeline = new TimelineLite({
           delay: window.theme.showPageTransition ? 0.5 : 0
         });
   
         this._setupAnimation();
   
         this._attachListeners();
       }
   
       _createClass(CollectionSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off('click');
   
           if (this.sortPopover) {
             this.sortPopover.destroy();
           }
   
           if (this.filterDrawer) {
             this.filterDrawer.destroy();
           }
   
           if (this.filterInnerSidebarScroller) {
             this.filterInnerSidebarScroller.destroy();
           }
   
           if (this.parallaxInstance) {
             this.parallaxInstance.destroy();
           }
   
           if (window.theme.showElementStaggering) {
             this.intersectionObserver.disconnect();
             this.timeline.kill();
           }
         }
       }, {
         key: "_setupAnimation",
         value: function _setupAnimation() {
           var _this = this;
   
           var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
   
           if (!window.theme.showElementStaggering) {
             return;
           } // If there is already an observer set up, we remove it first
   
   
           if (this.intersectionObserver) {
             this.intersectionObserver.disconnect();
           }
   
           if (forceLoadFromTop) {
             this.timeline.clear();
             this.timeline.staggerFromTo(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem'), 0.25, {
               autoAlpha: 0,
               y: 25
             }, {
               autoAlpha: 1,
               y: 0
             }, 0.1);
           } else {
             this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
               threshold: 0.3
             });
             Dom.nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem')).forEach(function (item) {
               _this.intersectionObserver.observe(item);
             });
           }
         }
       }, {
         key: "_reveal",
         value: function _reveal(results) {
           var _this2 = this;
   
           var toReveal = [];
           results.forEach(function (result) {
             if (result.isIntersecting || result.intersectionRatio > 0) {
               // isIntersecting does not exist on Samsung Android browser
               toReveal.push(result.target);
   
               _this2.intersectionObserver.unobserve(result.target);
             }
           });
   
           if (toReveal.length === 0) {
             return;
           }
   
           this.timeline.staggerFromTo(toReveal, 0.35, {
             autoAlpha: 0,
             y: 25
           }, {
             autoAlpha: 1,
             y: 0
           }, 0.15);
         }
       }, {
         key: "_changeLayoutMode",
         value: function _changeLayoutMode(event, target) {
           var _this3 = this;
   
           var layoutType = target.getAttribute('data-grid-type'),
               newCount = parseInt(target.getAttribute('data-count')); // Otherwise we detect the mode, and change all classes
   
           var productList = this.collectionInnerElement.querySelector('.ProductList');
   
           if (productList) {
             var previousCount = parseInt(productList.getAttribute("data-".concat(layoutType, "-count")));
   
             if (previousCount === newCount) {
               return; // Nothing has changed so we just return to avoid reflow
             }
   
             productList.setAttribute("data-".concat(layoutType, "-count"), newCount);
             Dom.nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (item) {
               if (layoutType === 'mobile') {
                 item.classList.remove("1/".concat(previousCount, "--phone")); // IE11 and lower does not support classList.replace
   
                 item.classList.add("1/".concat(newCount, "--phone"));
               } else {
                 var previousTabletCount = previousCount === 2 ? 2 : 3,
                     newTabletCount = newCount === 2 ? 2 : 3;
   
                 if (_this3.settings['filterPosition'] === 'drawer') {
                   item.classList.remove("1/".concat(previousCount, "--lap-and-up"));
                   item.classList.add("1/".concat(newCount, "--lap-and-up"));
                 } else {
                   item.classList.remove("1/".concat(previousCount, "--desk"));
                   item.classList.add("1/".concat(newCount, "--desk"));
                 }
   
                 item.classList.remove("1/".concat(previousTabletCount, "--tablet-and-up"));
                 item.classList.add("1/".concat(newTabletCount, "--tablet-and-up"));
               }
   
               if (window.theme.showElementStaggering) {
                 item.firstElementChild.style.visibility = 'hidden'; // Make it as hidden so we can re-trigger the animation
               }
             }); // Force lazy sizes to recalculate item sizes
   
             lazySizes.autoSizer.checkElems();
           }
   
           target.classList.add('is-active');
           Dom.getSiblings(target)[0].classList.remove('is-active');
   
           this._setupAnimation(); // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
           // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript
   
   
           fetch("".concat(window.routes.cartUrl, "/update.js"), {
             body: JSON.stringify({
               attributes: _defineProperty({}, "collection_".concat(layoutType, "_items_per_row"), newCount)
             }),
             credentials: 'same-origin',
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
   
             }
           });
         }
       }, {
         key: "_sortByChanged",
         value: function _sortByChanged(sortBy) {
           var currentUrl = new URL(location.href);
           currentUrl.searchParams.set('sort_by', sortBy);
           currentUrl.searchParams.delete('page');
   
           this._reloadProducts(currentUrl.toString());
         }
       }, {
         key: "_onFiltersCleared",
         value: function _onFiltersCleared(event) {
           this._reloadProducts(event.target.getAttribute('data-url'));
         }
       }, {
         key: "_onFilterChanged",
         value: function _onFilterChanged(event) {
           var formData = new FormData(event.target.closest('form'));
           var searchParamsAsString = new URLSearchParams(formData).toString();
   
           this._reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
         }
       }, {
         key: "_reloadProducts",
         value: function _reloadProducts(url) {
           var _this4 = this;
   
           if (this.abortController) {
             this.abortController.abort();
           }
   
           document.dispatchEvent(new CustomEvent('theme:loading:start'));
   
           if (history.replaceState) {
             window.history.pushState({
               path: url
             }, '', url);
           }
   
           var currentUrl = new URL(window.location);
           currentUrl.searchParams.set('section_id', this.settings['sectionId']);
   
           try {
             this.abortController = new AbortController();
             fetch(currentUrl.toString(), {
               signal: this.abortController.signal
             }).then(function (response) {
               response.text().then(function (content) {
                 var tempElement = document.createElement('div');
                 tempElement.innerHTML = content;
                 _this4.collectionInnerElement.innerHTML = tempElement.querySelector('.CollectionInner__Products').innerHTML;
                 var toolbarFilter = tempElement.querySelector('.CollectionToolbar__Item--filter');
   
                 if (toolbarFilter) {
                   var newToolbarFilter = _this4.element.querySelector('.CollectionToolbar__Item--filter');
   
                   newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
                   newToolbarFilter.className = toolbarFilter.className;
                 } // We also replace the filters
   
   
                 var collectionFiltersDrawer = _this4.element.querySelector('#collection-filters-drawer-form'),
                     collectionFiltersSidebar = _this4.element.querySelector('#collection-filters-sidebar-form');
   
                 if (collectionFiltersDrawer) {
                   var newDrawerContent = tempElement.querySelector('#collection-filters-drawer-form');
                   Array.from(collectionFiltersDrawer.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
                     var newCollapsible = newDrawerContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));
   
                     if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
                       newCollapsible.style.overflow = 'visible';
                       newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
                       newCollapsible.lastElementChild.style.height = 'auto';
                       newCollapsible.lastElementChild.style.overflow = 'visible';
                     }
                   });
                   collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
                   new ProductItemColorSwatch(_this4.element.querySelector('.ProductList'));
                 }
   
                 if (collectionFiltersSidebar) {
                   var newSidebarContent = tempElement.querySelector('#collection-filters-sidebar-form');
                   Array.from(collectionFiltersSidebar.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
                     var newCollapsible = newSidebarContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));
   
                    if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
                          
                          newCollapsible.style.overflow = 'visible';                   
                       newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
                       newCollapsible.lastElementChild.style.height = 'auto';
                       newCollapsible.lastElementChild.style.overflow = 'visible';
                     }
                     collapsible.firstElementChild.setAttribute ('aria-expanded', 'true');
                   });
                   
                   collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
                       
                 }
   
                 document.dispatchEvent(new CustomEvent('theme:loading:end'));
                 
   
                 _this4._setupAnimation(true); // We scroll to the top
   
                  
                 var elementOffset = _this4.element.querySelector('.CollectionMain').getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'));
   
                 if (Responsive.matchesBreakpoint('lap-and-up') && _this4.toolbarElement && _this4.toolbarElement.clientHeight === 0) {
                   elementOffset -= 50;
                 }
   
                 if (elementOffset < 0) {
                   window.scrollBy({
                     top: elementOffset,
                     behavior: 'smooth'
                   });
                 }
               });
             });
           } catch (exception) {}
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
           this.delegateElement.on('click', '[data-action="change-layout-mode"]', this._changeLayoutModeListener);
           this.delegateElement.on('click', '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
           this.delegateElement.on('change', '[name^="filter."]', this._onFilterChanged.bind(this));
           window.addEventListener('popstate', function (event) {
             if (event.state.path) {
               window.location.href = event.state.path;
             }
           });
         }
       }]);
   
       return CollectionSection;
     }();
   
     var FaqSection = /*#__PURE__*/function () {
       function FaqSection(element) {
         _classCallCheck(this, FaqSection);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
   
         this._attachListeners();
       }
   
       _createClass(FaqSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off();
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           this._openItem(event.target);
         }
       }, {
         key: "onBlockDeselect",
         value: function onBlockDeselect(event) {
           this._closeItem(event.target);
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '.Faq__Question', this._toggleItem.bind(this));
           this.delegateElement.on('click', '.FaqSummary__Item', this._switchToCategory.bind(this));
         }
       }, {
         key: "_switchToCategory",
         value: function _switchToCategory(event, target) {
           target.classList.add('is-active');
           Dom.getSiblings(target, '.is-active').forEach(function (item) {
             item.classList.remove('is-active');
           });
         }
       }, {
         key: "_toggleItem",
         value: function _toggleItem(event, target) {
           var item = target.closest('.Faq__Item');
   
           if (item.getAttribute('aria-expanded') === 'true') {
             this._closeItem(item);
           } else {
             this._openItem(item);
           }
         }
       }, {
         key: "_openItem",
         value: function _openItem(item) {
           var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
           item.setAttribute('aria-expanded', 'true');
           answerWrapper.setAttribute('aria-hidden', 'false');
           Animation.slideDown(answerWrapper, true);
           Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
             var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper');
             siblingItem.setAttribute('aria-expanded', 'false');
             siblingAnswerWrapper.setAttribute('aria-hidden', 'true');
             Animation.slideUp(siblingAnswerWrapper);
           });
         }
       }, {
         key: "_closeItem",
         value: function _closeItem(item) {
           var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
           item.setAttribute('aria-expanded', 'false');
           answerWrapper.setAttribute('aria-hidden', 'true');
           Animation.slideUp(answerWrapper);
         }
       }]);
   
       return FaqSection;
     }();
   
     var FeaturedCollectionsSection = /*#__PURE__*/function () {
       function FeaturedCollectionsSection(container) {
         var _this = this;
   
         _classCallCheck(this, FeaturedCollectionsSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.options = JSON.parse(this.element.getAttribute('data-settings'));
         this.carousels = [];
         Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
           _this.carousels.push(new Carousel(item));
         }); // Setup product item color swatch
   
         new ProductItemColorSwatch(this.element);
   
         this._setupAnimation();
   
         this._attachListeners();
       }
   
       _createClass(FeaturedCollectionsSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.carousels.forEach(function (item) {
             return item.destroy();
           });
           this.delegateElement.off('click');
           this.intersectionObserver.disconnect();
           this.timeline.kill();
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           // We simply trigger a click on the element that controls this tab
           this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '[data-action="toggle-tab"]', this._switchTab.bind(this));
         }
       }, {
         key: "_switchTab",
         value: function _switchTab(event, target) {
           var _this2 = this;
   
           // If the tab is already active, do nothing
           if (target.classList.contains('is-active')) {
             return;
           } // First, switch the current tab
   
   
           target.classList.add('is-active');
           Dom.getSiblings(target, '.is-active').forEach(function (item) {
             item.classList.remove('is-active');
           }); // Then, display the panel
   
           var tabPanelToShow = this.element.querySelector("#".concat(target.getAttribute('aria-controls')));
           this.timeline.eventCallback('onReverseComplete', function () {
             tabPanelToShow.setAttribute('aria-hidden', 'false');
             Dom.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
               item.setAttribute('aria-hidden', 'true');
             });
   
             if (Responsive.matchesBreakpoint('lap-and-up')) {
               _this2.carousels.forEach(function (carousel) {
                 // There is a bug in Safari where it cannot detect the pseudo-element "::after" if the tab panel is hidden. As a consequence,
                 // we manually activate it
                 carousel.flickityInstance.activate();
                 carousel.flickityInstance.resize(); // Ugly hack
               });
             }
   
             _this2.timeline.clear();
   
             _this2._setupAnimation();
           });
   
           if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
             this.timeline.reverse().timeScale(3);
           } else {
             this.timeline.reverse();
           }
         }
       }, {
         key: "_setupAnimation",
         value: function _setupAnimation() {
           var _this3 = this;
   
           if (this.intersectionObserver) {
             this.intersectionObserver.disconnect();
           }
   
           this.timeline = new TimelineLite({
             delay: 0.5
           });
   
           if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
             this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
             Dom.nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (item) {
               _this3.intersectionObserver.observe(item);
             });
           } else {
             var productList = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');
   
             if (productList) {
               this.timeline.fromTo(productList, 0.6, {
                 autoAlpha: 0,
                 y: 25
               }, {
                 autoAlpha: 1,
                 y: 0
               });
             }
           }
         }
       }, {
         key: "_reveal",
         value: function _reveal(results) {
           var _this4 = this;
   
           var toReveal = [];
           results.forEach(function (result) {
             if (result.isIntersecting || result.intersectionRatio > 0) {
               // isIntersecting does not exist on Samsung Android browser
               toReveal.push(result.target);
   
               _this4.intersectionObserver.unobserve(result.target);
             }
           });
   
           if (toReveal.length === 0) {
             return;
           }
   
           this.timeline.staggerFromTo(toReveal, 0.45, {
             autoAlpha: 0,
             y: 25
           }, {
             autoAlpha: 1,
             y: 0
           }, 0.2);
         }
       }]);
   
       return FeaturedCollectionsSection;
     }();
   
     var FeaturedProductSection = /*#__PURE__*/function () {
       function FeaturedProductSection(container) {
         _classCallCheck(this, FeaturedProductSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
   
         if (!this.options['usePlaceholder']) {
           this.productVariants = new ProductVariants(container, this.options);
         } // We have to re-order elements in the DOM
   
   
         var offscreenElement = this.element.querySelector('.Product__OffScreen');
   
         if (offscreenElement) {
           this.element.appendChild(offscreenElement);
         }
   
         this._attachListeners();
       }
   
       _createClass(FeaturedProductSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off('click');
   
           if (this.productVariants) {
             this.productVariants.destroy();
           }
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
         }
         /**
          * Update the main featured image
          */
   
       }, {
         key: "_updateMainImage",
         value: function _updateMainImage(event) {
           var variant = event.detail.variant,
               previousVariant = event.detail.previousVariant;
   
           if (!variant || !variant['featured_image'] || previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
             return;
           } // Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid
   
   
           var newImage = variant['featured_image'];
           var mainImageContainer = this.element.querySelector('.FeaturedProduct__Gallery .AspectRatio');
           mainImageContainer.style.cssText = "max-width: ".concat(newImage['width'], "px; --aspect-ratio: ").concat(newImage['width'] / newImage['height']);
           var newImageElement = document.createElement('img');
           newImageElement.classList.add('Image--lazyLoad');
           newImageElement.setAttribute('data-src', Image.getSizedImageUrl(newImage['src'], '1x1').replace('_1x1.', '_{width}x.'));
           newImageElement.setAttribute('data-widths', "[".concat(Image.getSupportedSizes(newImage, [200, 400, 600, 700, 800, 900, 1000]).join(','), "]"));
           newImageElement.setAttribute('data-sizes', 'auto');
           mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
         }
       }]);
   
       return FeaturedProductSection;
     }();
   
     var BackgroundVideoSection = /*#__PURE__*/function () {
       function BackgroundVideoSection(container) {
         _classCallCheck(this, BackgroundVideoSection);
   
         this.element = container;
         this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
   
         this._loadScript().then(this._setupPlayer.bind(this));
       }
   
       _createClass(BackgroundVideoSection, [{
         key: "_loadScript",
         value: function _loadScript() {
           var _this = this;
   
           return new Promise(function (resolve, reject) {
             var script = document.createElement('script');
             document.body.appendChild(script);
             script.onload = resolve;
             script.onerror = reject;
             script.async = true;
             script.src = _this.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
           });
         }
       }, {
         key: "onUnload",
         value: function onUnload() {
           if (this.player) {
             this.player.destroy(); // Both YouTube and Vimeo use the same function name
           }
         }
       }, {
         key: "_setupPlayer",
         value: function _setupPlayer() {
           var _this2 = this;
   
           var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');
           var playerLoadingInterval = setInterval(function () {
             if (_this2.options['videoType'] === 'youtube') {
               if (window.YT) {
                 _this2.player = new YT.Player(elementToInsert, {
                   videoId: _this2.options['videoId'],
                   playerVars: {
                     showinfo: 0,
                     controls: 0,
                     fs: 0,
                     rel: 0,
                     height: '100%',
                     width: '100%',
                     iv_load_policy: 3,
                     html5: 1,
                     loop: 1,
                     playsinline: 1,
                     modestbranding: 1,
                     disablekb: 1,
                     origin: _this2.options['requestHost']
                   },
                   events: {
                     onReady: _this2._onYouTubeReady.bind(_this2),
                     onStateChange: _this2._onYouTubeStateChange.bind(_this2)
                   }
                 });
                 clearInterval(playerLoadingInterval);
               }
             } else {
               if (window.Vimeo) {
                 _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                   id: _this2.options['videoId'],
                   autoplay: true,
                   autopause: false,
                   muted: true,
                   background: true,
   
                   /*height: '100%',
                   width: '100%',*/
                   loop: true
                 });
                 clearInterval(playerLoadingInterval);
               }
             }
           }, 50);
         }
       }, {
         key: "_onYouTubeReady",
         value: function _onYouTubeReady(event) {
           this.player.mute();
           this.player.playVideo();
         }
       }, {
         key: "_onYouTubeStateChange",
         value: function _onYouTubeStateChange(event) {
           if (event.data === YT.PlayerState.ENDED) {
             this.player.playVideo();
           }
         }
       }]);
   
       return BackgroundVideoSection;
     }();
   
     var GiftCardSection = /*#__PURE__*/function () {
       function GiftCardSection(container) {
         _classCallCheck(this, GiftCardSection);
   
         this.element = container;
   
         this._createQrCode();
   
         this._setupPrint();
       }
   
       _createClass(GiftCardSection, [{
         key: "_createQrCode",
         value: function _createQrCode() {
           var qrCodeElement = document.getElementById('QrCode');
           new QRCode(qrCodeElement, {
             text: qrCodeElement.getAttribute('data-identifier'),
             width: 120,
             height: 120
           });
         }
       }, {
         key: "_setupPrint",
         value: function _setupPrint() {
           var printElement = document.getElementById('PrintGiftCard');
   
           if (printElement) {
             printElement.addEventListener('click', function () {
               window.print();
             });
           }
         }
       }]);
   
       return GiftCardSection;
     }();
   
     var HeaderSection = /*#__PURE__*/function () {
       function HeaderSection(container) {
         var _this = this;
   
         _classCallCheck(this, HeaderSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
         this.lastScrollPosition = -1;
         this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;
   
         if (this.options['isSticky']) {
           Stickyfill.addOne(this.element.parentNode);
         } // Set up the search bar
   
   
         this.searchBar = new SearchBar();
   
         this._attachListeners();
   
         this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS
   
   
         var mainLogo = this.element.querySelector('.Header__LogoImage--primary');
   
         if (mainLogo && !mainLogo.complete) {
           mainLogo.addEventListener('load', function () {
             fastdom.measure(function () {
               document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
               document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
             });
           });
         } else {
           fastdom.measure(function () {
             document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
             document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
           });
         }
   
         window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));
   
         this._setupLocalizationPopovers();
       }
   
       _createClass(HeaderSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.element.removeEventListener('mouseleave', this._closeNavigationListener);
           this.element.removeEventListener('mouseenter', this._focusNavigationListener);
           this.element.removeEventListener('focusin', this._focusNavigationListener);
           this.delegateElement.off();
           window.removeEventListener('scroll', this._checkTransparentHeaderListener);
           window.removeEventListener('resize', this._verifyNavigationOverlapListener);
   
           if (this.options['isSticky']) {
             Stickyfill.removeOne(this.element.parentNode);
           }
   
           this.searchBar.destroy();
           this.localizationPopovers.forEach(function (localizationPopover) {
             localizationPopover.destroy();
           });
         }
       }, {
         key: "onSelect",
         value: function onSelect() {
           this._checkTransparentHeader();
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           var _this2 = this;
   
           var listItem = event.target.closest('.HorizontalList__Item');
           fastdom.mutate(function () {
             event.target.setAttribute('aria-hidden', 'false');
   
             if (listItem) {
               listItem.classList.add('is-expanded');
               Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
                 item.classList.remove('is-expanded');
               });
             }
   
             _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible
   
           });
         }
       }, {
         key: "onBlockDeselect",
         value: function onBlockDeselect(event) {
           var listItem = event.target.closest('.HorizontalList__Item');
           fastdom.mutate(function () {
             event.target.setAttribute('aria-hidden', 'true');
   
             if (listItem) {
               listItem.classList.remove('is-expanded');
             }
           });
   
           this._checkTransparentHeader();
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
           this._closeNavigationListener = this._closeNavigation.bind(this);
           this._focusNavigationListener = this._focusNavigation.bind(this);
           this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
           this.element.addEventListener('mouseleave', this._closeNavigationListener);
           this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
           this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
           this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
           this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
           this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
           this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);
   
           if (this.isTouch) {
             this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
           }
   
           if (this.options['hasTransparentHeader']) {
             this.element.addEventListener('mouseenter', this._focusNavigationListener);
             this.element.addEventListener('focusin', this._focusNavigationListener);
           }
   
           if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
             window.addEventListener('scroll', this._checkTransparentHeaderListener);
           }
   
           if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
             window.addEventListener('resize', this._verifyNavigationOverlapListener);
           }
         }
       }, {
         key: "_setupLocalizationPopovers",
         value: function _setupLocalizationPopovers() {
           // Prestige is an extremely complex theme, especially in the header due to the various layouts that power different
           // features. One issue that arises with this is that we output the localization elements twice in the DOM (with the
           // same ID as we're doing a capture in Liquid), and then depending on the screen size one layout is choosen. We therefore
           // have to de-duplicate the ID here. This is honestly not the cleanest code on earth, but I prefer handling this here
           // rather than duplicating too much Liquid
           this.localizationPopovers = [];
           Dom.nodeListToArray(document.querySelectorAll('#header-locale-popover')).forEach(function (item, index) {
             item.id = "".concat(item.id, "-").concat(index);
           });
           Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (item, index) {
             item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
           });
           Dom.nodeListToArray(document.querySelectorAll('#header-currency-popover')).forEach(function (item, index) {
             item.id = "".concat(item.id, "-").concat(index);
           });
           Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (item, index) {
             item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
           });
           var localePopoverElement1 = document.getElementById('header-locale-popover-0');
   
           if (localePopoverElement1) {
             this.localizationPopovers.push(new Popover(localePopoverElement1, {
               preferredAlignment: 'center',
               preferredPosition: 'bottom',
               threshold: 12
             }));
           }
   
           var localePopoverElement2 = document.getElementById('header-locale-popover-1');
   
           if (localePopoverElement2) {
             this.localizationPopovers.push(new Popover(localePopoverElement2, {
               preferredAlignment: 'center',
               preferredPosition: 'bottom',
               threshold: 12
             }));
           }
   
           var currencyPopoverElement1 = document.getElementById('header-currency-popover-0');
   
           if (currencyPopoverElement1) {
             this.localizationPopovers.push(new Popover(currencyPopoverElement1, {
               preferredAlignment: 'center',
               preferredPosition: 'bottom',
               threshold: 12
             }));
           }
   
           var currencyPopoverElement2 = document.getElementById('header-currency-popover-1');
   
           if (currencyPopoverElement2) {
             this.localizationPopovers.push(new Popover(currencyPopoverElement2, {
               preferredAlignment: 'center',
               preferredPosition: 'bottom',
               threshold: 12
             }));
           }
         }
       }, {
         key: "_focusNavigation",
         value: function _focusNavigation() {
           var _this3 = this;
   
           fastdom.mutate(function () {
             if (!_this3.isTouch || Responsive.matchesBreakpoint('desk')) {
               _this3.element.classList.remove('Header--transparent');
             }
           });
         }
       }, {
         key: "_closeNavigation",
         value: function _closeNavigation() {
           var _this4 = this;
   
           fastdom.mutate(function () {
             Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
               item.classList.remove('is-expanded');
             });
             Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
               item.setAttribute('aria-hidden', 'true');
             });
           });
   
           if (this.options['hasTransparentHeader']) {
             this._checkTransparentHeader();
           }
         }
       }, {
         key: "_openMenu",
         value: function _openMenu(event, target) {
           if (event.type === 'mouseenter' && target !== event.target) {
             return;
           }
   
           fastdom.mutate(function () {
             target.classList.add('is-expanded');
             Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
               item.setAttribute('aria-hidden', 'false');
             });
             Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
               item.classList.remove('is-expanded');
               Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
                 item.setAttribute('aria-hidden', 'true');
               });
             });
           });
         }
       }, {
         key: "_closeMenu",
         value: function _closeMenu(event, target) {
           if (event.type === 'mouseleave' && target !== event.target) {
             return;
           }
   
           fastdom.mutate(function () {
             target.classList.remove('is-expanded');
             Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
               item.setAttribute('aria-hidden', 'true');
             });
           });
         }
       }, {
         key: "_adjustDropdownPosition",
         value: function _adjustDropdownPosition(event, target) {
           var nestedMenus = Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
               shouldOpenLeft = false;
           fastdom.measure(function () {
             var windowWidth = window.innerWidth,
                 rightEdge = target.getBoundingClientRect().right;
             nestedMenus.forEach(function (item) {
               if (rightEdge + item.offsetWidth > windowWidth) {
                 shouldOpenLeft = true;
               }
             });
           });
           fastdom.mutate(function () {
             if (shouldOpenLeft) {
               nestedMenus.forEach(function (item) {
                 item.classList.add('DropdownMenu--reversed');
               });
             } else {
               nestedMenus.forEach(function (item) {
                 item.classList.remove('DropdownMenu--reversed');
               });
             }
           });
         }
         /**
          * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
          * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
          * the sub-menu. If this link is clicked a second twice, then the menu is followed
          */
   
       }, {
         key: "_handleTouchMenu",
         value: function _handleTouchMenu(event, target) {
           if (!target.classList.contains('is-expanded')) {
             event.preventDefault();
           }
         }
       }, {
         key: "_verifyNavigationOverlap",
         value: function _verifyNavigationOverlap() {
           var _this5 = this;
   
           var isOverlapping = false,
               mainTopMenu = this.element.querySelector('.Header__MainNav');
           fastdom.measure(function () {
             // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
             if (mainTopMenu) {
               // Get the first element
               var firstNavElementHeight = Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
                   mainNavHeight = mainTopMenu.scrollHeight;
   
               if (mainNavHeight > firstNavElementHeight) {
                 isOverlapping = true;
               }
             }
           });
           this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
           this.element.classList.add("Header--".concat(this.options['navigationStyle']));
           this.element.clientWidth; // Forces a reflow
   
           fastdom.mutate(function () {
             if (isOverlapping) {
               _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));
   
               _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode
   
   
               if (mainTopMenu) {
                 // Get the first element
                 var itemTopSet = new Set();
                 Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
                   itemTopSet.add(item.getBoundingClientRect().top);
                 });
                 isOverlapping = itemTopSet.size > 1;
               }
             } else {
               _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));
   
               _this5.element.classList.remove('Header--center');
             }
   
             var logo = _this5.element.querySelector('.Header__FlexItem--logo');
   
             logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);
   
             _this5.element.classList.add('Header--initialized');
   
             fastdom.measure(function () {
               document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
             });
           });
         }
         /**
          * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
          * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
          * scroll listener)
          */
   
       }, {
         key: "_checkTransparentHeader",
         value: function _checkTransparentHeader() {
           var _this6 = this;
   
           if (!this.options['hasTransparentHeader']) {
             return;
           }
   
           var scrollThreshold = 10;
           fastdom.measure(function () {
             _this6.lastScrollPosition = window.pageYOffset;
           });
           fastdom.mutate(function () {
             if (_this6.lastScrollPosition <= scrollThreshold) {
               _this6.element.classList.add('Header--transparent');
             } else {
               _this6.element.classList.remove('Header--transparent');
             }
           });
         }
       }]);
   
       return HeaderSection;
     }();
   
     var FooterSection = /*#__PURE__*/function () {
       function FooterSection(container) {
         _classCallCheck(this, FooterSection);
   
         this.element = container;
         var localePopoverElement = document.getElementById('footer-locale-popover');
   
         if (localePopoverElement) {
           this.localePopover = new Popover(localePopoverElement, {
             preferredAlignment: 'center',
             preferredPosition: 'top',
             threshold: 12
           });
         }
   
         var currencyPopoverElement = document.getElementById('footer-currency-popover');
   
         if (currencyPopoverElement) {
           this.currencyPopover = new Popover(currencyPopoverElement, {
             preferredAlignment: 'center',
             preferredPosition: 'top',
             threshold: 12
           });
         }
       }
   
       _createClass(FooterSection, [{
         key: "onUnload",
         value: function onUnload() {
           if (this.localePopover) {
             this.localePopover.destroy();
           }
   
           if (this.currencyPopover) {
             this.currencyPopover.destroy();
           }
         }
       }]);
   
       return FooterSection;
     }();
   
     var ImageWithTextBlockSection = /*#__PURE__*/function () {
       function ImageWithTextBlockSection(container) {
         _classCallCheck(this, ImageWithTextBlockSection);
   
         this.element = container;
       }
   
       _createClass(ImageWithTextBlockSection, [{
         key: "onUnload",
         value: function onUnload() {}
       }]);
   
       return ImageWithTextBlockSection;
     }();
   
     var LoginSection = /*#__PURE__*/function () {
       function LoginSection(container) {
         _classCallCheck(this, LoginSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.timelineLite = new TimelineLite();
         this.customerLoginForm = this.element.querySelector('#customer_login');
         this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
         this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
       }
   
       _createClass(LoginSection, [{
         key: "_showRecoverPassword",
         value: function _showRecoverPassword() {
           var isLoginActive = this.customerLoginForm.style.display === 'block';
   
           if (isLoginActive) {
             this.timelineLite.fromTo(this.customerLoginForm, 0.5, {
               autoAlpha: 1,
               display: 'block',
               y: 0
             }, {
               autoAlpha: 0,
               y: 20,
               display: 'none'
             }).fromTo(this.recoverPasswordForm, 0.5, {
               autoAlpha: 0,
               display: 'none',
               y: 20
             }, {
               autoAlpha: 1,
               display: 'block',
               y: 0,
               delay: 0.25
             });
           } else {
             this.timelineLite.fromTo(this.recoverPasswordForm, 0.5, {
               autoAlpha: 1,
               display: 'block',
               y: 0
             }, {
               autoAlpha: 0,
               y: 20,
               display: 'none'
             }).fromTo(this.customerLoginForm, 0.5, {
               autoAlpha: 0,
               display: 'none',
               y: 20
             }, {
               autoAlpha: 1,
               display: 'block',
               y: 0,
               delay: 0.25
             });
           }
         }
       }]);
   
       return LoginSection;
     }();
   
     var MapSection = /*#__PURE__*/function () {
       function MapSection(element) {
         _classCallCheck(this, MapSection);
   
         this.element = element;
         this.options = JSON.parse(element.getAttribute('data-section-settings'));
   
         if (this.options['apiKey'] && this.options['mapAddress']) {
           this._loadScript().then(this._initMap.bind(this));
         }
       }
   
       _createClass(MapSection, [{
         key: "_loadScript",
         value: function _loadScript() {
           var _this = this;
   
           return new Promise(function (resolve, reject) {
             var script = document.createElement('script');
             document.body.appendChild(script);
             script.onload = resolve;
             script.onerror = reject;
             script.async = true;
             script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(_this.options['apiKey']);
           });
         }
       }, {
         key: "_initMap",
         value: function _initMap() {
           var _this2 = this;
   
           var geocoder = new google.maps.Geocoder();
           geocoder.geocode({
             address: this.options['mapAddress']
           }, function (results, status) {
             if (status !== google.maps.GeocoderStatus.OK) {
               if (Shopify.designMode) ;
             } else {
               var mapOptions = {
                 zoom: _this2.options['zoom'],
                 center: results[0].geometry.location,
                 draggable: false,
                 clickableIcons: false,
                 scrollwheel: false,
                 disableDoubleClickZoom: true,
                 disableDefaultUI: true
               };
               var map = new google.maps.Map(_this2.element.querySelector('.FeaturedMap__GMap'), mapOptions),
                   center = map.getCenter();
               map.setCenter(center);
               var icon = {
                 path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                 fillColor: _this2.options['markerColor'],
                 fillOpacity: 1,
                 anchor: new google.maps.Point(15, 55),
                 strokeWeight: 0,
                 scale: 0.6
               };
               new google.maps.Marker({
                 map: map,
                 position: map.getCenter(),
                 icon: icon
               });
               var styledMapType = new google.maps.StyledMapType(JSON.parse(_this2.element.querySelector('[data-gmap-style]').innerHTML));
               map.mapTypes.set('styled_map', styledMapType);
               map.setMapTypeId('styled_map');
               google.maps.event.addDomListener(window, 'resize', function () {
                 google.maps.event.trigger(map, 'resize');
                 map.setCenter(center);
               });
             }
           });
         }
       }]);
   
       return MapSection;
     }();
   
     var NewsletterPopupSection = /*#__PURE__*/function () {
       function NewsletterPopupSection(element) {
         _classCallCheck(this, NewsletterPopupSection);
   
         this.element = element;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.options = JSON.parse(element.getAttribute('data-section-settings')); // If the popup has been already displayed, we do not display it
   
         try {
           if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
             this._openPopup();
           } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
             setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
           }
         } catch (error) {// Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
         }
   
         this._attachListeners();
       }
   
       _createClass(NewsletterPopupSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off();
         }
       }, {
         key: "onSelect",
         value: function onSelect() {
           this._openPopup();
         }
       }, {
         key: "onDeselect",
         value: function onDeselect() {
           this._closePopup();
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
         }
       }, {
         key: "_openPopup",
         value: function _openPopup() {
           this.element.setAttribute('aria-hidden', 'false');
           localStorage.setItem('themePopup', 'true');
         }
       }, {
         key: "_closePopup",
         value: function _closePopup() {
           this.element.setAttribute('aria-hidden', 'true');
         }
       }]);
   
       return NewsletterPopupSection;
     }();
   
     var ProductRecommendationsSection = /*#__PURE__*/function () {
       function ProductRecommendationsSection(container) {
         _classCallCheck(this, ProductRecommendationsSection);
   
         this.element = container;
         this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
   
         if (this.options['useRecommendations']) {
           this._loadRecommendations().then(this._createSlideshow.bind(this));
         } else {
           this._createSlideshow();
         }
       }
   
       _createClass(ProductRecommendationsSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.carousel.destroy();
         }
       }, {
         key: "_loadRecommendations",
         value: function _loadRecommendations() {
           var _this = this;
   
           var url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&product_id=").concat(this.options['productId'], "&limit=").concat(this.options['recommendationsCount']);
           return fetch(url).then(function (response) {
             return response.text().then(function (content) {
               var container = document.createElement('div');
               container.innerHTML = content;
               _this.element.querySelector('.ProductRecommendations').innerHTML = container.querySelector('.ProductRecommendations').innerHTML;
             });
           });
         }
       }, {
         key: "_createSlideshow",
         value: function _createSlideshow() {
           var flickityElement = this.element.querySelector('[data-flickity-config]');
   
           if (!flickityElement) {
             return;
           }
   
           this.carousel = new Carousel(flickityElement); // Setup product item color swatch
   
           new ProductItemColorSwatch(this.element);
         }
       }]);
   
       return ProductRecommendationsSection;
     }();
   
     var ProductSection = /*#__PURE__*/function () {
       function ProductSection(container) {
         var _this = this;
   
         _classCallCheck(this, ProductSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
         this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]');
         this.productVariants = new ProductVariants(container, this.options);
         this.productReviews = new ProductReviews(container);
         var productSlideshowElement = this.element.querySelector('.Product__Slideshow'); // If there is no image at all, there is nothing to init
   
         if (productSlideshowElement) {
           this.productSlideshow = new Carousel(productSlideshowElement, {
             onSelect: this._onImageChanged.bind(this),
             onSettle: this._onImageSettled.bind(this)
           }, {
             draggable: !Responsive.matchesBreakpoint('supports-hover')
           });
           this.mediaList = {}; // We keep track of a list of media element
   
           this.previouslySelectedMedia = null; // Keep track of the previously selected media
           // For each model and video, we register a media
   
           productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
             _this.mediaList[model.getAttribute('data-media-id')] = new ProductModel(model, _this.options['stackProductImages']);
           });
           productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
             _this.mediaList[video.getAttribute('data-media-id')] = new ProductVideo(video, _this.options['stackProductImages'], _this.options['enableVideoLooping']);
           });
   
           if (this.options['stackProductImages']) {
             this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots');
             this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : [];
           }
   
           if (this.options['showThumbnails']) {
             this.slideshowNavThumbnails = this.element.querySelector('.Product__SlideshowNav--thumbnails');
             this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage')) : [];
           }
   
           this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.Carousel__Cell')); // Setup the mobile nav
   
           this._setupSlideshowMobileNav();
         }
   
         this.productWrapperElement = this.element.querySelector('.Product__Wrapper');
         this.productInfoElement = this.element.querySelector('.Product__Info');
         this.productAsideElement = this.element.querySelector('.Product__Aside');
         this.productGalleryElement = this.element.querySelector('.Product__Gallery');
         this.quickNav = this.element.querySelector('.Product__QuickNav');
   
         if (this.options['enableImageZoom']) {
           this.imageZoomInstance = new ProductImageZoom(this.element, this.productSlideshow);
         }
   
         Stickyfill.addOne(this.productInfoElement); // We have to re-order elements in the DOM
   
         var offscreenElement = this.element.querySelector('.Product__OffScreen');
   
         if (offscreenElement) {
           this.element.appendChild(offscreenElement);
         }
   
         this._setupDeviceFeatures();
   
         this._attachListeners();
       }
   
       _createClass(ProductSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off('click');
           this.productReviews.destroy();
   
           if (this.productVariants) {
             this.productVariants.destroy();
           }
   
           if (this.productSlideshow) {
             this.productSlideshow.destroy();
           }
   
           if (this.options['enableImageZoom']) {
             this.imageZoomInstance.destroy();
           }
   
           if (this.carouselNavScrollSpy) {
             this.carouselNavScrollSpy.destroy();
           }
   
           if (this.quickNav) {
             window.removeEventListener('scroll', this._checkQuickNavListener);
           }
   
           if (this.productInfoScroller) {
             this.productInfoScroller.destroy();
           }
   
           if (this.productThumbnailsScroller) {
             this.productThumbnailsScroller.destroy();
           }
   
           if (window.ResizeObserver && this.productInfoResizeObserver) {
             this.productInfoResizeObserver.disconnect();
           }
   
           Stickyfill.removeOne(this.productInfoElement);
           document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
           this._checkQuickNavListener = this._checkQuickNav.bind(this);
           this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
           this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
           this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));
           this.delegateElement.on('model:played', this._onMediaPlayed.bind(this));
           this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));
           this.delegateElement.on('model:paused', this._onMediaPaused.bind(this));
           this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));
           document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
   
           if (this.quickNav) {
             window.addEventListener('scroll', this._checkQuickNavListener);
           }
   
           if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
             this.delegateElement.on('click', '.Product__SlideshowNavImage', this._switchToImage.bind(this));
           }
         }
       }, {
         key: "_setupSlideshowMobileNav",
         value: function _setupSlideshowMobileNav() {
           var _this2 = this;
   
           this.slideshowMobileNav = this.element.querySelector('.Product__SlideshowMobileNav');
   
           if (this.slideshowMobileNav) {
             var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav); // Handle the dot
   
             slideshowMobileNavDelegate.on('click', '.dot', function (event, element) {
               _this2._slideWillChange();
   
               _this2.productSlideshow.selectCell(parseInt(element.getAttribute('data-index')));
             }); // Handle the buttons
   
             slideshowMobileNavDelegate.on('click', '.Product__SlideshowNavArrow', function (event, element) {
               _this2._slideWillChange();
   
               if (element.getAttribute('data-direction') === 'next') {
                 _this2.productSlideshow.next();
               } else {
                 _this2.productSlideshow.previous();
               }
             });
           }
         }
         /**
          * Update the main carousel image
          */
   
       }, {
         key: "_updateSlideshowImage",
         value: function _updateSlideshowImage(event) {
           var variant = event.detail.variant,
               previousVariant = event.detail.previousVariant;
   
           if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
             return;
           } // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor
   
   
           this._slideWillChange();
   
           if (Responsive.matchesBreakpoint('pocket') || !this.options['stackProductImages']) {
             for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
               var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
                   mediaId = parseInt(cellElement.getAttribute('data-media-id'));
   
               if (mediaId === variant['featured_media']['id']) {
                 this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
               }
             }
           } else {
             document.querySelector("[href=\"#Media".concat(variant['featured_media']['id'], "\"]")).click(); //document.getElementById(`Media${variant['featured_media']['id']}`).scrollIntoView({behavior: 'smooth'});
           }
         }
         /**
          * This happens when a media is played
          */
   
       }, {
         key: "_onMediaPlayed",
         value: function _onMediaPlayed(event) {
           // Remove draggability
           this.productSlideshow.getFlickityInstance().options.draggable = false;
           this.productSlideshow.getFlickityInstance().unbindDrag(); // If there is a previously enabled media, we disable it
   
           if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
             this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
           } // If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
           // have to keep track of it here
   
   
           if (this.options['stackProductImages']) {
             this.previouslySelectedMedia = event.target;
           }
         }
         /**
          * This happens when a given media is paused
          */
   
       }, {
         key: "_onMediaPaused",
         value: function _onMediaPaused() {
           // Enable draggability
           this.productSlideshow.getFlickityInstance().options.draggable = !Responsive.matchesBreakpoint('supports-hover');
           this.productSlideshow.getFlickityInstance().bindDrag();
         }
         /**
          * This method is called when a media changed in the slideshow
          */
   
       }, {
         key: "_handleMedia",
         value: function _handleMedia(item) {
           // First, we need to turn off the previous media (if any)
           if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
             switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
               case 'video':
               case 'external_video':
               case 'model':
                 this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
             } // If the previous media was a model, we need to adjust the "view in space" button to go back to initial value
   
   
             if (this.previouslySelectedMedia.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
               this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'));
             }
           } // Then, we have to handle the currently selected media
   
   
           switch (item.getAttribute('data-media-type')) {
             case 'video':
             case 'external_video':
             case 'model':
               this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected();
               break;
           } // If the media is a model, we need to adjust the "view in space" button
   
   
           if (item.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
             this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', item.getAttribute('data-media-id'));
           } // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted
   
   
           this.previouslySelectedMedia = item;
         }
         /**
          * Callback when the target changes
          */
   
       }, {
         key: "_onScrollTargetChanged",
         value: function _onScrollTargetChanged(event) {
           // The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
           // manually iterate through all of them to remove it first
           if (this.options['stackProductImages']) {
             this.slideshowNavDotsItems.forEach(function (item) {
               return item.classList.remove('is-selected');
             });
             this.slideshowNavDotsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');
   
             if (this.options['showThumbnails']) {
               this.slideshowNavThumbnailsItems.forEach(function (item) {
                 return item.classList.remove('is-selected');
               });
               this.slideshowNavThumbnailsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');
             }
           }
         }
       }, {
         key: "_switchToImage",
         value: function _switchToImage(event, target) {
           event.preventDefault();
   
           this._slideWillChange();
   
           for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
             var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
                 mediaId = parseInt(cellElement.getAttribute('data-media-id'));
   
             if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
               this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
             }
           }
         }
         /**
          * Check the quick nav
          */
   
       }, {
         key: "_checkQuickNav",
         value: function _checkQuickNav() {
           var _this3 = this;
   
           var showAsideQuickNav = false;
           fastdom.measure(function () {
             showAsideQuickNav = window.scrollY >= _this3.productAsideElement.offsetTop - _this3.productAsideElement.clientHeight;
           });
           fastdom.mutate(function () {
             if (showAsideQuickNav) {
               _this3.quickNav.classList.add('is-flipped');
             } else {
               _this3.quickNav.classList.remove('is-flipped');
             }
           });
         }
         /**
          * Toggle the social share icons
          */
   
       }, {
         key: "_toggleSocialShare",
         value: function _toggleSocialShare(event, target) {
           target.classList.toggle('is-active');
           target.classList.toggle('RoundButton--secondaryState');
           target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
           target.nextElementSibling.setAttribute('aria-hidden', target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
         }
       }, {
         key: "_onImageChanged",
         value: function _onImageChanged(event, cell) {
           // If cell is video or model, we hide the action list
           if (Responsive.matchesBreakpoint('pocket')) {
             var productGalleryActionListElement = this.element.querySelector('.Product__Gallery .Product__ActionList');
   
             if (productGalleryActionListElement) {
               if (cell.classList.contains('Product__SlideItem--image')) {
                 productGalleryActionListElement.classList.remove('is-hidden');
               } else {
                 productGalleryActionListElement.classList.add('is-hidden');
               }
             }
           } // If we have non-stacked with thumbnails, update it
   
   
           if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
             var mediaId = cell.getAttribute('data-media-id');
             this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
               if (thumbnail.getAttribute('data-media-id') === mediaId) {
                 thumbnail.classList.add('is-selected');
               } else {
                 thumbnail.classList.remove('is-selected');
               }
             });
           } // If we have the mobile navigation, we also update it
   
   
           if (this.slideshowMobileNav) {
             var selectedIndex = parseInt(cell.getAttribute('data-media-position')) - 1; // The -1 is to make it 0 indexed
   
             Dom.nodeListToArray(this.slideshowMobileNav.querySelectorAll('.dot')).forEach(function (item, index) {
               if (index === selectedIndex) {
                 item.classList.add('is-selected');
               } else {
                 item.classList.remove('is-selected');
               }
             });
           }
         }
       }, {
         key: "_onImageSettled",
         value: function _onImageSettled(index, cell) {
           this._handleMedia(cell);
   
           if (Responsive.matchesBreakpoint('lap-and-up')) {
             var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)');
             slides.forEach(function (slide) {
               slide.classList.add('Product__SlideItem--hidden');
             });
           }
         }
       }, {
         key: "_slideWillChange",
         value: function _slideWillChange() {
           if (Responsive.matchesBreakpoint('lap-and-up')) {
             var slides = this.element.querySelectorAll('.Product__SlideItem');
             slides.forEach(function (slide) {
               slide.classList.remove('Product__SlideItem--hidden');
             });
           }
         }
         /**
          * Verify when the screen size changes to create additional stuff on non pocket mode
          */
   
       }, {
         key: "_setupDeviceFeatures",
         value: function _setupDeviceFeatures(event) {
           var _this4 = this;
   
           var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
               previousBreakpoint = event ? event.detail.previousBreakpoint : null;
   
           if (currentBreakpoint === previousBreakpoint) {
             return; // Nothing has changed, no specific setup to do
           }
   
           if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
             if (this.carouselNavScrollSpy) {
               this.carouselNavScrollSpy.destroy();
             }
   
             if (this.productInfoScroller) {
               this.productInfoScroller.destroy();
             }
   
             if (this.productThumbnailsScroller) {
               this.productThumbnailsScroller.destroy();
             }
   
             if (this.productAsideElement) {
               this.productAsideElement.style.minHeight = null;
             } else {
               this.productWrapperElement.style.minHeight = null;
             }
   
             this.productInfoElement.parentNode.style.maxHeight = null;
           } else {
             // 1st: scrollspy for the dots and image
             if (this.slideshowImages && this.slideshowImages.length > 1) {
               var offsetTop = 0;
   
               if (this.options['stackProductImages'] && this.slideshowNavDots) {
                 offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
               }
   
               if (this.options['showThumbnails'] && Responsive.matchesBreakpoint('desk')) {
                 offsetTop = 250;
               }
   
               this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
                 rootMargin: "-".concat(offsetTop, "px 0px 0px 0px")
               });
             }
   
             var productInfoStyles = window.getComputedStyle(this.productInfoElement),
                 productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
                 productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0; // 2nd: making sure to set up enough space in aside part
   
             var calculateMinHeight = function calculateMinHeight() {
               if (_this4.productAsideElement) {
                 _this4.productAsideElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight, "px");
                 _this4.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight = _this4.productAsideElement.offsetTop + _this4.productInfoElement.scrollHeight - productInfoPadding + 'px';
               } else {
                 _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px");
               }
             };
   
             calculateMinHeight(); // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
             // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
             // but I feel it's already good to have a clean fix
   
             if (window.ResizeObserver) {
               this.productInfoResizeObserver = new ResizeObserver(function () {
                 calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
               });
               this.productInfoResizeObserver.observe(this.productInfoElement);
             } // 3rd: let's handle the scroll for the product info
   
   
             this.productInfoScroller = new OverflowScroller(this.productInfoElement); // 4th: let's handle the scroll for the thumbnails
   
             if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
               this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails);
             }
           }
         }
       }]);
   
       return ProductSection;
     }();
   
     var RecentlyViewedProductsSection = /*#__PURE__*/function () {
       function RecentlyViewedProductsSection(container) {
         _classCallCheck(this, RecentlyViewedProductsSection);
   
         this.element = container;
         this.options = JSON.parse(this.element.getAttribute('data-section-settings')); // Setup product item color swatch
   
         new ProductItemColorSwatch(this.element);
   
         this._fetchProducts();
       }
   
       _createClass(RecentlyViewedProductsSection, [{
         key: "onUnload",
         value: function onUnload() {
           if (this.carousel) {
             this.carousel.destroy();
           }
         }
         /**
          * In order to get the products to display, we hit the search template with the given IDS
          */
   
       }, {
         key: "_fetchProducts",
         value: function _fetchProducts() {
           var _this = this;
   
           var queryString = this._getSearchQueryString();
   
           if (queryString === '') {
             return;
           } // If we have a non empty query string we do a search query
   
   
           fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&type=product&q=").concat(queryString), {
             credentials: 'same-origin',
             method: 'GET'
           }).then(function (response) {
             response.text().then(function (content) {
               var tempElement = document.createElement('div');
               tempElement.innerHTML = content; // Set the content
   
               _this.element.innerHTML = tempElement.querySelector('.Section').innerHTML; // Show the section
   
               _this.element.parentNode.style.display = 'block'; // And finally let's create the carousel !
   
               _this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'));
             });
           });
         }
       }, {
         key: "_getSearchQueryString",
         value: function _getSearchQueryString() {
           var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // If we are on a product template, we make sure to remove the main product from the related product
   
           if (items.includes(this.options['productId'])) {
             items.splice(items.indexOf(this.options['productId']), 1);
           }
   
           return items.map(function (item) {
             return 'id:' + item;
           }).join(' OR ');
         }
       }]);
   
       return RecentlyViewedProductsSection;
     }();
   
     /**
      * This code is extracted from Slate
      */
   
     var SectionContainer = /*#__PURE__*/function () {
       function SectionContainer() {
         _classCallCheck(this, SectionContainer);
   
         this.constructors = [];
         this.instances = [];
   
         this._attachListeners();
       }
   
       _createClass(SectionContainer, [{
         key: "_attachListeners",
         value: function _attachListeners() {
           document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
           document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
           document.addEventListener('shopify:section:select', this._onSelect.bind(this));
           document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
           document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
           document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
           document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
         }
       }, {
         key: "register",
         value: function register(type, constructor) {
           var _this = this;
   
           this.constructors[type] = constructor;
           Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
             _this._createInstance(container, constructor);
           });
         }
         /**
          * Return an object from an array of objects that matches the provided key and value
          */
   
       }, {
         key: "_findInstance",
         value: function _findInstance(array, key, value) {
           for (var i = 0; i < array.length; i++) {
             if (array[i][key] === value) {
               return array[i];
             }
           }
         }
         /**
          * Remove an object from an array of objects by matching the provided key and value
          */
   
       }, {
         key: "_removeInstance",
         value: function _removeInstance(array, key, value) {
           var i = array.length;
   
           while (i--) {
             if (array[i][key] === value) {
               array.splice(i, 1);
               break;
             }
           }
   
           return array;
         }
       }, {
         key: "_onSectionLoad",
         value: function _onSectionLoad(event) {
           var container = event.target.querySelector('[data-section-id]');
   
           if (container) {
             this._createInstance(container);
           }
         }
       }, {
         key: "_onSectionUnload",
         value: function _onSectionUnload(event) {
           var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
   
           if (!instance) {
             return;
           }
   
           if (typeof instance.onUnload === 'function') {
             instance.onUnload(event);
           }
   
           this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
         }
       }, {
         key: "_onSelect",
         value: function _onSelect(event) {
           var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
   
           if (instance && typeof instance.onSelect === 'function') {
             instance.onSelect(event);
           }
         }
       }, {
         key: "_onDeselect",
         value: function _onDeselect(event) {
           var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
   
           if (instance && typeof instance.onDeselect === 'function') {
             instance.onDeselect(event);
           }
         }
       }, {
         key: "_onReorder",
         value: function _onReorder(event) {
           var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
   
           if (instance && typeof instance.onReorder === 'function') {
             instance.onReorder(event);
           }
         }
       }, {
         key: "_onBlockSelect",
         value: function _onBlockSelect(event) {
           var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
   
           if (instance && typeof instance.onBlockSelect === 'function') {
             instance.onBlockSelect(event);
           }
         }
       }, {
         key: "_onBlockDeselect",
         value: function _onBlockDeselect(event) {
           var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
   
           if (instance && typeof instance.onBlockDeselect === 'function') {
             instance.onBlockDeselect(event);
           }
         }
       }, {
         key: "_createInstance",
         value: function _createInstance(container, constructor) {
           var id = container.getAttribute('data-section-id'),
               type = container.getAttribute('data-section-type');
           constructor = constructor || this.constructors[type];
   
           if (typeof constructor === 'undefined') {
             return;
           }
   
           var instance = Object.assign(new constructor(container), {
             id: id,
             type: type,
             container: container
           });
           this.instances.push(instance);
         }
       }]);
   
       return SectionContainer;
     }();
   
     var ShopNowSection = /*#__PURE__*/function () {
       function ShopNowSection(container) {
         _classCallCheck(this, ShopNowSection);
   
         this.element = container;
         this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]')); // Setup product item color swatch
   
         new ProductItemColorSwatch(this.element);
       }
   
       _createClass(ShopNowSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.carousel.destroy();
         }
       }]);
   
       return ShopNowSection;
     }();
   
     var ShopTheLookSection = /*#__PURE__*/function () {
       function ShopTheLookSection(container) {
         _classCallCheck(this, ShopTheLookSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.usePocketMode = Responsive.matchesBreakpoint('pocket');
         this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]');
   
         this._createOuterCarousel();
   
         this._createPocketPopovers();
   
         this._attachListeners();
       }
   
       _createClass(ShopTheLookSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.outerCarousel.destroy();
           this.innerCarousels.forEach(function (item) {
             item.forEach(function (innerItem) {
               return innerItem.destroy();
             });
           });
           this.popovers.forEach(function (item) {
             return item.destroy();
           });
           this.delegateElement.off();
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           this.outerCarousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
         }
         /**
          * Attach all the listeners
          */
   
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '.ShopTheLook__Dot', this._onDotClicked.bind(this));
         }
         /**
          * There is one mobile and tablet popover per look, so we pre-create them
          */
   
       }, {
         key: "_createPocketPopovers",
         value: function _createPocketPopovers() {
           var _this = this;
   
           this.popovers = [];
           Dom.nodeListToArray(this.element.querySelectorAll('.Popover')).forEach(function (popover) {
             _this.popovers.push(new Popover(popover, {
               activator: _this.pocketActivatorButton,
               showOverlay: false,
               onOpen: _this._openPocketZoom.bind(_this),
               onClose: _this._closePocketZoom.bind(_this)
             }));
           });
         }
         /**
          * The outer carousel is the carousel that holds the main one (all the looks). Internally, it also creates
          * a sub-carousel for each inner carousel
          */
   
       }, {
         key: "_createOuterCarousel",
         value: function _createOuterCarousel() {
           var _this2 = this;
   
           this.outerCarousel = new Carousel(this.element.querySelector('.ShopTheLook'), {
             onSelect: this._onLookChanged.bind(this)
           });
           this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length);
   
           for (var i = 0; i !== this.innerCarousels.length; ++i) {
             this.innerCarousels[i] = [];
           } // We need to create ALL the carousels (both in desktop and mobile). Fortunately Flickity is quite fast, but
           // we have no other choices if we want to have proper animations everywhere.
   
   
           Dom.nodeListToArray(this.element.querySelectorAll('.ShopTheLook__ProductList')).forEach(function (item) {
             var lookIndex = parseInt(item.getAttribute('data-look-index'));
   
             _this2.innerCarousels[lookIndex].push(new Carousel(item, {
               onSelect: _this2._onProductChanged.bind(_this2)
             })); // By default, Flickity will append the carousel, hence making the "ViewButton" before the carousel. We need to manipulate it to move it after
   
   
             item.insertBefore(item.querySelector('.flickity-viewport'), item.querySelector('.ShopTheLook__ViewButton'));
           });
           this.outerCarousel.resize(); // Needed in case the products are taller than the image
         }
         /**
          * This function is called whenever the main look has changed, so that we can modify the popover activator
          */
   
       }, {
         key: "_onLookChanged",
         value: function _onLookChanged(selectedIndex, selectedCell) {
           // Then, we update the mobile button so that it opens the correct block
           this.pocketActivatorButton.setAttribute('aria-controls', "".concat(selectedCell.getAttribute('id'), "-popover"));
         }
         /**
          * This function is called whenever a product is changed in the list for a given look. This allows to focus the main dot
          */
   
       }, {
         key: "_onProductChanged",
         value: function _onProductChanged(selectedIndex, selectedCell) {
           var lookItem = this.outerCarousel.getSelectedCell(),
               activeDot = null;
           Dom.nodeListToArray(lookItem.querySelectorAll('.ShopTheLook__Dot')).forEach(function (dot, index) {
             dot.classList.remove('is-active'); // IE11 and lower does not support "toggle" with second parameter :(
   
             if (index === selectedIndex) {
               dot.classList.add('is-active');
               activeDot = dot;
             }
           }); // Update the link to the product (if using the desktop view)
   
           lookItem.querySelector('.ShopTheLook__ViewButton').setAttribute('href', selectedCell.getAttribute('data-product-url')); // We trigger an event so that when the dot change we can recalculate the position
   
           lookItem.dispatchEvent(new CustomEvent('product:changed', {
             detail: {
               dot: activeDot
             }
           }));
         }
         /**
          * This function is called whenever you explicitly click on a dot.
          *
          * On mobile and tablet, this must open the appropriate popver
          */
   
       }, {
         key: "_onDotClicked",
         value: function _onDotClicked(event, target) {
           var shouldAnimateCarousel = false,
               hasOnePopoverOpen = false,
               lookIndex = this.outerCarousel.getSelectedIndex();
           this.popovers.forEach(function (item) {
             if (item.isOpen) {
               hasOnePopoverOpen = true;
               shouldAnimateCarousel = true;
             }
           }); // Each inner carousel has a mobile AND desktop version, so we change both
   
           this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
             innerCarousel.selectCell(parseInt(target.getAttribute('data-product-index')) - 1, false, shouldAnimateCarousel);
           });
   
           if (this.usePocketMode && !hasOnePopoverOpen) {
             this.popovers[lookIndex].open();
           }
         }
         /**
          * This is called when, on mobile, the popover is open. We must open the image in full resolution
          */
   
       }, {
         key: "_openPocketZoom",
         value: function _openPocketZoom(popover) {
           var _this3 = this;
   
           this._calculateImageTransform(popover);
   
           fastdom.mutate(function () {
             // We need to animate the header to avoid a slightly ugly effect if image overlap the header
             document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(-100%); transition: transform 0.3s ease-in-out;';
   
             _this3.outerCarousel.flickityInstance.unbindDrag(); // Prevent changing the active slide
   
   
             _this3.outerCarousel.flickityInstance.element.classList.add('is-zoomed');
   
             _this3.outerCarousel.getSelectedCell().classList.add('is-expanded');
           });
         }
         /**
          * When the mobile zoom is open, and whenever the active dot changes, we need to potentially re-calculate the transform
          */
   
       }, {
         key: "_calculateImageTransform",
         value: function _calculateImageTransform(openPopover) {
           var _this4 = this;
   
           var selectedCell = this.outerCarousel.getSelectedCell();
           fastdom.measure(function () {
             // We first need to compute the initial transform and scale factor
             var scale = window.innerWidth / (selectedCell.offsetWidth - parseInt(window.getComputedStyle(selectedCell).paddingLeft) * 2),
                 heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
                 // Height of the selected cell once the scale transform is applied
             hiddenImageHeight = Math.round(Math.max(heightAfterScale - (window.innerHeight - openPopover.element.offsetHeight), 0)),
                 // Part of image that is below popover
             visibleImageHeight = heightAfterScale - hiddenImageHeight,
                 // Part of the image that is visible in the viewport
             minTranslateY = Math.round(-(selectedCell.getBoundingClientRect().top - (heightAfterScale - selectedCell.offsetHeight) / 2)),
                 // The minimum translate Y transform allowed so that image is visible
             maxTranslateY = Math.round(minTranslateY - hiddenImageHeight); // The maximum translate Y transform allowed so that image is visible
   
             _this4._calculateTransformForDotListener = function (event) {
               var dotTopPosition = Math.round((event.detail.dot.offsetTop + event.detail.dot.offsetHeight / 2) * scale),
                   offsetToMove = Math.round(dotTopPosition - visibleImageHeight / 2),
                   translateY = Math.min(Math.max(minTranslateY - offsetToMove, maxTranslateY), minTranslateY);
               fastdom.mutate(function () {
                 _this4.outerCarousel.flickityInstance.viewport.style.transform = "translate3d(0, ".concat(Math.round(translateY), "px, 0) scale(").concat(scale, ")");
               });
             }; // We manually generate an event the first time to trigger the positioning
   
   
             selectedCell.addEventListener('product:changed', _this4._calculateTransformForDotListener);
             selectedCell.dispatchEvent(new CustomEvent('product:changed', {
               detail: {
                 dot: selectedCell.querySelector('.ShopTheLook__Dot.is-active')
               }
             }));
           });
         }
         /**
          * Close the mobile zoom (which close the popover and remove any transform
          */
   
       }, {
         key: "_closePocketZoom",
         value: function _closePocketZoom() {
           var _this5 = this;
   
           var selectedCell = this.outerCarousel.getSelectedCell();
           selectedCell.removeEventListener('product:changed', this._calculateTransformForDotListener);
           fastdom.mutate(function () {
             document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;';
   
             _this5.outerCarousel.flickityInstance.bindDrag();
   
             _this5.outerCarousel.flickityInstance.element.classList.remove('is-zoomed');
   
             _this5.outerCarousel.flickityInstance.viewport.style.transform = null;
             selectedCell.classList.remove('is-expanded');
           });
         }
       }]);
   
       return ShopTheLookSection;
     }();
   
     var SidebarMenuSection = /*#__PURE__*/function () {
       function SidebarMenuSection(container) {
         _classCallCheck(this, SidebarMenuSection);
   
         this.element = container;
         this.sidebarDrawer = new Drawer(container);
       }
   
       _createClass(SidebarMenuSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.sidebarDrawer.destroy();
         }
       }, {
         key: "onSelect",
         value: function onSelect() {
           this.sidebarDrawer.open();
         }
       }, {
         key: "onDeselect",
         value: function onDeselect() {
           this.sidebarDrawer.close();
         }
       }]);
   
       return SidebarMenuSection;
     }();
   
     var SlideshowSection = /*#__PURE__*/function () {
       function SlideshowSection(container) {
         _classCallCheck(this, SlideshowSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.slideshow = new Carousel(this.element.querySelector('[data-flickity-config]'), {
           onSelect: this._onSlideChanged.bind(this)
         });
         this.selectedSlide = null;
         this.shouldAnimate = true;
         this.timeline = new TimelineLite({
           delay: window.theme.showPageTransition ? 0.5 : 0
         });
   
         if (this.slideshow.flickityInstance.cells.length > 0) {
           this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
         }
   
         this._attachListeners();
       }
   
       _createClass(SlideshowSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.slideshow.destroy();
           this.timeline.kill();
           this.delegateElement.off();
           document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           if (this.slideshow.flickityInstance.options.autoPlay) {
             this.slideshow.flickityInstance.stopPlayer();
           }
   
           this.shouldAnimate = !event.detail.load;
           this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
         }
       }, {
         key: "onBlockDeselect",
         value: function onBlockDeselect() {
           this.shouldAnimate = true;
   
           if (this.slideshow.flickityInstance.options.autoPlay) {
             this.slideshow.flickityInstance.playPlayer();
           }
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
           this.delegateElement.on('mouseenter', '.Button', this._pauseSlideshow.bind(this), true);
           this.delegateElement.on('mouseleave', '.Button', this._resumeSlideshow.bind(this), true);
           document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
         }
       }, {
         key: "_pauseSlideshow",
         value: function _pauseSlideshow() {
           if (this.slideshow.flickityInstance.options.autoPlay) {
             this.slideshow.flickityInstance.pausePlayer();
           }
         }
       }, {
         key: "_resumeSlideshow",
         value: function _resumeSlideshow() {
           if (this.slideshow.flickityInstance.options.autoPlay) {
             this.slideshow.flickityInstance.unpausePlayer();
           }
         }
       }, {
         key: "_onSlideChanged",
         value: function _onSlideChanged(index, element) {
           this._transitionToSlide(element);
         }
       }, {
         key: "_transitionToSlide",
         value: function _transitionToSlide(slide) {
           var _this = this;
   
           this.timeline.clear(); // First, we check if there is a previous slide selected, if that's the case
   
           if (this.selectedSlide) {
             this._slideLeave(this.selectedSlide);
   
             this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
           } // We get the next slide (if any) to preload it
   
   
           this._lazyLoadNextImage();
   
           this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
             autoAlpha: 0
           }, {
             autoAlpha: 1,
             ease: Cubic.easeInOut
           }, 'enter'); // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned
   
           if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
             this.slideshow.flickityInstance.pausePlayer();
           }
   
           Dom.nodeListToArray(slide.querySelectorAll('.Slideshow__Image')).forEach(function (image) {
             if (image.classList.contains('Image--lazyLoading') || image.classList.contains('Image--lazyLoad')) {
               image.addEventListener('lazyloaded', _this._slideEnter.bind(_this, slide));
             } else {
               _this._slideEnter(slide);
             }
           });
           this.selectedSlide = slide;
         }
       }, {
         key: "_slideLeave",
         value: function _slideLeave(slide) {
           var content = slide.querySelector('.SectionHeader'),
               buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
           this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, {
             autoAlpha: 1
           }, {
             autoAlpha: 0,
             ease: Cubic.easeInOut,
             delay: this.shouldAnimate ? 0.35 : 0
           });
   
           if (content) {
             this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, {
               autoAlpha: 1,
               y: 0
             }, {
               autoAlpha: 0,
               y: 20,
               ease: Cubic.easeIn
             }, 0);
           }
   
           if (buttonWrapper) {
             this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, {
               autoAlpha: 1,
               y: 0
             }, {
               autoAlpha: 0,
               y: 10,
               ease: Cubic.easeIn
             }, 0);
           }
         }
       }, {
         key: "_slideEnter",
         value: function _slideEnter(slide) {
           var images = slide.querySelectorAll('.Slideshow__Image'),
               content = slide.querySelector('.SectionHeader'),
               buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
   
           if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
             this.slideshow.flickityInstance.unpausePlayer();
           }
   
           if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
             if (window.theme.showImageZooming) {
               this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
                 opacity: 0,
                 scale: 1.2
               }, {
                 opacity: 1,
                 scale: 1,
                 ease: Quad.easeOut
               }, 'enter');
             } else {
               this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
                 opacity: 0
               }, {
                 opacity: 1,
                 ease: Quad.easeOut
               }, 'enter');
             }
           }
   
           if (content) {
             this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, {
               autoAlpha: 0,
               y: 30
             }, {
               autoAlpha: 1,
               y: 0,
               delay: this.shouldAnimate ? 0.8 : 0,
               ease: Cubic.easeOut
             }, 'enter');
           }
   
           if (buttonWrapper) {
             this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, {
               autoAlpha: 0,
               y: 20
             }, {
               autoAlpha: 1,
               y: 0,
               delay: this.shouldAnimate ? 0.8 : 0,
               ease: Cubic.easeOut
             }, 'enter');
           }
         }
       }, {
         key: "_lazyLoadNextImage",
         value: function _lazyLoadNextImage() {
           var currentIndex = this.slideshow.flickityInstance.selectedIndex,
               breakpoint = Responsive.getCurrentBreakpoint();
   
           if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
             var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
                 imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll('.Slideshow__ImageContainer')),
                 imageToReveal = null;
   
             if (breakpoint === 'phone') {
               imageToReveal = imageContainers[0];
             } else {
               imageToReveal = imageContainers[1];
             }
   
             if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('Image--lazyLoad')) {
               lazySizes.loader.unveil(imageToReveal.firstElementChild);
             }
           }
         }
       }, {
         key: "_onBreakpointChanged",
         value: function _onBreakpointChanged(event) {
           if (event.detail.previousBreakpoint === 'phone' && event.detail.currentBreakpoint !== 'phone' || event.detail.previousBreakpoint !== 'phone' && event.detail.currentBreakpoint === 'phone') {
             this.selectedSlide = null;
   
             this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
           }
         }
       }]);
   
       return SlideshowSection;
     }();
   
     var TestimonialsSection = /*#__PURE__*/function () {
       function TestimonialsSection(container) {
         _classCallCheck(this, TestimonialsSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.TestimonialNav__Item'));
         this.carousel = new Carousel(this.element.querySelector('.TestimonialList'), {
           onSelect: this._testimonialChanged.bind(this)
         });
   
         this._attachListeners();
       }
   
       _createClass(TestimonialsSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.carousel.destroy();
           this.delegateElement.off('click');
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true);
         }
       }, {
         key: "onBlockDeselect",
         value: function onBlockDeselect() {
           this.carousel.unpausePlayer();
         }
       }, {
         key: "_testimonialClicked",
         value: function _testimonialClicked(event, target) {
           this.carousel.pausePlayer();
           this.carousel.selectCell(parseInt(target.getAttribute('data-index')));
           this.carousel.unpausePlayer();
         }
       }, {
         key: "_testimonialChanged",
         value: function _testimonialChanged(newIndex) {
           this.navItems.forEach(function (item, index) {
             item.classList.remove('is-selected'); // IE11 and lower does not support classList.toggle
   
             if (newIndex === index) {
               item.classList.add('is-selected');
             }
           });
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '.TestimonialNav__Item', this._testimonialClicked.bind(this));
         }
       }]);
   
       return TestimonialsSection;
     }();
   
     var TimelineSection = /*#__PURE__*/function () {
       function TimelineSection(container) {
         _classCallCheck(this, TimelineSection);
   
         this.element = container;
         this.delegateElement = new domDelegate.Delegate(this.element);
         this.items = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__Item'));
         this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__NavItem'));
   
         this._attachListeners();
       }
   
       _createClass(TimelineSection, [{
         key: "onUnload",
         value: function onUnload() {
           this.delegateElement.off('click');
         }
       }, {
         key: "onBlockSelect",
         value: function onBlockSelect(event) {
           this.navItems[parseInt(event.target.getAttribute('data-index'))].click(); // Simulate a click on the given nav item
         }
       }, {
         key: "_attachListeners",
         value: function _attachListeners() {
           this.delegateElement.on('click', '.Timeline__NavItem', this._clickOnNavItem.bind(this));
         }
       }, {
         key: "_clickOnNavItem",
         value: function _clickOnNavItem(event, target) {
           var newItem = this.items[parseInt(target.getAttribute('data-index'))];
   
           if (newItem.classList.contains('is-selected')) {
             return;
           }
   
           var isContentLarger = false,
               navWrapper = target.parentNode,
               scrollableOffset = 0;
           fastdom.measure(function () {
             var scrollableWidth = navWrapper.scrollWidth,
                 visibleWidth = navWrapper.offsetWidth;
             isContentLarger = visibleWidth < scrollableWidth;
   
             if (isContentLarger) {
               var beginBound = target.offsetLeft,
                   endBound = beginBound + target.offsetWidth,
                   closerToLeft = beginBound <= visibleWidth - endBound;
               var itemToUse = null;
   
               if (closerToLeft) {
                 // If closer to left, we try to make the previous item visible (if possible)
                 itemToUse = target.previousElementSibling || target;
               } else {
                 // If closer to right, we try to make the next item visible (if possible)
                 itemToUse = target.nextElementSibling || target;
               }
   
               var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
                   itemEndBound = itemBeginBound + itemToUse.offsetWidth;
   
               if (itemEndBound > visibleWidth) {
                 // Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
                 scrollableOffset = itemEndBound - visibleWidth;
               } else if (itemBeginBound < 0) {
                 // Element is not visible from the left, so we simply use the opposite of the negative offset
                 scrollableOffset = itemBeginBound;
               }
             }
           });
           fastdom.mutate(function () {
             if (isContentLarger) {
               navWrapper.scrollBy({
                 behavior: 'smooth',
                 left: scrollableOffset
               });
             } // First we set the class on the selected item and remove it on siblings
   
   
             target.classList.add('is-selected');
             Dom.getSiblings(target, '.is-selected').forEach(function (item) {
               item.classList.remove('is-selected');
             }); // Then we slide to the appropriate element
   
             newItem.classList.add('is-selected');
             Dom.getSiblings(newItem, '.is-selected').forEach(function (item) {
               item.classList.remove('is-selected');
             });
           });
         }
       }]);
   
       return TimelineSection;
     }();
   
     var PriceRange = /*#__PURE__*/function (_HTMLElement) {
       _inherits(PriceRange, _HTMLElement);
   
       var _super = _createSuper(PriceRange);
   
       function PriceRange() {
         _classCallCheck(this, PriceRange);
   
         return _super.apply(this, arguments);
       }
   
       _createClass(PriceRange, [{
         key: "connectedCallback",
         value: function connectedCallback() {
           var _this = this;
   
           this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
           this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
           this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
           this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience
   
           this.textInputLowerBound.addEventListener('focus', function () {
             return _this.textInputLowerBound.select();
           });
           this.textInputHigherBound.addEventListener('focus', function () {
             return _this.textInputHigherBound.select();
           }); // Keep in sync the range with the text input fields
   
           this.textInputLowerBound.addEventListener('change', function (event) {
             event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
             _this.rangeLowerBound.value = event.target.value;
   
             _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
           });
           this.textInputHigherBound.addEventListener('change', function (event) {
             event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
             _this.rangeHigherBound.value = event.target.value;
   
             _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
           });
           this.rangeLowerBound.addEventListener('change', function (event) {
             _this.textInputLowerBound.value = event.target.value;
   
             _this.textInputLowerBound.dispatchEvent(new Event('change', {
               bubbles: true
             }));
           });
           this.rangeHigherBound.addEventListener('change', function (event) {
             _this.textInputHigherBound.value = event.target.value;
   
             _this.textInputHigherBound.dispatchEvent(new Event('change', {
               bubbles: true
             }));
           }); // We also have to bound the two range sliders
   
           this.rangeLowerBound.addEventListener('input', function (event) {
             event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value
   
             event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
             _this.textInputLowerBound.value = event.target.value;
           });
           this.rangeHigherBound.addEventListener('input', function (event) {
             event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value
   
             event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
             _this.textInputHigherBound.value = event.target.value;
           });
         }
       }]);
   
       return PriceRange;
     }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
     window.customElements.define('price-range', PriceRange);
   
     (function () {
       // First, we register all plugins that are used for all pages
       new Collapsible();
       new Modal();
       new Responsive();
   
       if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
         new LoadingBar();
       }
   
       var sections = new SectionContainer();
       sections.register('header', HeaderSection);
       sections.register('footer', FooterSection);
       sections.register('sidebar-menu', SidebarMenuSection);
       sections.register('cart', CartSection);
       sections.register('newsletter-popup', NewsletterPopupSection); // Sections used on index
   
       sections.register('slideshow', SlideshowSection);
       sections.register('collection-list', CollectionListSection);
       sections.register('article-list', ArticleList);
       sections.register('featured-product', FeaturedProductSection);
       sections.register('image-with-text-block', ImageWithTextBlockSection);
       sections.register('timeline', TimelineSection);
       sections.register('map', MapSection);
       sections.register('featured-collections', FeaturedCollectionsSection);
       sections.register('shop-the-look', ShopTheLookSection);
       sections.register('testimonials', TestimonialsSection);
       sections.register('background-video', BackgroundVideoSection); // Sections used on product page
   
       sections.register('product', ProductSection);
       sections.register('product-recommendations', ProductRecommendationsSection); // Sections used on collection page
   
       sections.register('collection', CollectionSection); // Sections used on blog page
   
       sections.register('article-list', ArticleList); // Sections used on article page
   
       sections.register('article', ArticleSection); // Sections used on content pages
   
       sections.register('faq', FaqSection); // Sections used on login page
   
       sections.register('login', LoginSection); // Sections used on addresses page
   
       sections.register('addresses', AddressesSection); // Sections used on gift card page
   
       sections.register('gift-card', GiftCardSection); // Sections used on different pages
   
       sections.register('recently-viewed-products', RecentlyViewedProductsSection);
       sections.register('shop-now', ShopNowSection);
       /**
        * ----------------------------------------------------------------------------
        * FLICKITY
        *
        * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
        * event.preventDefault to be called on dynamically added listeners, which is
        * what Flickity is using.
        *
        * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
        * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
        * and that we are using here as a temporary workaround, that should be removed
        * once the bug is fixed on iOS
        * ----------------------------------------------------------------------------
        */
   
       Flickity.defaults.dragThreshold = 7;
   
       (function () {
         var touchingCarousel = false,
             touchStartCoords;
         document.body.addEventListener('touchstart', function (e) {
           if (e.target.closest('.flickity-slider')) {
             touchingCarousel = true;
           } else {
             touchingCarousel = false;
             return;
           }
   
           touchStartCoords = {
             x: e.touches[0].pageX,
             y: e.touches[0].pageY
           };
         });
         document.body.addEventListener('touchmove', function (e) {
           if (!(touchingCarousel && e.cancelable)) {
             return;
           }
   
           var moveVector = {
             x: e.touches[0].pageX - touchStartCoords.x,
             y: e.touches[0].pageY - touchStartCoords.y
           };
           if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
         }, {
           passive: false
         });
       })();
       /**
        * ----------------------------------------------------------------------------
        * FLICKITY 2
        *
        * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
        * the bottom bar as soon as you do even a minor diagonal movement. This is causing
        * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
        * patch Flickity to make sure they re-size the carousel only when the width is
        * changed, by ignoring the height
        * ----------------------------------------------------------------------------
        */
   
   
       (function () {
         if (window.Flickity) {
           var originalResizeMethod = window.Flickity.prototype.resize,
               lastWidth = window.innerWidth;
   
           window.Flickity.prototype.resize = function () {
             if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
               return;
             }
   
             lastWidth = window.innerWidth;
             originalResizeMethod.apply(this, arguments); // Call original method
           };
         }
       })();
       /**
        * ----------------------------------------------------------------------------
        * RTE
        * ----------------------------------------------------------------------------
        */
   
   
       (function () {
         // We wrap each RTE table by a specific class to allow wrapping
         Dom.nodeListToArray(document.querySelectorAll('.Rte table')).forEach(function (table) {
           table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
         });
         Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
           // We scope the wrapping only for YouTube and Vimeo
           if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
             iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
             // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
   
             iframe.src = iframe.src;
           }
         });
       })();
       /**
        * ----------------------------------------------------------------------------
        * UTILS
        * ----------------------------------------------------------------------------
        */
   
   
       (function () {
         var documentDelegate = new domDelegate.Delegate(document.body),
             announcementBar = document.querySelector('.AnnouncementBar');
         documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
           var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');
   
           if (selector === '#' || selector === '#main') {
             return;
           }
   
           var element = document.querySelector(selector),
               offset = parseInt(target.getAttribute('data-offset') || 0);
   
           if (announcementBar) {
             offset -= announcementBar.clientHeight;
           }
   
           if (target.hasAttribute('data-focus-on-click')) {
             var prevScrollY = window.pageYOffset;
             element.focus({
               preventScroll: true
             }); // hack to fix scroll jump after focus
   
             if (window.pageYOffset !== prevScrollY) {
               window.scrollTo(window.pageXOffset, prevScrollY);
             }
   
             element.focus();
           }
   
           window.scrollTo({
             behavior: 'smooth',
             top: element.offsetTop - offset
           });
           event.preventDefault();
         });
       })();
   
       (function () {
         var windowWidth = window.innerWidth,
             headerSection = document.getElementById('shopify-section-header');
         window.addEventListener('resize', function () {
           var newWidth = -1;
           fastdom.measure(function () {
             newWidth = window.innerWidth;
           });
           fastdom.mutate(function () {
             if (newWidth === windowWidth) {
               return;
             }
   
             windowWidth = newWidth;
             document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
   
             if (headerSection) {
               document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
             }
           });
         });
       })();
   
       (function () {
         function handleFirstTab(event) {
           if (event.keyCode === 9) {
             document.body.classList.add('is-tabbing');
             window.removeEventListener('keydown', handleFirstTab);
           }
         }
   
         window.addEventListener('keydown', handleFirstTab);
       })();

       (function () {
         function fixInstagramFrame(iframe) {
           if (!iframe.getAttribute('title')) {
             iframe.setAttribute('title', 'Instagram post');
           }
           iframe.removeAttribute('allowtransparency');
           iframe.removeAttribute('frameborder');
           iframe.removeAttribute('scrolling');
         }
         function fixAllInstagramFrames(root) {
           root.querySelectorAll('iframe.instagram-media').forEach(fixInstagramFrame);
         }
         var observer = new MutationObserver(function (mutations) {
           mutations.forEach(function (mutation) {
             mutation.addedNodes.forEach(function (node) {
               if (node.nodeType !== 1) return;
               if (node.matches('iframe.instagram-media')) fixInstagramFrame(node);
               fixAllInstagramFrames(node);
             });
           });
         });
         fixAllInstagramFrames(document);
         observer.observe(document.body, { childList: true, subtree: true });
       })();

       /**
        * ----------------------------------------------------------------------------
        * ANIMATION
        *
        * Important: this has to be at the very end of the file
        * ----------------------------------------------------------------------------
        */
   
   
       if (window.theme.showPageTransition) {
         PageTransition.getInstance();
       }
     })();
   
   })));
   

